var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function getAugmentedNamespace(n) {
  if (Object.prototype.hasOwnProperty.call(n, '__esModule')) return n;
  var f = n.default;
	if (typeof f == "function") {
		var a = function a () {
			var isInstance = false;
      try {
        isInstance = this instanceof a;
      } catch {}
			if (isInstance) {
        return Reflect.construct(f, arguments, this.constructor);
			}
			return f.apply(this, arguments);
		};
		a.prototype = f.prototype;
  } else a = {};
  Object.defineProperty(a, '__esModule', {value: true});
	Object.keys(n).forEach(function (k) {
		var d = Object.getOwnPropertyDescriptor(n, k);
		Object.defineProperty(a, k, d.get ? d : {
			enumerable: true,
			get: function () {
				return n[k];
			}
		});
	});
	return a;
}

var build = {};

var main = {};

var hasRequiredMain;

function requireMain () {
	if (hasRequiredMain) return main;
	hasRequiredMain = 1;
	Object.defineProperty(main, "__esModule", { value: true });
	main.Err = main.Ok = void 0;
	// --- Note ---
	// `throw` is a reserved keyword
	function throwErr(message) {
	    if (!this.ok) {
	        if (typeof this.error === "string" || typeof this.error === "undefined") {
	            var defaultMessage = "There was an error! No specific error message was provided.";
	            throw new Error(message || this.error || defaultMessage);
	        }
	        if (message) {
	            this.error.message = message;
	        }
	        throw this.error;
	    }
	    return this.data;
	}
	// --- Note ---
	// `else` is a reserved keyword
	function elseDo(callback) {
	    if (this.ok) {
	        return this.data;
	    }
	    // TODO:
	    // - Tackle the problem of callback return type not being enforced when using `void` | `undefined` as `T`
	    // - In the same situation `or` works well
	    return callback(this.error);
	}
	function or(orValue) {
	    if (this.ok) {
	        return this.data;
	    }
	    return orValue;
	}
	function and(callback) {
	    if (this.ok) {
	        callback(this.data);
	    }
	    return this;
	}
	function Ok(data) {
	    return { ok: true, data: data, throw: throwErr, else: elseDo, or: or, and: and };
	}
	main.Ok = Ok;
	function Err(error) {
	    return { ok: false, error: error, throw: throwErr, else: elseDo, or: or, and: and };
	}
	main.Err = Err;
	
	return main;
}

var hasRequiredBuild;

function requireBuild () {
	if (hasRequiredBuild) return build;
	hasRequiredBuild = 1;
	(function (exports) {
		Object.defineProperty(exports, "__esModule", { value: true });
		exports.Err = exports.Ok = void 0;
		var main_1 = requireMain();
		Object.defineProperty(exports, "Ok", { enumerable: true, get: function () { return main_1.Ok; } });
		Object.defineProperty(exports, "Err", { enumerable: true, get: function () { return main_1.Err; } });
		
	} (build));
	return build;
}

var buildExports = requireBuild();

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol, Iterator */


function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

class EventManager {
    addEventHandler(eventType, callback) {
        if (!this.eventHandlers) {
            this.eventHandlers = new Map();
        }
        this.eventHandlers.set(eventType, callback);
    }
    fireEvent(eventType, data) {
        var _a;
        const eventHandler = (_a = this.eventHandlers) === null || _a === void 0 ? void 0 : _a.get(eventType);
        if (eventHandler && data) {
            eventHandler(data);
        }
    }
}

/**
 * @readonly
 * @enum {string} an Enum containing all possible variants of event types
 * */
var EventType;
(function (EventType) {
    EventType["Evaluation"] = "evaluation";
    EventType["ConfigurationUpdate"] = "configurationUpdate";
})(EventType || (EventType = {}));

const DEFAULT_DATA_FILE_CONFIGURATION = {
    customData: [],
    featureFlags: [],
    configuration: {
        realTimeUpdate: false,
        consentType: "NOT_REQUIRED" /* ConsentType.NotRequired */,
        dataApiDomain: 'data.kameleoon.io',
        consentOptOutBehavior: "PARTIALLY_BLOCK" /* ConsentBlockingBehaviour.PartiallyBlocked */,
    },
};

/**
 * Enumeration of log levels.
 */
var LogLevel;
(function (LogLevel) {
    LogLevel[LogLevel["NONE"] = 0] = "NONE";
    LogLevel[LogLevel["ERROR"] = 1] = "ERROR";
    LogLevel[LogLevel["WARNING"] = 2] = "WARNING";
    LogLevel[LogLevel["INFO"] = 3] = "INFO";
    LogLevel[LogLevel["DEBUG"] = 4] = "DEBUG";
})(LogLevel || (LogLevel = {}));
/**
 * Mapping of log levels to their string representations.
 */
const LOG_LEVEL_NAMES = {
    [LogLevel.NONE]: 'NONE',
    [LogLevel.ERROR]: 'ERROR',
    [LogLevel.WARNING]: 'WARNING',
    [LogLevel.INFO]: 'INFO',
    [LogLevel.DEBUG]: 'DEBUG',
};

/**
 * A simple implementation of a logger that prints log messages to the console. This logger
 * implements the {@code IExternalLogger} interface.
 */
class DefaultLogger {
    /**
     * @method log - logs a message at the specified log level.
     *
     * @param {LogLevel} level - the log level
     * @param {string} message - the log message
     */
    log(level, message) {
        switch (level) {
            case LogLevel.DEBUG:
                console.debug(message);
                break;
            case LogLevel.INFO:
                console.info(message);
                break;
            case LogLevel.WARNING:
                console.warn(message);
                break;
            case LogLevel.ERROR:
                console.error(message);
                break;
        }
    }
}

const replacer = (key, value) => {
    if (key === 'credentials') {
        return {
            clientId: `****`,
            clientSecret: `****`,
        };
    }
    if (value instanceof Map) {
        return Array.from(value.entries());
    }
    return value;
};
function template(strings, keys) {
    let res = '';
    if (keys) {
        for (let i = 0; i < keys.length; i++) {
            let key = keys[i];
            if (typeof key === 'object') {
                try {
                    res += strings[i] + JSON.stringify(key, replacer);
                }
                catch (error) {
                    res += strings[i] + "{object}";
                }
            }
            else if (typeof key === 'string') {
                res += strings[i] + "'" + key + "'";
            }
            else {
                res += strings[i] + key;
            }
        }
    }
    res += strings[strings.length - 1];
    return res;
}
class KameleoonLogger {
    static setLogger(logger) {
        KameleoonLogger.logger = logger;
    }
    static setLogLevel(logLevel) {
        KameleoonLogger.logLevel = logLevel;
    }
    static log({ level, strings, keys }) {
        if (!KameleoonLogger.checkLevel(level))
            return;
        let message;
        if (typeof strings === 'string') {
            message = strings;
        }
        else if (typeof strings === 'function') {
            try {
                message = strings();
            }
            catch (error) {
                message = 'Failed to log message';
            }
        }
        else {
            message = template(strings, keys);
        }
        KameleoonLogger.writeMessage(level, message);
    }
    static info(strings, ...keys) {
        KameleoonLogger.log({ level: LogLevel.INFO, strings, keys });
    }
    static error(strings, ...keys) {
        KameleoonLogger.log({ level: LogLevel.ERROR, strings, keys });
    }
    static warning(strings, ...keys) {
        KameleoonLogger.log({ level: LogLevel.WARNING, strings, keys });
    }
    static debug(strings, ...keys) {
        KameleoonLogger.log({ level: LogLevel.DEBUG, strings, keys });
    }
    static checkLevel(level) {
        return level <= KameleoonLogger.logLevel && level !== LogLevel.NONE;
    }
    static writeMessage(level, message) {
        KameleoonLogger.logger.log(level, `Kameleoon [${LOG_LEVEL_NAMES[level]}]: ${message}`);
    }
}
KameleoonLogger.logger = new DefaultLogger();
KameleoonLogger.logLevel = LogLevel.WARNING;

class MEGroup {
    constructor(featureFlags) {
        this._featureFlags = featureFlags
            .slice()
            .sort((ff1, ff2) => ff1.id - ff2.id);
    }
    getFeatureFlagByHash(hash) {
        let idx = Math.floor(hash * this._featureFlags.length);
        idx = Math.min(idx, this._featureFlags.length - 1);
        return this._featureFlags[idx];
    }
    get featureFlags() {
        return this._featureFlags;
    }
}

/**
 * @readonly
 * @enum {string} an Enum containing all possible variants of exception types `KameleoonError`
 * */
var KameleoonException;
(function (KameleoonException) {
    KameleoonException["Credentials"] = "Credentials";
    KameleoonException["EventSourceInitialization"] = "EventSourceInitialization";
    KameleoonException["FeatureFlagConfigurationNotFound"] = "FeatureFlagConfigurationNotFound";
    KameleoonException["FeatureFlagVariableNotFound"] = "FeatureFlagVariableNotFound";
    KameleoonException["FeatureFlagVariationNotFound"] = "FeatureFlagVariationNotFound";
    KameleoonException["FeatureFlagExperimentNotFound"] = "FeatureFlagExperimentNotFound";
    KameleoonException["FeatureFlagEnvironmentDisabled"] = "FeatureFlagEnvironmentDisabled";
    KameleoonException["VisitAmount"] = "VisitAmount";
    KameleoonException["VisitorCodeMaxLength"] = "VisitorCodeMaxLength";
    KameleoonException["VisitorCodeEmpty"] = "VisitorCodeEmpty";
    KameleoonException["StorageInitialization"] = "StorageInitialization";
    KameleoonException["StorageWrite"] = "StorageWrite";
    KameleoonException["StorageRead"] = "StorageRead";
    KameleoonException["StorageParse"] = "StorageParse";
    KameleoonException["StorageEmpty"] = "StorageEmpty";
    KameleoonException["ClientConfiguration"] = "ClientConfiguration";
    KameleoonException["TargetingCondition"] = "TargetingCondition";
    KameleoonException["AmongValuesCheck"] = "AmongValuesCheck";
    KameleoonException["RangeCheck"] = "RangeCheck";
    KameleoonException["Initialization"] = "Initialization";
    KameleoonException["JSONParse"] = "JSONParse";
    KameleoonException["NumberParse"] = "NumberParse";
    KameleoonException["VersionParse"] = "VersionParse";
    KameleoonException["CookieParse"] = "CookieParse";
    KameleoonException["SemanticVersionParse"] = "SemanticVersionParse";
    KameleoonException["RemoteData"] = "RemoteData";
    KameleoonException["MaximumRetriesReached"] = "MaximumRetriesReached";
})(KameleoonException || (KameleoonException = {}));

const ERROR_MESSAGES = {
    [KameleoonException.CookieParse]: (reason) => `Couldn't parse cookie string: ${reason}`,
    [KameleoonException.JSONParse]: (err) => `Couldn't parse JSON variable: ${err}`,
    [KameleoonException.NumberParse]: (value) => `It's not possible to parse value ${value} to Number`,
    [KameleoonException.VersionParse]: (value) => `It's not possible to parse a version value ${value} to Number, version should be in format x.x`,
    [KameleoonException.SemanticVersionParse]: (value) => `It's not possible to parse a version value ${value} to Number, version should be in format x.x.x`,
    [KameleoonException.Initialization]: () => "It seems that the client wasn't properly initialized, make sure to run `initialize` method before invoking other methods",
    [KameleoonException.Credentials]: () => 'KameleoonClient can not be created without credentials',
    [KameleoonException.StorageInitialization]: () => "There was an error while initializing React Native SDK storage, it seems that the storage library dependency wasn't installed",
    [KameleoonException.EventSourceInitialization]: () => "There was an error while initializing Real Time Update service, it seems that the event source library dependency wasn't installed",
    [KameleoonException.FeatureFlagConfigurationNotFound]: (featureKey) => `No feature flag with key ${featureKey} was found.`,
    [KameleoonException.FeatureFlagEnvironmentDisabled]: (featureKey, environment) => `Feature flag with key ${featureKey} is disabled in ${environment} environment.`,
    [KameleoonException.FeatureFlagVariableNotFound]: (variableKey, visitorCode) => `No feature flag variable with key ${variableKey} was found for ${visitorCode} visitorCode.`,
    [KameleoonException.FeatureFlagVariationNotFound]: (variationKey, visitorCode) => `No feature flag variation with key ${variationKey} was found for ${visitorCode} visitorCode.`,
    [KameleoonException.FeatureFlagExperimentNotFound]: (experimentId, visitorCode) => `No feature flag experiment with id ${experimentId} was found for ${visitorCode} visitorCode.`,
    [KameleoonException.VisitAmount]: () => 'Visit amount must be a number between 1 and 25',
    [KameleoonException.VisitorCodeMaxLength]: () => 'Visitor code can not be more than 255 characters long',
    [KameleoonException.VisitorCodeEmpty]: () => 'Visitor code can not be empty',
    [KameleoonException.StorageWrite]: (err) => `Couldn't update storage for kameleoonClient: ${err}`,
    [KameleoonException.StorageRead]: (key) => `No data found in storage under ${key} key`,
    [KameleoonException.StorageEmpty]: () => 'No data found in storage',
    [KameleoonException.StorageParse]: (err, key) => `Couldn't parse ${key} storage data, the data may be corrupted. Error: ${err}`,
    [KameleoonException.ClientConfiguration]: (err) => `Couldn't retrieve client configuration from Kameleoon Api. Error: ${err}`,
    [KameleoonException.TargetingCondition]: (targetingType) => `${targetingType} targeting condition is not yet supported.`,
    [KameleoonException.AmongValuesCheck]: (err, value) => `Couldn't parse value "${value}": ${err}`,
    [KameleoonException.RangeCheck]: (value) => `Couldn't parse value "${value}" as a range, value should be in format [x: number, y: number]`,
    [KameleoonException.RemoteData]: (err) => `Couldn't retrieve data from Kameleoon server. Error: ${err}`,
    [KameleoonException.MaximumRetriesReached]: (err) => `Maximum retries reached, request failed. Reason: ${err}`,
};

function exhaustCheck(option) {
    throw new Error(`Reaching an impossible state because of ${option}`);
}

/**
 * @class
 * KameleoonError - extends standard `Error` by adding custom `type` property with the type of `KameleoonException`
 * */
class KameleoonError extends Error {
    constructor(type, secondParam, thirdParam) {
        super(`Error: ${type}`);
        this.name = 'KameleoonError';
        this.errorType = type;
        switch (type) {
            case KameleoonException.Initialization:
            case KameleoonException.Credentials:
            case KameleoonException.VisitorCodeMaxLength:
            case KameleoonException.VisitorCodeEmpty:
            case KameleoonException.StorageInitialization:
            case KameleoonException.VisitAmount:
            case KameleoonException.EventSourceInitialization:
            case KameleoonException.StorageEmpty:
                this.message = ERROR_MESSAGES[type]();
                break;
            case KameleoonException.CookieParse:
            case KameleoonException.FeatureFlagConfigurationNotFound:
            case KameleoonException.NumberParse:
            case KameleoonException.ClientConfiguration:
            case KameleoonException.MaximumRetriesReached:
            case KameleoonException.RemoteData:
            case KameleoonException.VersionParse:
            case KameleoonException.SemanticVersionParse:
                this.message = ERROR_MESSAGES[type](secondParam);
                break;
            case KameleoonException.FeatureFlagExperimentNotFound:
                this.message = ERROR_MESSAGES[type](secondParam, thirdParam);
                break;
            case KameleoonException.FeatureFlagVariationNotFound:
            case KameleoonException.FeatureFlagVariableNotFound:
                this.message = ERROR_MESSAGES[type](secondParam, thirdParam);
                break;
            case KameleoonException.FeatureFlagEnvironmentDisabled:
                if (thirdParam !== undefined) {
                    this.message = ERROR_MESSAGES[type](secondParam, thirdParam);
                }
                else {
                    this.message = secondParam;
                }
                break;
            case KameleoonException.StorageWrite:
            case KameleoonException.JSONParse:
                this.message = ERROR_MESSAGES[type](secondParam);
                break;
            case KameleoonException.StorageRead:
                this.message = ERROR_MESSAGES[type](secondParam);
                break;
            case KameleoonException.StorageParse:
                this.message = ERROR_MESSAGES[type](secondParam, thirdParam);
                break;
            case KameleoonException.TargetingCondition:
                this.message = ERROR_MESSAGES[type](secondParam);
                break;
            case KameleoonException.AmongValuesCheck:
                this.message = ERROR_MESSAGES[type](secondParam, thirdParam);
                break;
            case KameleoonException.RangeCheck:
                this.message = ERROR_MESSAGES[type](secondParam);
                break;
            default:
                exhaustCheck(type);
        }
    }
    get type() {
        return this.errorType;
    }
}

const NUMBER_OF_RETRIES = 1;
const UrlEventType = {
    CustomData: 'eventType=customData',
    StaticData: 'eventType=staticData',
    Page: 'eventType=page',
    Conversion: 'eventType=conversion',
    Activity: 'eventType=activity',
    Experiment: 'eventType=experiment',
    Geolocation: 'eventType=geolocation',
    TargetingSegment: 'eventType=targetingSegment',
};
const UrlParameter = {
    Title: '&title=',
    ReferrersIndices: '&referrersIndices=',
    Negative: '&negative=',
    Revenue: '&revenue=',
    Overwrite: '&overwrite=',
    Index: '&index=',
    BrowserIndex: '&browserIndex=',
    BrowserVersion: '&browserVersion=',
    Href: '&href=',
    DeviceType: '&deviceType=',
    SiteCode: '&siteCode=',
    GoalId: '&goalId=',
    VisitorCode: '&visitorCode=',
    VariationId: '&variationId=',
    Ts: '&ts=',
    Key: '&key=',
    SdkName: '&sdkName=',
    SdkVersion: '&sdkVersion=',
    ValuesCountMap: '&valuesCountMap=',
    Nonce: '&nonce=',
    Id: '&id=',
    CustomData: '&customData=',
    CurrentVisit: '&currentVisit=',
    MaxNumberPreviousVisits: '&maxNumberPreviousVisits=',
    Os: '&os=',
    OsIndex: '&osIndex=',
    Country: '&country=',
    City: '&city=',
    Region: '&region=',
    Latitude: '&latitude=',
    Longitude: '&longitude=',
    PostalCode: '&postalCode=',
    Conversion: '&conversion=',
    StaticData: '&staticData=',
    Geolocation: '&geolocation=',
    Page: '&page=',
    Experiment: '&experiment=',
    Browser: '&browser=',
    MappingIdentifier: '&mappingIdentifier=',
    MappingValue: '&mappingValue=',
    Kcs: '&kcs=',
    Personalization: '&personalization=',
    UserAgent: '&userAgent=',
    BodyUa: '&bodyUa=',
    Cbs: '&cbs=',
    Metadata: '&metadata=',
    VisitNumber: '&visitNumber=',
    TimeSincePreviousVisit: '&timeSincePreviousVisit=',
};
const UrlFirstParameter = {
    Environment: '?environment=',
    SdkName: '?sdkName=',
    Ts: '?ts='};
const UrlQuery = {
    Sse: 'sse?siteCode=',
    Map: 'map?siteCode=',
    Events: 'events?siteCode=',
    Visitor: 'visitor?siteCode=',
};
const UrlTracking = {
    Visit: 'visit/',
    Map: 'map/',
};
const DEFAULT_DOMAINS = {
    ["dataApi" /* UrlType.DataApi */]: 'data.kameleoon.io',
    ["accessToken" /* UrlType.AccessToken */]: 'api.kameleoon.com',
    ["events" /* UrlType.Events */]: 'events.kameleoon.eu',
    ["clientConfiguration" /* UrlType.ClientConfiguration */]: 'sdk-config.kameleoon.eu',
};

/**
 * @enum `RequestType` - an enum of available request types
 * */
var RequestType;
(function (RequestType) {
    RequestType["Configuration"] = "configuration";
    RequestType["Tracking"] = "tracking";
    RequestType["RemoteData"] = "remoteData";
})(RequestType || (RequestType = {}));

class Requester {
    constructor({ urlProvider, packageInfo, externalRequester, requestTimeout, trackRetryDelay, useAbortController, }) {
        KameleoonLogger.debug `CALL: new Requester(urlProvider, packageInfo: ${packageInfo}, externalRequester, requestTimeout: ${requestTimeout}, trackRetryDelay: ${trackRetryDelay}, useAbortController: ${useAbortController})`;
        this.urlProvider = urlProvider;
        this.useAbortController = useAbortController;
        this.externalRequester = externalRequester;
        this.trackRetryDelay = trackRetryDelay;
        this.packageInfo = packageInfo;
        this.timeout = requestTimeout;
        KameleoonLogger.debug `RETURN: new Requester(urlProvider, packageInfo: ${packageInfo}, externalRequester, requestTimeout: ${requestTimeout}, trackRetryDelay: ${trackRetryDelay}, useAbortController: ${useAbortController})`;
    }
    getClientConfiguration(timeStamp, modifiedSince) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestUrl = this.urlProvider.getClientConfigurationUrl(timeStamp);
            let headers = Object.assign({ ["X-Kameleoon-SDK-Type" /* Header.SdkType */]: this.packageInfo.type, ["X-Kameleoon-SDK-Version" /* Header.SdkVersion */]: this.packageInfo.version }, (modifiedSince && { ["If-Modified-Since" /* Header.IfModifiedSince */]: modifiedSince }));
            // --- Note ---
            // Initial request + NUMBER_OF_RETRIES
            const requests = NUMBER_OF_RETRIES + 1;
            try {
                let responseInfo = { message: '' };
                KameleoonLogger.debug `Running configuration request Method: ${"GET" /* HttpMethod.Get */}, Url: ${requestUrl}, Headers: ${headers}, with retry limit ${requests}`;
                for (let i = 0; i < requests; i++) {
                    const response = yield this.sendRequest({
                        url: requestUrl,
                        requestType: RequestType.Configuration,
                        retryCount: i,
                        parameters: {
                            method: "GET" /* HttpMethod.Get */,
                            headers,
                        },
                    });
                    if (response.ok) {
                        const data = yield response.json();
                        this.logReceivedConfigurationResponse(response.status, requestUrl, headers);
                        const lastModified = this.getLastModifiedHeader(response);
                        const configurationData = data;
                        return buildExports.Ok({
                            configuration: configurationData,
                            lastModified: lastModified,
                        });
                    }
                    if (response.status === 304) {
                        this.logReceivedConfigurationResponse(response.status, requestUrl, headers);
                        return buildExports.Ok({});
                    }
                    if (i === NUMBER_OF_RETRIES) {
                        if (response.text) {
                            const text = yield response.text();
                            responseInfo = JSON.parse(text);
                        }
                        KameleoonLogger.error `Failed to get configuration response ${{
                            status: response.status,
                            message: responseInfo.message,
                        }} for request Method: ${"GET" /* HttpMethod.Get */}, Url: ${requestUrl}, Headers: ${headers}`;
                    }
                    else {
                        yield this.logRequestError({
                            logLevel: LogLevel.WARNING,
                            message: 'Failed to get configuration response',
                            response: response,
                            method: "GET" /* HttpMethod.Get */,
                            url: requestUrl,
                        });
                    }
                }
                return buildExports.Err(new KameleoonError(KameleoonException.MaximumRetriesReached, responseInfo.message));
            }
            catch (err) {
                yield this.logRequestError({
                    logLevel: LogLevel.ERROR,
                    message: 'Failed to get configuration response',
                    error: err,
                    method: "GET" /* HttpMethod.Get */,
                    url: requestUrl,
                    headers,
                });
                return buildExports.Err(new KameleoonError(KameleoonException.ClientConfiguration, err));
            }
        });
    }
    getRemoteData(key) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const requestUrl = this.urlProvider.getRemoteDataUrl(key);
            KameleoonLogger.debug `Running remote data request Method: ${"GET" /* HttpMethod.Get */}, Url: ${requestUrl}`;
            try {
                const response = yield this.sendRequest({
                    url: requestUrl,
                    requestType: RequestType.RemoteData,
                    retryCount: 0,
                    parameters: {
                        method: "GET" /* HttpMethod.Get */,
                    },
                });
                if (!response.ok) {
                    yield this.logRequestError({
                        logLevel: LogLevel.ERROR,
                        message: 'Failed to get remote data response',
                        response: response,
                        method: "GET" /* HttpMethod.Get */,
                        url: requestUrl,
                    });
                    if (response.text) {
                        const text = yield response.text();
                        const message = (_a = JSON.parse(text)) === null || _a === void 0 ? void 0 : _a.message;
                        return buildExports.Err(new KameleoonError(KameleoonException.RemoteData, message));
                    }
                    return buildExports.Err(new KameleoonError(KameleoonException.RemoteData, 'Unknown Reason - no `text()` was found for a response'));
                }
                const data = yield response.json();
                KameleoonLogger.debug `Received remote data response: ${{
                    status: response.status,
                }} for request Method: ${"GET" /* HttpMethod.Get */}, Url: ${requestUrl}`;
                return buildExports.Ok(data);
            }
            catch (err) {
                yield this.logRequestError({
                    logLevel: LogLevel.ERROR,
                    message: 'Failed to get remote data response',
                    error: err,
                    method: "GET" /* HttpMethod.Get */,
                    url: requestUrl,
                });
                return buildExports.Err(new KameleoonError(KameleoonException.RemoteData, err));
            }
        });
    }
    getVisitorData({ visitorCode, filters, isMappingIdentifier, }) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const requestUrl = this.urlProvider.getVisitorDataUrl({
                visitorCode,
                filters,
                isMappingIdentifier,
            });
            KameleoonLogger.debug `Running visitor data request Method: ${"GET" /* HttpMethod.Get */}, Url: ${requestUrl}`;
            try {
                const response = yield this.sendRequest({
                    url: requestUrl,
                    requestType: RequestType.RemoteData,
                    retryCount: 0,
                    parameters: {
                        method: "GET" /* HttpMethod.Get */,
                    },
                });
                if (!response.ok) {
                    yield this.logRequestError({
                        logLevel: LogLevel.ERROR,
                        message: 'Failed to get visitor data response',
                        response: response,
                        method: "GET" /* HttpMethod.Get */,
                        url: requestUrl,
                    });
                    if (typeof response.text === 'function') {
                        const text = yield response.text();
                        if (text) {
                            const message = (_a = JSON.parse(text)) === null || _a === void 0 ? void 0 : _a.message;
                            return buildExports.Err(new KameleoonError(KameleoonException.RemoteData, message));
                        }
                    }
                    if (response.status) {
                        return buildExports.Err(new KameleoonError(KameleoonException.RemoteData, `No error message. Error status: ${response.status}`));
                    }
                    return buildExports.Err(new KameleoonError(KameleoonException.RemoteData, 'Unknown Reason - no text message or error status was found for a response'));
                }
                const data = yield response.json();
                KameleoonLogger.debug `Received visitor data response: ${{
                    status: response.status,
                }} for request Method: ${"GET" /* HttpMethod.Get */}, Url: ${requestUrl}`;
                return buildExports.Ok(data);
            }
            catch (err) {
                yield this.logRequestError({
                    logLevel: LogLevel.ERROR,
                    message: 'Failed to get visitor data response',
                    error: err,
                    method: "GET" /* HttpMethod.Get */,
                    url: requestUrl,
                });
                return buildExports.Err(new KameleoonError(KameleoonException.RemoteData, err));
            }
        });
    }
    track(body, isBodyUserAgent) {
        return __awaiter(this, void 0, void 0, function* () {
            // --- Note ---
            // Initial request + NUMBER_OF_RETRIES
            const requests = NUMBER_OF_RETRIES + 1;
            const url = this.urlProvider.getTrackingUrl(isBodyUserAgent);
            KameleoonLogger.debug `Running tracking request Method: ${"POST" /* HttpMethod.Post */}, Url: ${url}, Body: ${body}, with retry limit ${requests}, retry delay ${this.trackRetryDelay} ms`;
            for (let i = 0; i < requests; i++) {
                let response;
                try {
                    response = yield this.sendRequest({
                        url,
                        retryCount: i,
                        requestType: RequestType.Tracking,
                        parameters: {
                            body,
                            method: "POST" /* HttpMethod.Post */,
                            headers: {
                                ["Content-Type" /* Header.ContentType */]: '*/*',
                            },
                        },
                    });
                    if (response.ok) {
                        KameleoonLogger.debug `Received tracking response: ${{
                            status: response.status,
                        }} for request Method: ${"POST" /* HttpMethod.Post */}, Url: ${url}, Body: ${body}`;
                        return buildExports.Ok();
                    }
                    yield this.logRequestError({
                        logLevel: i == NUMBER_OF_RETRIES ? LogLevel.ERROR : LogLevel.WARNING,
                        message: 'Failed to get tracking response',
                        response: response,
                        method: "POST" /* HttpMethod.Post */,
                        url,
                    });
                }
                catch (error) {
                    yield this.logRequestError({
                        logLevel: i == NUMBER_OF_RETRIES ? LogLevel.ERROR : LogLevel.WARNING,
                        message: 'Failed to get tracking response',
                        error,
                        method: "POST" /* HttpMethod.Post */,
                        url,
                    });
                }
                if (i < requests) {
                    yield new Promise((resolve) => setTimeout(resolve, this.trackRetryDelay));
                }
            }
            return buildExports.Err();
        });
    }
    sendRequest({ url, requestType, retryCount, parameters, }) {
        return __awaiter(this, void 0, void 0, function* () {
            let response;
            if (this.useAbortController) {
                const controller = new AbortController();
                const timeoutId = setTimeout(() => controller.abort(), this.timeout);
                response = yield this.externalRequester.sendRequest({
                    url,
                    retryCount: retryCount,
                    requestType,
                    parameters: Object.assign(Object.assign({}, parameters), { signal: controller.signal }),
                });
                clearTimeout(timeoutId);
            }
            else {
                response = yield this.externalRequester.sendRequest({
                    url,
                    retryCount: retryCount,
                    requestType,
                    parameters: parameters,
                });
            }
            return response;
        });
    }
    logRequestError({ logLevel, message, error, method, url, response, headers, }) {
        return __awaiter(this, void 0, void 0, function* () {
            if (error) {
                let errorText = 'Unknown error';
                if (error instanceof Error) {
                    errorText = error.message;
                }
                KameleoonLogger.log({
                    level: logLevel,
                    strings: () => `${message} with error: ${errorText} for request Method: ${method}, Url: ${url}`,
                });
            }
            else if (response) {
                if (KameleoonLogger.checkLevel(logLevel)) {
                    const logResponse = yield this.parseResponse(response);
                    KameleoonLogger.log({
                        level: logLevel,
                        strings: () => `${message} response: Status: '${logResponse.status}' Message: '${logResponse.message}' for request Method: ${method}, Url: '${url}'` +
                            (headers ? `, Headers: ${headers}` : ''),
                    });
                }
            }
        });
    }
    parseResponse(response) {
        return __awaiter(this, void 0, void 0, function* () {
            let message = '';
            try {
                if (typeof response.text === 'function') {
                    const text = yield response.text();
                    if (text) {
                        message = text;
                    }
                }
            }
            catch (error) { }
            return {
                status: response.status,
                message: message,
            };
        });
    }
    getLastModifiedHeader(response) {
        if (response.headers) {
            const targetKey = "Last-Modified" /* Header.LastModified */.toLowerCase();
            for (const [key, value] of response.headers) {
                if (key.toLowerCase() === targetKey) {
                    return value;
                }
            }
        }
        return undefined;
    }
    logReceivedConfigurationResponse(responseStatus, requestUrl, headers) {
        KameleoonLogger.debug `Received configuration response: ${{
            status: responseStatus,
        }} for request Method: ${"GET" /* HttpMethod.Get */}, Url: ${requestUrl}, Headers: ${headers}`;
    }
}

/**
 * @readonly
 * @enum {string} an Enum containing all possible variants of environment, passed as an argument to KameleoonClient `configuration`s `environment` field
 * */
var Environment;
(function (Environment) {
    Environment["Production"] = "production";
    Environment["Staging"] = "staging";
    Environment["Development"] = "development";
})(Environment || (Environment = {}));

class UrlProvider {
    constructor() {
        this.ready = false;
        this.isCustomDomain = false;
        this.domains = DEFAULT_DOMAINS;
    }
    initialize({ domain, siteCode, packageInfo, environment, }) {
        this.siteCode = siteCode;
        this.environment = environment;
        this.packageInfo = packageInfo;
        this.ready = true;
        this.setDomains(domain);
    }
    set dataApiDomain(domain) {
        if (!this.isCustomDomain) {
            this.domains["dataApi" /* UrlType.DataApi */] = domain;
            return;
        }
        const subDomain = domain.split('.')[0];
        const currentDomain = this.domains["dataApi" /* UrlType.DataApi */];
        this.domains["dataApi" /* UrlType.DataApi */] = currentDomain.replace(/^[^.]+/, subDomain);
    }
    get dataApiDomain() {
        return this.domains["dataApi" /* UrlType.DataApi */];
    }
    getClientConfigurationUrl(timeStamp) {
        this.isInitialized();
        const baseUrl = `https://${this.domains["clientConfiguration" /* UrlType.ClientConfiguration */]}/v3/`;
        const environmentParam = this.environment === Environment.Production
            ? ''
            : UrlFirstParameter.Environment + encodeURIComponent(this.environment);
        let timeStampParam = '';
        if (timeStamp) {
            if (environmentParam) {
                timeStampParam = UrlParameter.Ts + timeStamp;
            }
            else {
                timeStampParam = UrlFirstParameter.Ts + timeStamp;
            }
        }
        return baseUrl + this.siteCode + environmentParam + timeStampParam;
    }
    getEventSourceUrl() {
        this.isInitialized();
        return `https://${this.domains["events" /* UrlType.Events */]}:8110/${UrlQuery.Sse}${this.siteCode}`;
    }
    getRemoteDataUrl(key) {
        this.isInitialized();
        return (this.getDataApiUrl(2 /* DataApiQuery.DataMap */) +
            this.siteCode +
            UrlParameter.Key +
            encodeURI(key));
    }
    getVisitorDataUrl({ visitorCode, filters, isMappingIdentifier, }) {
        this.isInitialized();
        const { customData, previousVisitAmount, currentVisit, conversions, geolocation, experiments, pageViews, device, browser, operatingSystem, kcs, personalization, visitorCode: visitorCodeFilter, cbs, } = filters;
        const identifierParameter = isMappingIdentifier
            ? UrlParameter.MappingValue
            : UrlParameter.VisitorCode;
        const customDataParameter = customData || visitorCodeFilter ? UrlParameter.CustomData + true : '';
        const conversionsParameter = conversions
            ? UrlParameter.Conversion + true
            : '';
        const geolocationParameter = geolocation
            ? UrlParameter.Geolocation + true
            : '';
        const experimentsParameter = experiments
            ? UrlParameter.Experiment + true
            : '';
        const pageViewsParameter = pageViews ? UrlParameter.Page + true : '';
        const staticDataParameter = UrlParameter.StaticData + true;
        const currentVisitParameter = currentVisit
            ? UrlParameter.CurrentVisit + true
            : '';
        const kcsParameter = kcs ? UrlParameter.Kcs + true : '';
        const personalizationParameter = personalization
            ? UrlParameter.Personalization + true
            : '';
        const previousVisitAmountParam = typeof previousVisitAmount !== 'number'
            ? UrlParameter.MaxNumberPreviousVisits + 1
            : UrlParameter.MaxNumberPreviousVisits + previousVisitAmount;
        const cbsParameter = cbs ? UrlParameter.Cbs + true : '';
        return (this.getDataApiUrl(1 /* DataApiQuery.VisitData */) +
            this.siteCode +
            identifierParameter +
            visitorCode +
            previousVisitAmountParam +
            customDataParameter +
            conversionsParameter +
            geolocationParameter +
            experimentsParameter +
            pageViewsParameter +
            staticDataParameter +
            currentVisitParameter +
            kcsParameter +
            personalizationParameter +
            cbsParameter);
    }
    getTrackingUrl(isBodyUserAgent) {
        this.isInitialized();
        const { type, version } = this.packageInfo;
        let url = this.getDataApiUrl(0 /* DataApiQuery.VisitEvent */) +
            this.siteCode +
            UrlParameter.SdkName +
            type +
            UrlParameter.SdkVersion +
            version;
        if (isBodyUserAgent) {
            url += UrlParameter.BodyUa + true;
        }
        return url;
    }
    getAccessTokenUrl() {
        this.isInitialized();
        const { type, version } = this.packageInfo;
        return (`https://${this.domains["accessToken" /* UrlType.AccessToken */]}/oauth/token` +
            UrlFirstParameter.SdkName +
            type +
            UrlParameter.SdkVersion +
            version +
            UrlParameter.SiteCode +
            this.siteCode);
    }
    isInitialized() {
        if (!this.ready) {
            throw new Error('UrlProvider is not initialized');
        }
    }
    getDataApiUrl(query) {
        if (!this.domains["dataApi" /* UrlType.DataApi */]) {
            throw new Error('Data API domain is not set');
        }
        const domain = `https://${this.domains["dataApi" /* UrlType.DataApi */]}`;
        switch (query) {
            case 0 /* DataApiQuery.VisitEvent */:
                return `${domain}/${UrlTracking.Visit + UrlQuery.Events}`;
            case 1 /* DataApiQuery.VisitData */:
                return `${domain}/${UrlTracking.Visit + UrlQuery.Visitor}`;
            case 2 /* DataApiQuery.DataMap */:
                return `${domain}/${UrlTracking.Map + UrlQuery.Map}`;
        }
    }
    setDomains(domain) {
        if (!domain) {
            return;
        }
        this.isCustomDomain = true;
        this.domains["dataApi" /* UrlType.DataApi */] = 'data.' + domain;
        this.domains["accessToken" /* UrlType.AccessToken */] = 'api.' + domain;
        this.domains["events" /* UrlType.Events */] = 'events.' + domain;
        this.domains["clientConfiguration" /* UrlType.ClientConfiguration */] = 'sdk-config.' + domain;
    }
}

/**
 * @readonly
 * @enum {string} an Enum containing all possible variants of feature variable types
 * */
var VariableType;
(function (VariableType) {
    VariableType["BOOLEAN"] = "BOOLEAN";
    VariableType["NUMBER"] = "NUMBER";
    VariableType["STRING"] = "STRING";
    VariableType["JSON"] = "JSON";
    VariableType["JS"] = "JS";
    VariableType["CSS"] = "CSS";
})(VariableType || (VariableType = {}));
/**
 * @readonly
 * @enum {string} an Enum containing all possible variants for data status
 * */
var TrackingStatus;
(function (TrackingStatus) {
    TrackingStatus["Sent"] = "sent";
    TrackingStatus["Unsent"] = "unsent";
    TrackingStatus["Pending"] = "pending";
})(TrackingStatus || (TrackingStatus = {}));

function constructTypeMap(indexMap) {
    return Object.fromEntries(Object.entries(indexMap).map(([key, value]) => [value, key]));
}

var KameleoonData;
(function (KameleoonData) {
    KameleoonData["UniqueIdentifier"] = "uniqueIdentifier";
    KameleoonData["CustomData"] = "customData";
    KameleoonData["PageView"] = "pageView";
    KameleoonData["GeolocationData"] = "geolocation";
    KameleoonData["Browser"] = "browser";
    KameleoonData["Conversion"] = "conversion";
    KameleoonData["Cookie"] = "cookie";
    KameleoonData["Device"] = "device";
    KameleoonData["OperatingSystem"] = "operatingSystem";
    KameleoonData["UserAgent"] = "userAgent";
    KameleoonData["ApplicationVersion"] = "applicationVersion";
    KameleoonData["VisitsData"] = "visitsData";
    KameleoonData["KameleoonConversionScore"] = "kameleoonConversionScore";
    KameleoonData["Personalization"] = "personalization";
    KameleoonData["CBScores"] = "cbScores";
    KameleoonData["TargetedSegment"] = "targetedSegment";
})(KameleoonData || (KameleoonData = {}));
/**
 * @readonly
 * @enum {string} an Enum containing all possible variants for device type
 * */
var DeviceType;
(function (DeviceType) {
    DeviceType["Phone"] = "PHONE";
    DeviceType["Tablet"] = "TABLET";
    DeviceType["Desktop"] = "DESKTOP";
})(DeviceType || (DeviceType = {}));
/**
 * @readonly
 * @enum {string} an Enum containing all possible variants for operating system type
 * */
var OperatingSystemType;
(function (OperatingSystemType) {
    OperatingSystemType["WindowsPhone"] = "WINDOWS_PHONE";
    OperatingSystemType["Windows"] = "WINDOWS";
    OperatingSystemType["Android"] = "ANDROID";
    OperatingSystemType["Linux"] = "LINUX";
    OperatingSystemType["Mac"] = "MAC";
    OperatingSystemType["IOS"] = "IOS";
})(OperatingSystemType || (OperatingSystemType = {}));
/**
 * @readonly
 * @enum {string} an Enum containing all possible variants for browser type
 * */
var BrowserType;
(function (BrowserType) {
    BrowserType["Chrome"] = "CHROME";
    BrowserType["InternetExplorer"] = "IE";
    BrowserType["Firefox"] = "FIREFOX";
    BrowserType["Safari"] = "SAFARI";
    BrowserType["Opera"] = "OPERA";
    BrowserType["Other"] = "OTHER";
})(BrowserType || (BrowserType = {}));
const OperatingSystemIndexMap = {
    [OperatingSystemType.Windows]: 0,
    [OperatingSystemType.Mac]: 1,
    [OperatingSystemType.IOS]: 2,
    [OperatingSystemType.Linux]: 3,
    [OperatingSystemType.Android]: 4,
    [OperatingSystemType.WindowsPhone]: 5,
};
const OperatingSystemTypeMap = constructTypeMap(OperatingSystemIndexMap);
const BrowserIndexMap = {
    [BrowserType.Chrome]: 0,
    [BrowserType.InternetExplorer]: 1,
    [BrowserType.Firefox]: 2,
    [BrowserType.Safari]: 3,
    [BrowserType.Opera]: 4,
    [BrowserType.Other]: 5,
};
const BrowserTypeMap = constructTypeMap(BrowserIndexMap);

const HEX_CHARACTERS = '0123456789ABCDEF';
const NONCE_LENGTH = 16;
const HTTP = 'http://';
const HTTPS = 'https://';
const LOCALHOST = 'localhost';
const REGEX_DOMAIN = /^(\.?(([a-zA-Z\d][a-zA-Z\d-]*[a-zA-Z\d])|[a-zA-Z\d]))(\.(([a-zA-Z\d][a-zA-Z\d-]*[a-zA-Z\d])|[a-zA-Z\d])){1,126}$/;
const HIDDEN_SECRET_CHAR = '*';
const SECRET_VISIBLE_LENGTH = 4;
const VISITOR_VISIT_MAX_LENGTH = 26;

class Validator {
    static validateVersion(version) {
        const versionParts = version.split('.').map((x) => parseInt(x, 10));
        while (versionParts.length < 3) {
            versionParts.push(0);
        }
        if (versionParts.some((item) => isNaN(item))) {
            return buildExports.Err(new KameleoonError(KameleoonException.SemanticVersionParse, version));
        }
        return buildExports.Ok(versionParts.slice(0, 3));
    }
    static validateDomain(domain) {
        if (!domain) {
            return buildExports.Err();
        }
        domain = Validator.checkAndTrimProtocol(domain.toLowerCase());
        if (!REGEX_DOMAIN.test(domain) && domain !== LOCALHOST) {
            KameleoonLogger.error `The top-level domain ${domain} is invalid. The value has been set as provided, but it does not meet the required format for proper SDK functionality. Please check the domain for correctness.`;
            return buildExports.Ok(domain);
        }
        return buildExports.Ok(domain);
    }
    static validateNetworkDomain(networkDomain) {
        if (!networkDomain) {
            return buildExports.Err();
        }
        networkDomain = Validator.checkAndTrimProtocol(networkDomain.toLowerCase());
        // replace first and last dot
        networkDomain = networkDomain.replace(/^\.+|\.+$/g, '');
        if (!REGEX_DOMAIN.test(networkDomain) && networkDomain !== LOCALHOST) {
            KameleoonLogger.error `The network domain ${networkDomain} is invalid.`;
            return buildExports.Err();
        }
        return buildExports.Ok(networkDomain);
    }
    static checkAndTrimProtocol(domain) {
        const protocols = [HTTP, HTTPS];
        for (const protocol of protocols) {
            if (domain.startsWith(protocol)) {
                domain = domain.substring(protocol.length);
                KameleoonLogger.warning `The domain contains ${protocol}. Domain after protocol trimming: ${domain}`;
                break;
            }
        }
        return domain;
    }
}

class Utilities {
    static getNonce(prng) {
        let nonce = '';
        for (let i = 0; i < NONCE_LENGTH; i++) {
            const randomNumber = prng.getRandomNumber();
            const randomIndex = Math.floor(randomNumber * NONCE_LENGTH);
            nonce += HEX_CHARACTERS.charAt(randomIndex);
        }
        return nonce;
    }
    static checkTargeting({ segment, visitorCode, targetingData, experimentId, variationConfiguration, clientConfiguration, packageInfo, dataManager, }) {
        KameleoonLogger.debug `CALL: checkTargeting(segment, visitorCode: ${visitorCode}, targetingData: ${targetingData}, experimentId: ${experimentId}, variationConfiguration, clientConfiguration, packageInfo, dataManager)`;
        if (!segment || !segment.conditionsData.firstLevel.length) {
            const result = buildExports.Ok(true);
            KameleoonLogger.debug `RETURN checkTargeting(segment, visitorCode: ${visitorCode}, targetingData: ${targetingData}, experimentId: ${experimentId}, variationConfiguration, clientConfiguration, packageInfo, dataManager) -> (result: ${result})`;
            return result;
        }
        if (!variationConfiguration) {
            const result = buildExports.Err(new KameleoonError(KameleoonException.Initialization));
            KameleoonLogger.debug `RETURN checkTargeting(segment, visitorCode: ${visitorCode}, targetingData: ${targetingData}, experimentId: ${experimentId}, variationConfiguration, clientConfiguration, packageInfo, dataManager) -> (result: ${result})`;
            return result;
        }
        let variations = {};
        const assignedVariationsResult = variationConfiguration.getStoredVariations(visitorCode);
        if (assignedVariationsResult.ok) {
            variations = assignedVariationsResult.data;
        }
        const targetingTree = dataManager.getTree(segment);
        let trees = undefined;
        let ruleMap = undefined;
        let segments = undefined;
        // --- Note ---
        // Only getting trees and segments targeting type
        if (targetingTree.hasTargetingType("SEGMENT" /* TargetingType.SEGMENT */)) {
            trees = dataManager.trees;
            segments = clientConfiguration.segments;
        }
        // --- Note ---
        // Only constructing rule map for targeting type
        if (targetingTree.hasTargetingType("TARGET_FEATURE_FLAG" /* TargetingType.TARGET_FEATURE_FLAG */)) {
            ruleMap = clientConfiguration.ruleMap;
        }
        const result = targetingTree.evaluate({
            variationData: variations,
            sdkInfo: packageInfo,
            segments,
            ruleMap,
            trees,
            targetingData,
            experimentId,
            visitorCode,
        });
        KameleoonLogger.debug `RETURN checkTargeting(segment, visitorCode: ${visitorCode}, targetingData: ${targetingData}, experimentId: ${experimentId}, variationConfiguration, clientConfiguration, packageInfo, dataManager) -> (result: ${result})`;
        return result;
    }
    static convertTimeUnit(time, timeUnit) {
        const timeMap = {
            ["MINUTE" /* TimeUnit.Minute */]: 60000 /* Milliseconds.Minute */,
            ["HOUR" /* TimeUnit.Hour */]: 3600000 /* Milliseconds.Hour */,
            ["DAY" /* TimeUnit.Day */]: 86400000 /* Milliseconds.Day */,
            ["WEEK" /* TimeUnit.Week */]: 604800000 /* Milliseconds.Week */,
            ["MONTH" /* TimeUnit.Month */]: 2592000000 /* Milliseconds.Month */,
        };
        return time / timeMap[timeUnit];
    }
    static isCustomData(dataItem) {
        return dataItem.data.type === KameleoonData.CustomData;
    }
    static compareSemVer({ version, compareVersion, operator, }) {
        const versionResult = Validator.validateVersion(version);
        const compareVersionResult = Validator.validateVersion(compareVersion);
        if (!versionResult.ok) {
            return buildExports.Err(versionResult.error);
        }
        if (!compareVersionResult.ok) {
            return buildExports.Err(compareVersionResult.error);
        }
        const [major, minor, patch] = versionResult.data;
        const [compareMajor, compareMinor, comparePatch] = compareVersionResult.data;
        const [isMajorEqual, isMinorEqual, isPatchEqual] = [
            major === compareMajor,
            minor === compareMinor,
            patch === comparePatch,
        ];
        switch (operator) {
            case "EQUAL" /* VersionMatchType.EQUAL */:
                return buildExports.Ok(isMajorEqual && isMinorEqual && isPatchEqual);
            case "GREATER" /* VersionMatchType.GREATER */:
                return buildExports.Ok(major > compareMajor ||
                    (isMajorEqual && minor > compareMinor) ||
                    (isMajorEqual && isMinorEqual && patch > comparePatch));
            case "LOWER" /* VersionMatchType.LOWER */:
                return buildExports.Ok(major < compareMajor ||
                    (isMajorEqual && minor < compareMinor) ||
                    (isMajorEqual && isMinorEqual && patch < comparePatch));
            default:
                KameleoonLogger.error `Unknown version match type: ${operator}`;
                exhaustCheck(operator);
        }
    }
    static getVariationByHash(variationByExposition, hash) {
        let total = 0;
        for (const varByExpItem of variationByExposition) {
            total += varByExpItem.exposition;
            if (total >= hash) {
                return varByExpItem;
            }
        }
        return null;
    }
}

class ListUtilities {
    /**
     * Insert element in ordered list, if element already exists in list, does nothing
     * @param list - list to insert element
     * @param element - element to insert
     * @param order - order of list
     */
    static insertInOrderedListMutably({ list, element, order, }) {
        if (list.includes(element)) {
            return;
        }
        const index = list.findIndex((item) => order === "asc" /* Order.Ascending */ ? item >= element : item <= element);
        if (index === -1) {
            list.push(element);
        }
        else {
            list.splice(index, 0, element);
        }
    }
    /**
     * Insert visit in ordered list, if visit already exists in list, does nothing
     * @param list - list to insert element
     * @param visit - visit to insert
     */
    static insertVisitInOrderedListMutably({ list, visit, }) {
        // Check if the visit already exists in the list
        const currentVisit = list.find((item) => typeof item === 'number'
            ? item === visit.timeStarted
            : item.timeStarted === visit.timeStarted);
        if (currentVisit) {
            return;
        }
        const index = list.findIndex((item) => {
            if (typeof item === 'number') {
                return item >= visit.timeStarted;
            }
            return item.timeStarted >= visit.timeStarted;
        });
        if (index === -1) {
            list.push(visit);
        }
        else {
            list.splice(index, 0, visit);
        }
        if (list.length > VISITOR_VISIT_MAX_LENGTH) {
            list.splice(0, list.length - VISITOR_VISIT_MAX_LENGTH);
        }
    }
}

/**
 * @class
 * PageView - a class for creating an instance of a page view data
 * */
class PageView {
    /**
     * @param {PageViewParametersType} pageViewParameters - an object with page view parameters
     * */
    constructor({ urlAddress, title, referrers }) {
        this.urlAddress = urlAddress;
        this.title = title;
        this.referrers = referrers;
        this.timestamps = [
            {
                time: Date.now(),
                status: TrackingStatus.Unsent,
            },
        ];
    }
    get url() {
        var _a;
        // --- Note ---
        // If SDK is used in vanilla JS codebase, then you're also able to create an instance
        // with no required data, we don't want send anything to tracking in that case
        if (!this.urlAddress) {
            return '';
        }
        const titleParameter = this.title
            ? UrlParameter.Title + encodeURIComponent(this.title)
            : '';
        const referrersParameter = ((_a = this.referrers) === null || _a === void 0 ? void 0 : _a.length)
            ? UrlParameter.ReferrersIndices + JSON.stringify(this.referrers)
            : '';
        return (UrlEventType.Page +
            UrlParameter.Href +
            encodeURIComponent(this.urlAddress) +
            titleParameter +
            referrersParameter);
    }
    get status() {
        const { [TrackingStatus.Sent]: sent, [TrackingStatus.Unsent]: unsent, [TrackingStatus.Pending]: pending, } = this.timestamps.reduce((acc, { status }) => {
            acc[status] = true;
            return acc;
        }, {
            [TrackingStatus.Sent]: false,
            [TrackingStatus.Unsent]: false,
            [TrackingStatus.Pending]: false,
        });
        if (sent && !unsent && !pending) {
            return TrackingStatus.Sent;
        }
        if (pending && !unsent) {
            return TrackingStatus.Pending;
        }
        return TrackingStatus.Unsent;
    }
    set status(status) {
        this.timestamps = this.timestamps.map((timestamp) => (Object.assign(Object.assign({}, timestamp), { status })));
    }
    set _nonce(nonce) {
        this.nonce = nonce;
    }
    get data() {
        return {
            urlAddress: this.urlAddress,
            title: this.title,
            referrers: this.referrers,
            type: KameleoonData.PageView,
            timestamps: this.timestamps,
            status: this.status,
            nonce: this.nonce,
        };
    }
    /**
     * @private
     * @method _fromRaw - an internal method for creating a PageView instance from raw data
     * @param {PageViewDataType} data - a raw data
     * @return {PageView} a PageView instance
     * */
    static _fromRaw(data) {
        const { urlAddress, title, referrers, timestamps, nonce } = data;
        const pageView = new PageView({
            urlAddress,
            title,
            referrers,
        });
        pageView.timestamps = timestamps;
        if (nonce) {
            pageView._nonce = nonce;
        }
        return pageView;
    }
    /**
     * @private
     * @method _updateFromVisit - an internal method for updating a list of page view data from a visit
     * @param {VisitType} visit - a visit
     * @param {Map<string, PageView>} dataMap - a map of page view data where we collect data
     * */
    static _updateFromVisit(visit, dataMap) {
        const pageEvents = visit.pageEvents;
        if (pageEvents) {
            for (const pageEvent of pageEvents) {
                let referrers = [];
                const { time } = pageEvent;
                const { href, title, referrersIndices } = pageEvent.data;
                if (typeof referrersIndices[0] === 'number') {
                    referrers = referrersIndices;
                }
                let pageView;
                if (dataMap.has(href)) {
                    const existingTimestamps = dataMap.get(href).timestamps;
                    pageView = new PageView({
                        urlAddress: href,
                        title,
                        referrers,
                    });
                    pageView.timestamps = [
                        ...existingTimestamps,
                        { time, status: TrackingStatus.Sent },
                    ];
                }
                else {
                    pageView = new PageView({
                        urlAddress: href,
                        title,
                        referrers,
                    });
                    pageView.timestamps = [{ time, status: TrackingStatus.Sent }];
                }
                dataMap.set(href, pageView);
            }
        }
    }
}

/**
 * @class
 * CustomData - a class for creating an instance for user's custom data
 * */
let CustomData$1 = class CustomData {
    constructor(first, second, ...rest) {
        this._status = TrackingStatus.Unsent;
        this.isIdentifier = false;
        const isNumber = typeof first === 'number';
        const isBoolean = typeof second === 'boolean';
        if (isNumber) {
            this._index = first;
        }
        else {
            this._name = first;
            this._index = CustomData.UNDEFINED_INDEX;
        }
        this.overwrite = isBoolean ? second : true;
        this.value = isBoolean
            ? rest
            : [second, ...rest].filter((v) => v != null);
    }
    get url() {
        // --- Note ---
        // If SDK is used in vanilla JS codebase, then you're also able to create an instance
        // with no required data, we don't want send anything to tracking in that case
        if (typeof this._index !== 'number') {
            return '';
        }
        const uniqueValues = [...new Set(this.value)];
        let resultValue = {};
        // --- Note ---
        // Final value should look like this `{ "value_1": 1, "value_2": 1, "value_3": 1 }`
        // With no duplicates
        uniqueValues.forEach((value) => {
            resultValue[value] = 1;
        });
        let identifierParameter = '';
        if (this.isIdentifier) {
            identifierParameter = UrlParameter.MappingIdentifier + String(true);
        }
        return (UrlEventType.CustomData +
            UrlParameter.Index +
            this._index +
            UrlParameter.ValuesCountMap +
            encodeURIComponent(JSON.stringify(resultValue)) +
            UrlParameter.Overwrite +
            String(this.overwrite) +
            identifierParameter);
    }
    get data() {
        return Object.assign(Object.assign({ index: this._index }, (this._name !== undefined ? { name: this._name } : {})), { value: this.value, type: KameleoonData.CustomData, isIdentifier: this.isIdentifier, status: this.status, overwrite: this.overwrite });
    }
    get status() {
        if (this._isMappingIdentifier) {
            return TrackingStatus.Unsent;
        }
        return this._status;
    }
    /**
     * @private
     * @method _fromRaw - an internal method for creating a CustomData instance from raw data
     * @param {CustomDataType} data - a raw data
     * @return {CustomData} a CustomData instance
     * */
    static _fromRaw(data) {
        const { index, value, status, isIdentifier, name, overwrite } = data;
        let customData;
        if (name) {
            customData = new CustomData(name, overwrite !== null && overwrite !== void 0 ? overwrite : true, ...value);
            customData.index = index;
        }
        else {
            customData = new CustomData(index, overwrite !== null && overwrite !== void 0 ? overwrite : true, ...value);
        }
        customData.status = status;
        customData._isMappingIdentifier = isIdentifier;
        return customData;
    }
    /**
     * @property isMappingIdentifier - signifying if the data is a mapping identifier
     * @private
     * */
    set _isMappingIdentifier(value) {
        this.isIdentifier = value;
    }
    set status(status) {
        this._status = status;
    }
    /**
     * @private
     * @method _updateFromVisit - an internal method for updating a list of custom data from a visit
     * @param {VisitType} visit - a visit
     * */
    static _updateFromVisit(visit, dataMap) {
        var _a;
        if ((_a = visit.customDataEvents) === null || _a === void 0 ? void 0 : _a.length) {
            for (let i = visit.customDataEvents.length - 1; i >= 0; i--) {
                const { index, valuesCountMap } = visit.customDataEvents[i].data;
                if (!dataMap.has(index)) {
                    dataMap.set(index, new CustomData(index, ...Object.keys(valuesCountMap)));
                }
            }
        }
    }
    /**
     * @private
     * @method index - an internal setter for setting index of custom data
     * @param {number} value - an index value
     * */
    set index(value) {
        this._index = value;
    }
    /**
     * @private
     * @method index - an internal getter for index of custom data
     * */
    get index() {
        return this._index;
    }
    /**
     * @private
     * @method name - an internal getter for a name of custom data
     * */
    get name() {
        return this._name;
    }
    /**
     * @private
     * @method name - an internal getter for a name of custom data
     * */
    get values() {
        return this.value;
    }
};
CustomData$1.UNDEFINED_INDEX = -1;

/**
 * @class
 * Conversion - a class for creating an instance for conversion tracking
 * */
let Conversion$1 = class Conversion {
    /**
     * @param {ConversionParametersType} conversionParameters - an object with conversion parameters
     * */
    constructor({ goalId, revenue = 0, negative = false, metadata, }) {
        this.goalId = goalId;
        this.revenue = revenue;
        this.negative = negative;
        this.status = TrackingStatus.Unsent;
        this.id = Math.floor(Math.random() * 1000000);
        this._metadata = metadata;
        this.assignedTime = Date.now();
    }
    set _id(id) {
        this.id = id;
    }
    set _nonce(nonce) {
        this.nonce = nonce;
    }
    /** @internal */
    static _fromInternal(_a) {
        var { assignedTime } = _a, params = __rest(_a, ["assignedTime"]);
        const instance = new Conversion(params);
        if (assignedTime !== undefined) {
            instance.assignedTime = assignedTime;
        }
        return instance;
    }
    get url() {
        var _a;
        return (UrlEventType.Conversion +
            UrlParameter.GoalId +
            String(this.goalId) +
            UrlParameter.Revenue +
            String(this.revenue) +
            UrlParameter.Negative +
            String(this.negative) +
            (((_a = this.metadata) === null || _a === void 0 ? void 0 : _a.length)
                ? UrlParameter.Metadata + this._encodeMetadata()
                : ''));
    }
    /**
     * @private
     * @method metadata - an internal getter for a metadata of conversion
     * */
    get _metadata() {
        return this.metadata;
    }
    /**
     * @private
     * @method metadata - an internal setter for setting metadata of conversion
     * @param {number} value - an index value
     * */
    set _metadata(value) {
        this.metadata = value;
    }
    get data() {
        var _a;
        return {
            goalId: this.goalId,
            nonce: this.nonce,
            revenue: this.revenue,
            negative: this.negative,
            type: KameleoonData.Conversion,
            status: this.status,
            id: this.id,
            metadata: ((_a = this.metadata) === null || _a === void 0 ? void 0 : _a.map((item) => item.data)) || undefined,
            assignedTime: this.assignedTime,
        };
    }
    _encodeMetadata() {
        var _a;
        if (!((_a = this.metadata) === null || _a === void 0 ? void 0 : _a.length)) {
            return '';
        }
        return encodeURIComponent(JSON.stringify(this.metadata.reduce((acc, item) => {
            if (acc[item.data.index] == null) {
                acc[item.data.index] = item.data.value;
            }
            return acc;
        }, {})));
    }
    /**
     * @private
     * @method _fromRaw - an internal method for creating a Conversion instance from raw data
     * @param {ConversionDataType} data - a raw data
     * @return {Conversion} a Conversion instance
     * */
    static _fromRaw(data) {
        const { goalId, revenue, negative, status, id, nonce, metadata, assignedTime, } = data;
        const conversion = Conversion._fromInternal({
            goalId,
            revenue,
            negative,
            metadata: Conversion.parseMetadata(metadata),
            assignedTime,
        });
        conversion._id = id;
        conversion.status = status;
        if (nonce) {
            conversion._nonce = nonce;
        }
        return conversion;
    }
    static parseMetadata(metadata) {
        return ((metadata === null || metadata === void 0 ? void 0 : metadata.map((item) => CustomData$1._fromRaw(item))) ||
            undefined);
    }
    /**
     * @private
     * @method _listFromVisit - an internal method for returning a list of all Conversion instances
     * @param {VisitType} visit - a visits
     * @return {Conversion[]} - a list of Conversion instances
     * */
    static _listFromVisit(visit) {
        var _a, _b;
        const conversions = [];
        if (!((_a = visit.conversionEvents) === null || _a === void 0 ? void 0 : _a.length)) {
            return [];
        }
        if ((_b = visit === null || visit === void 0 ? void 0 : visit.conversionEvents) === null || _b === void 0 ? void 0 : _b.length) {
            for (const conversionEvent of visit.conversionEvents) {
                const { goalId, revenue, negative } = conversionEvent.data;
                const conversion = Conversion._fromInternal({
                    goalId,
                    revenue,
                    negative,
                    assignedTime: conversionEvent.time,
                });
                // --- Note ---
                // Conversion is marked as sent, so the visitor won't be converted again just
                // by pulling visits data
                conversion.status = TrackingStatus.Sent;
                conversions.push(conversion);
            }
        }
        return conversions;
    }
    /**
     * @private
     * @method _updateFromVisit - an internal method for updating a list of Conversion instances with only goalId
     * @param {VisitType} visit - a visits
     * @param {Map<number, Conversion>} dataMap - a map of Conversion instances
     * */
    static _updateFromVisit(visit, dataMap) {
        var _a;
        if ((_a = visit.conversionEvents) === null || _a === void 0 ? void 0 : _a.length) {
            for (const conversionEvent of visit.conversionEvents) {
                const { goalId } = conversionEvent.data;
                // --- Note ---
                // - We only take unique `goalId`s as and don't use `revenue` and `negative`
                // because we only utilize it for Conversion Condition and don't re-sent this data tracking
                // not to break server `revenue` calculations and not to cause extra conversions
                // - Moreover conversion is marked as sent, so the visitor won't be converted again just
                // by pulling visits data
                if (!dataMap.has(goalId)) {
                    const conversion = Conversion._fromInternal({
                        goalId,
                        assignedTime: conversionEvent.time,
                    });
                    conversion.status = TrackingStatus.Sent;
                    dataMap.set(goalId, conversion);
                }
            }
        }
    }
};

/**
 * @class
 * Browser - a class for creating an instance for browser of a certain type
 * */
let Browser$1 = class Browser {
    /**
     * @param {BrowserType} browser - one of the browser types available for data, if browser can not be found in a list, it can be marked as `BrowserType.Other`
     * @param {number | undefined} version - version of the browser, floating point number represents major and minor version of the browser
     * @example
     * ```ts
     * const browser = new Browser(BrowserType.Chrome, 86);
     * const browser = new Browser(BrowserType.Safari, 14.1);
     * ```
     * */
    constructor(browser, version) {
        this.browser = browser;
        this.version = version;
        this.status = TrackingStatus.Unsent;
    }
    get url() {
        // --- Note ---
        // If SDK is used in vanilla JS codebase, then you're also able to create an instance
        // with no required data, we don't want send anything to tracking in that case
        if (!this.browser) {
            return '';
        }
        const browserVersion = this.version
            ? UrlParameter.BrowserVersion + this.version
            : '';
        return (UrlEventType.StaticData +
            UrlParameter.Browser +
            this.browser +
            UrlParameter.BrowserIndex +
            BrowserIndexMap[this.browser] +
            browserVersion);
    }
    get data() {
        return {
            browser: this.browser,
            type: KameleoonData.Browser,
            version: this.version,
            status: this.status,
        };
    }
    /**
     * @private
     * @method _fromRaw - an internal method for creating a Browser instance from raw data
     * @param {BrowserDataType} data - a raw data
     * @return {Browser} a Browser instance
     * */
    static _fromRaw(data) {
        const { browser: browserType, version, status } = data;
        const browser = new Browser(browserType, version);
        browser.status = status;
        return browser;
    }
    /**
     * @private
     * @method _fromVisit - an internal method for creating an instance of Browser class from a visit
     * @param {VisitType} visit - a visit
     * @returns {Browser | undefined} an instance of Browser class or undefined if browser can not be found among visits
     * */
    static _fromVisit(visit) {
        if (!visit.staticDataEvent) {
            return undefined;
        }
        const { browser: browserType, browserIndex, browserVersion, } = visit.staticDataEvent.data;
        if (browserType || typeof browserIndex === 'number') {
            const browser = browserType !== null && browserType !== void 0 ? browserType : BrowserTypeMap[browserIndex];
            if (browserVersion) {
                return new Browser(browser, browserVersion);
            }
            else {
                return new Browser(browser);
            }
        }
        return undefined;
    }
};

/**
 * @class
 * Device - a class for creating an instance for device of a certain type
 * */
let Device$1 = class Device {
    /**
     * @param {DeviceType} device - one of the available device types from `DeviceType` enum
     * */
    constructor(device) {
        this.device = device;
        this.status = TrackingStatus.Unsent;
    }
    get url() {
        // --- Note ---
        // If SDK is used in vanilla JS codebase, then you're also able to create an instance
        // with no required data, we don't want send anything to tracking in that case
        if (!this.device) {
            return '';
        }
        return UrlEventType.StaticData + UrlParameter.DeviceType + this.device;
    }
    get data() {
        return {
            device: this.device,
            type: KameleoonData.Device,
            status: this.status,
        };
    }
    /**
     * @private
     * @method _fromRaw - an internal method for creating a Device instance from raw data
     * @param {DeviceDataType} data - a raw data
     * @return {Device} a Device instance
     * */
    static _fromRaw(data) {
        const { device: deviceType, status } = data;
        const device = new Device(deviceType);
        device.status = status;
        return device;
    }
    /**
     * @private
     * @method _fromVisit - an internal method for creating an instance of Device class from a visit
     * @param {VisitType} visit - a visit
     * @returns {Device | undefined} an instance of Device class or undefined if browser can not be found among visits
     * */
    static _fromVisit(visit) {
        var _a;
        if ((_a = visit.staticDataEvent) === null || _a === void 0 ? void 0 : _a.data.deviceType) {
            return new Device(visit.staticDataEvent.data.deviceType);
        }
        return undefined;
    }
};

/**
 * @class
 * OperatingSystem - a class for creating an instance for Operating System of a certain type
 * */
let OperatingSystem$1 = class OperatingSystem {
    /**
     * @param {OperatingSystemType} operatingSystem - one of the available operating system types from `OperatingSystemType` enum
     * */
    constructor(operatingSystem) {
        this.operatingSystem = operatingSystem;
        this.status = TrackingStatus.Unsent;
    }
    get url() {
        // --- Note ---
        // If SDK is used in vanilla JS codebase, then you're also able to create an instance
        // with no required data, we don't want send anything to tracking in that case
        if (!this.operatingSystem) {
            return '';
        }
        return (UrlEventType.StaticData +
            UrlParameter.Os +
            this.operatingSystem +
            UrlParameter.OsIndex +
            OperatingSystemIndexMap[this.operatingSystem]);
    }
    get data() {
        return {
            operatingSystem: this.operatingSystem,
            type: KameleoonData.OperatingSystem,
            status: this.status,
        };
    }
    /**
     * @private
     * @method _fromRaw - a static method for creating an instance of OperatingSystem class from raw data
     * @param {OperatingSystemDataType} data - a raw data
     * @returns {OperatingSystem} an instance of OperatingSystem class
     * */
    static _fromRaw(data) {
        const { operatingSystem, status } = data;
        const os = new OperatingSystem(operatingSystem);
        os.status = status;
        return os;
    }
    /**
     * @private
     * @method _fromVisit - a static method for creating an instance of OperatingSystem class from a visit
     * @param {VisitType} visit - a visit
     * @returns {OperatingSystem | undefined} an instance of OperatingSystem class or undefined
     * */
    static _fromVisit(visit) {
        if (!visit.staticDataEvent) {
            return undefined;
        }
        const { os: operatingSystemType, osIndex } = visit.staticDataEvent.data;
        if (operatingSystemType || typeof osIndex === 'number') {
            const operatingSystem = operatingSystemType !== null && operatingSystemType !== void 0 ? operatingSystemType : OperatingSystemTypeMap[osIndex];
            return new OperatingSystem(operatingSystem);
        }
        return undefined;
    }
};

/**
 * @class
 * Geolocation - a class for creating an instance for geolocation data
 * */
class GeolocationData {
    /**
     * @param {GeolocationInfoType} geolocationInfo - an object containing information about geolocation of a visitor
     * @example
     * ```ts
     * // Visitor is located at Triumph Arch in Paris, France
     * const location: GeolocationDataType = {
     *   country: 'France',
     *   region: 'Île-de-France',
     *   city: 'Paris',
     *   postalCode: '75008',
     *   coordinates: [48.8738, 2.295]
     * };
     *
     * const geolocation = new GeolocationData(location);
     * ```
     *
     * */
    constructor({ country, region, city, postalCode, coordinates, }) {
        this.country = country;
        this.region = region;
        this.city = city;
        this.postalCode = postalCode;
        this.coordinates = coordinates;
        this.status = TrackingStatus.Unsent;
    }
    get url() {
        const region = this.region
            ? UrlParameter.Region + encodeURIComponent(this.region)
            : '';
        const city = this.city
            ? UrlParameter.City + encodeURIComponent(this.city)
            : '';
        const postalCode = this.postalCode
            ? UrlParameter.PostalCode + encodeURIComponent(this.postalCode)
            : '';
        const coordinates = this.coordinates
            ? UrlParameter.Latitude +
                this.coordinates[0] +
                UrlParameter.Longitude +
                this.coordinates[1]
            : '';
        return (UrlEventType.Geolocation +
            UrlParameter.Country +
            encodeURIComponent(this.country) +
            region +
            city +
            postalCode +
            coordinates);
    }
    get data() {
        return {
            type: KameleoonData.GeolocationData,
            country: this.country,
            region: this.region,
            city: this.city,
            postalCode: this.postalCode,
            coordinates: this.coordinates,
            status: this.status,
        };
    }
    /**
     * @private
     * @method _fromRaw - an internal method for creating a GeolocationData instance from raw data
     * @param {GeolocationDataType} data - a raw data
     * @return {GeolocationData} a GeolocationData instance
     * */
    static _fromRaw(data) {
        const { country, region, city, postalCode, coordinates, status } = data;
        const geolocation = new GeolocationData({
            country,
            region,
            city,
            postalCode,
            coordinates,
        });
        geolocation.status = status;
        return geolocation;
    }
    /**
     * @private
     * @method _fromVisit - an internal method for creating an instance of GeolocationData class from a visit
     * @param {VisitType} visit - a visit
     * @returns {GeolocationData | undefined} an instance of GeolocationData class or undefined if geolocation can not be found among visits
     * */
    static _fromVisit(visit) {
        var _a;
        if (!((_a = visit.geolocationEvents) === null || _a === void 0 ? void 0 : _a.length)) {
            return undefined;
        }
        let geolocationData = undefined;
        for (const geolocationEvent of visit.geolocationEvents) {
            const { data } = geolocationEvent;
            if (data.country) {
                geolocationData = data;
            }
        }
        // --- Note ---
        // We only take `country`, `region`, and `city` from geolocation event ignoring other fields
        // as they are not participating in targeting, and visits data won't be tracked again
        const { country, region, city } = geolocationData || {};
        if (country) {
            if (region && city) {
                return new GeolocationData({ country, region, city });
            }
            else if (region) {
                return new GeolocationData({ country, region });
            }
            else {
                return new GeolocationData({ country });
            }
        }
    }
}

/**
 * @class
 * Visits - a class for creating an instance of a stored visits data
 * */
class VisitsData {
    /**
     * @param {number[]} visits - a list of visits
     * */
    constructor(visits) {
        this.status = TrackingStatus.Sent;
        this.visits = visits;
        this._visitNumber = visits.length ? visits.length - 1 : 0;
    }
    get visitNumber() {
        return this._visitNumber;
    }
    get url() {
        return '';
    }
    get data() {
        return {
            visits: this.visits,
            visitNumber: this._visitNumber,
            type: KameleoonData.VisitsData,
            status: this.status,
        };
    }
    get isSent() {
        return true;
    }
    /**
     * Adds a single timestamp while ensuring the list remains sorted and unique
     * @param {VisitDataType} visit - The visit data to be added
     */
    set timestamp(visit) {
        ListUtilities.insertVisitInOrderedListMutably({
            list: this.visits,
            visit,
        });
        this._visitNumber = this.visits.length ? this.visits.length - 1 : 0;
    }
    updateVisitNumber(visitNumber) {
        if (visitNumber > this._visitNumber) {
            this._visitNumber = visitNumber;
        }
    }
}

/**
 * @class
 * KameleoonConversionScore - a class for creating an KCS Heat Range data
 * */
class KameleoonConversionScore {
    /**
     * @param {KCSType} kcs - Kameleoon Conversion Score nested object
     * */
    constructor(kcs) {
        this.kcs = kcs;
        this.status = TrackingStatus.Sent;
    }
    get url() {
        return '';
    }
    get data() {
        return {
            kcs: this.kcs,
            type: KameleoonData.KameleoonConversionScore,
            status: this.status,
        };
    }
}

class Personalization {
    /**
     * @param {number} id
     * @param {number} variationId
     * */
    constructor(id, variationId, assignedTime = Date.now()) {
        this.id = id;
        this.variationId = variationId;
        this.status = TrackingStatus.Sent;
        this.assignedTime = assignedTime;
    }
    get url() {
        return '';
    }
    get data() {
        return {
            id: this.id,
            variationId: this.variationId,
            type: KameleoonData.Personalization,
            status: TrackingStatus.Sent,
            assignedTime: this.assignedTime,
        };
    }
    /**
     * @private
     * @method _fromRaw - an internal method for creating a Personalization instance from raw data
     * @param {PersonalizationDataType} data - a raw data
     * @return {Personalization} a Personalization instance
     * */
    static _fromRaw(data) {
        return new Personalization(data.id, data.variationId, data.assignedTime);
    }
    /**
     * @private
     * @method _updateFromVisit - an internal method for updating a list of Personalization instances
     * @param {VisitType} visit - a visits
     * @param {Map<number, Personalization>} dataMap - a map of Personalization instances
     * */
    static _updateFromVisit(visit, dataMap) {
        var _a;
        if ((_a = visit.personalizationEvents) === null || _a === void 0 ? void 0 : _a.length) {
            for (const personalizationEvent of visit.personalizationEvents) {
                const { id, variationId } = personalizationEvent.data;
                if (!dataMap.has(id)) {
                    const personalization = new Personalization(id, variationId, personalizationEvent.time);
                    dataMap.set(id, personalization);
                }
            }
        }
    }
}

class CBScores {
    constructor(cbsMap) {
        this.values = new Map(Object.entries(cbsMap).map(([key, value]) => [
            Number(key),
            this.extractVarIds(value),
        ]));
        this.cbs = cbsMap;
        this.status = TrackingStatus.Sent;
    }
    extractVarIds(scores) {
        // keys = experiment IDs / values = list of variation IDs ordered descending
        // by score (there may be several variation ids with same score)
        const grouped = new Map();
        Object.entries(scores).forEach(([variationId, score]) => {
            if (!grouped.has(score)) {
                grouped.set(score, []);
            }
            grouped.get(score).push(Number(variationId));
        });
        return Array.from(grouped.entries())
            .sort(([scoreA], [scoreB]) => scoreB - scoreA)
            .map(([, ids]) => ({ ids: ids.sort((a, b) => a - b) }));
    }
    getValues() {
        return this.values;
    }
    get url() {
        return '';
    }
    get data() {
        return {
            cbs: this.cbs,
            type: KameleoonData.CBScores,
            status: this.status,
        };
    }
    static _fromRaw(data) {
        const cbScores = new CBScores(data.cbs);
        cbScores.status = data.status;
        return cbScores;
    }
}

class VisitProcessor {
    constructor({ filters, dataManager, visitorCode, }) {
        this.visitsData = new VisitsData([]);
        this.visitorData = [];
        this.storageVisitorData = [];
        this.experimentData = {};
        this.singleDataTypes = {
            [KameleoonData.Device]: null,
            [KameleoonData.Browser]: null,
            [KameleoonData.GeolocationData]: null,
            [KameleoonData.OperatingSystem]: null,
            [KameleoonData.KameleoonConversionScore]: null,
            [KameleoonData.CBScores]: null,
        };
        this.multipleDataTypes = {
            [KameleoonData.CustomData]: new Map(),
            [KameleoonData.PageView]: new Map(),
            [KameleoonData.Conversion]: new Map(),
            [KameleoonData.Personalization]: new Map(),
        };
        this.filters = filters;
        this.dataManager = dataManager;
        this.visitorDataTypes = dataManager.getVisitorStoredDataTypes(visitorCode);
    }
    get data() {
        return {
            visitorData: this.visitorData,
            storageVisitorData: this.storageVisitorData,
            visitsData: this.visitsData,
            experimentData: this.experimentData,
        };
    }
    processVisit(visit) {
        this.processBrowser(visit);
        this.processDevice(visit);
        this.processOperatingSystem(visit);
        this.processGeolocationData(visit);
        this.processCustomData(visit);
        this.processConversion(visit);
        this.processPageView(visit);
        this.processExperiments(visit);
        this.processPersonalization(visit);
    }
    processMultipleDataTypes() {
        for (const [dataType, data] of Object.entries(this.multipleDataTypes)) {
            if (!data.size) {
                continue;
            }
            switch (dataType) {
                case KameleoonData.PageView: {
                    this.visitorData.push(...data.values());
                    this.storageVisitorData.push(...data.values());
                    break;
                }
                case KameleoonData.Personalization:
                case KameleoonData.Conversion: {
                    this.storageVisitorData.push(...data.values());
                    break;
                }
                case KameleoonData.CustomData: {
                    const dataItem = data;
                    dataItem.forEach((customData) => {
                        this.visitorData.push(customData);
                        if (!this.dataManager.storedCustomDataIndexes.has(customData.data.index)) {
                            this.storageVisitorData.push(customData);
                        }
                    });
                    break;
                }
            }
        }
    }
    processKcs(kcsData) {
        if (this.filters.kcs && kcsData) {
            const kcs = new KameleoonConversionScore(kcsData);
            this.storageVisitorData.push(kcs);
        }
    }
    processVisitsData(visit) {
        var _a;
        this.visitsData.timestamp = {
            timeStarted: visit.timeStarted,
            timeLastActivity: (_a = visit.timeLastEvent) !== null && _a !== void 0 ? _a : visit.timeStarted,
        };
    }
    processVisitNumber(visit, visitOffset) {
        var _a, _b, _c;
        if (this.visitsData.visitNumber <= visitOffset &&
            ((_a = visit.staticDataEvent) === null || _a === void 0 ? void 0 : _a.data.visitNumber)) {
            const visitNumber = (_c = (_b = visit.staticDataEvent) === null || _b === void 0 ? void 0 : _b.data.visitNumber) !== null && _c !== void 0 ? _c : 0;
            this.visitsData.updateVisitNumber(visitNumber + visitOffset);
        }
    }
    processCbs(cbsData) {
        if (this.filters.cbs && cbsData) {
            const cbs = new CBScores(cbsData);
            this.storageVisitorData.push(cbs);
        }
    }
    processBrowser(visit) {
        if (this.filters.browser && !this.singleDataTypes[KameleoonData.Browser]) {
            const browser = Browser$1._fromVisit(visit);
            if (browser) {
                if (!this.visitorDataTypes.has(KameleoonData.Browser)) {
                    this.storageVisitorData.push(browser);
                }
                this.visitorData.push(browser);
                this.singleDataTypes[KameleoonData.Browser] = browser;
            }
        }
    }
    processDevice(visit) {
        if (this.filters.device && !this.singleDataTypes[KameleoonData.Device]) {
            const device = Device$1._fromVisit(visit);
            if (device) {
                if (!this.visitorDataTypes.has(KameleoonData.Device)) {
                    this.storageVisitorData.push(device);
                }
                this.visitorData.push(device);
                this.singleDataTypes[KameleoonData.Device] = device;
            }
        }
    }
    processOperatingSystem(visit) {
        if (this.filters.operatingSystem &&
            !this.singleDataTypes[KameleoonData.OperatingSystem]) {
            const operatingSystem = OperatingSystem$1._fromVisit(visit);
            if (operatingSystem) {
                if (!this.visitorDataTypes.has(KameleoonData.OperatingSystem)) {
                    this.storageVisitorData.push(operatingSystem);
                }
                this.visitorData.push(operatingSystem);
                this.singleDataTypes[KameleoonData.OperatingSystem] = operatingSystem;
            }
        }
    }
    processGeolocationData(visit) {
        if (this.filters.geolocation &&
            !this.singleDataTypes[KameleoonData.GeolocationData]) {
            const geolocation = GeolocationData._fromVisit(visit);
            if (geolocation) {
                if (!this.visitorDataTypes.has(KameleoonData.GeolocationData)) {
                    this.storageVisitorData.push(geolocation);
                }
                this.visitorData.push(geolocation);
                this.singleDataTypes[KameleoonData.GeolocationData] = geolocation;
            }
        }
    }
    processCustomData(visit) {
        if (this.filters.customData) {
            CustomData$1._updateFromVisit(visit, this.multipleDataTypes[KameleoonData.CustomData]);
        }
    }
    processConversion(visit) {
        if (this.filters.conversions) {
            // --- Note ---
            // We collect Conversion data with only unique goalId
            Conversion$1._updateFromVisit(visit, this.multipleDataTypes[KameleoonData.Conversion]);
            // --- Note ---
            // We collect all Conversion data with goalId, revenue and negative for all visits
            const conversions = Conversion$1._listFromVisit(visit);
            if (conversions.length) {
                this.visitorData.push(...conversions);
            }
        }
    }
    processPageView(visit) {
        if (this.filters.pageViews) {
            PageView._updateFromVisit(visit, this.multipleDataTypes[KameleoonData.PageView]);
        }
    }
    processExperiments(visit) {
        if (this.filters.experiments && visit.experimentEvents) {
            for (const experimentEvent of visit.experimentEvents) {
                const { id, variationId } = experimentEvent.data;
                this.experimentData[id] = {
                    variationId,
                    isTargetedRule: false,
                    status: TrackingStatus.Unsent,
                    assignedTime: experimentEvent.time,
                };
            }
        }
    }
    processPersonalization(visit) {
        if (this.filters.personalization) {
            Personalization._updateFromVisit(visit, this.multipleDataTypes[KameleoonData.Personalization]);
        }
    }
    processMappingIdentifier(visit) {
        var _a, _b;
        if (!visit) {
            return;
        }
        const timestamp = (_b = (_a = visit.customDataEvents) === null || _a === void 0 ? void 0 : _a.find((event) => event.data.mappingIdentifier)) === null || _b === void 0 ? void 0 : _b.time;
        if (timestamp && visit.visitorCode) {
            return {
                mappingIdentifier: visit.visitorCode,
                timestamp,
            };
        }
    }
}

class Parser {
    static parseFeatureVariable(variable) {
        const { key, type, value } = variable;
        switch (type) {
            case VariableType.BOOLEAN:
                return buildExports.Ok({
                    key,
                    type,
                    value: Boolean(value),
                });
            case VariableType.JS:
            case VariableType.CSS:
            case VariableType.STRING:
                return buildExports.Ok({
                    key,
                    type,
                    value: String(value),
                });
            case VariableType.NUMBER:
                const numberValue = Number(value);
                if (Number.isNaN(numberValue)) {
                    return buildExports.Err(new KameleoonError(KameleoonException.NumberParse, String(value)));
                }
                return buildExports.Ok({
                    key,
                    type,
                    value: numberValue,
                });
            case VariableType.JSON:
                try {
                    const jsonValue = JSON.parse(String(variable.value));
                    return buildExports.Ok({
                        key,
                        type,
                        value: jsonValue,
                    });
                }
                catch (err) {
                    return buildExports.Err(new KameleoonError(KameleoonException.JSONParse, err));
                }
            default:
                exhaustCheck(type);
        }
    }
    static parseVisitorData({ data, filters, visitorCode, dataManager, variationConfiguration, }) {
        const visitProcessor = new VisitProcessor({
            filters,
            dataManager,
            visitorCode,
        });
        const { currentVisit, previousVisits, kcs, cbs } = data;
        if (!(previousVisits === null || previousVisits === void 0 ? void 0 : previousVisits.length) && !currentVisit) {
            return {
                visitorData: [],
                storageVisitorData: [],
                visitsData: new VisitsData([]),
            };
        }
        if (currentVisit) {
            visitProcessor.processVisit(currentVisit);
            visitProcessor.processVisitNumber(currentVisit, 0);
        }
        previousVisits === null || previousVisits === void 0 ? void 0 : previousVisits.forEach((visit, index) => {
            visitProcessor.processVisit(visit);
            visitProcessor.processVisitsData(visit);
            visitProcessor.processVisitNumber(visit, index + 1);
        });
        visitProcessor.processKcs(kcs);
        visitProcessor.processCbs(cbs);
        visitProcessor.processMultipleDataTypes();
        const mappingIdentifier = visitProcessor.processMappingIdentifier(currentVisit !== null && currentVisit !== void 0 ? currentVisit : previousVisits === null || previousVisits === void 0 ? void 0 : previousVisits[0]);
        const { visitorData, storageVisitorData, visitsData, experimentData } = visitProcessor.data;
        variationConfiguration.updateStoredVariations(visitorCode, experimentData);
        return {
            visitorData,
            storageVisitorData,
            visitsData,
            mappingIdentifier,
        };
    }
    static parseRegExp(value) {
        if (value[0] === '/') {
            const [_, expression, flags] = value.split('/');
            return new RegExp(expression, flags);
        }
        return new RegExp(value);
    }
    static parseSecret(secret) {
        if (secret === null) {
            return 'null';
        }
        const length = secret.length;
        if (length <= SECRET_VISIBLE_LENGTH) {
            return HIDDEN_SECRET_CHAR.repeat(length);
        }
        const hiddenLength = Math.max(length - SECRET_VISIBLE_LENGTH, SECRET_VISIBLE_LENGTH);
        return (secret.substring(0, length - hiddenLength) +
            HIDDEN_SECRET_CHAR.repeat(hiddenLength));
    }
}

class ClientConfiguration {
    constructor({ updateInterval, urlProvider, storage, requester, dataManager, eventSource, externalVisitorCodeManager, eventManager, externalPackageInfo, defaultDataFile, }) {
        this.updateConfigurationIntervalId = null;
        this.updateType = 0 /* UpdateType.Polling */;
        this.configurationData = DEFAULT_DATA_FILE_CONFIGURATION;
        this.featureFlagsData = new Map();
        this.isTargetedDeliveryRule = null;
        this.segmentsData = null;
        this.holdoutData = null;
        this.meGroupsData = new Map();
        this.mappedRules = null;
        this.mappedExperiments = null;
        this.usedDefaultDataFile = false;
        this.isRefreshingDataFile = false;
        this.blockingBehaviourMode = "PARTIALLY_BLOCK" /* ConsentBlockingBehaviour.PartiallyBlocked */;
        this.cachedDataFile = null;
        this.CACHE_REVALIDATE_PERIOD = 90 * 60000 /* Milliseconds.Minute */;
        this.urlProvider = urlProvider;
        this.requester = requester;
        this.updateInterval = updateInterval;
        this.lastUpdate = new Date();
        this.storage = storage;
        this.dataManager = dataManager;
        this.eventManager = eventManager;
        this.visitorCodeManager = externalVisitorCodeManager;
        this.eventSource = eventSource;
        this.externalPackageInfo = externalPackageInfo;
        this.defaultDataFile = defaultDataFile;
    }
    initialize() {
        return __awaiter(this, void 0, void 0, function* () {
            KameleoonLogger.debug('CALL: ClientConfiguration.initialize()');
            this.readStorageData();
            const shouldUpdate = this.checkShouldUpdate();
            if (shouldUpdate) {
                const updateResult = yield this.updateClientConfiguration();
                if (!updateResult.ok) {
                    KameleoonLogger.error('Error occurred during client configuration update');
                    return updateResult;
                }
                // --- Note ---
                // If update type is being toggled `initialize` will be called again
                // so we don't need to continue execution here
                const isUpdateTypeToggled = updateResult.data;
                if (isUpdateTypeToggled) {
                    KameleoonLogger.debug('RETURN: ClientConfiguration.initialize()');
                    return buildExports.Ok();
                }
            }
            if (this.updateType === 1 /* UpdateType.RealTime */ && !this.eventSource.isOpen) {
                this.handleRealTimeUpdates();
                KameleoonLogger.debug('RETURN: ClientConfiguration.initialize()');
                return buildExports.Ok();
            }
            if (this.updateType === 0 /* UpdateType.Polling */) {
                this.handlePollingUpdates();
            }
            KameleoonLogger.debug('RETURN: ClientConfiguration.initialize()');
            return buildExports.Ok();
        });
    }
    refreshDataFileIfStale() {
        if (this.isRefreshingDataFile || !this.checkShouldUpdate()) {
            return Promise.resolve(buildExports.Ok(false));
        }
        this.isRefreshingDataFile = true;
        return this.fetchClientConfiguration()
            .then((result) => (result.ok ? buildExports.Ok(true) : result))
            .finally(() => {
            this.isRefreshingDataFile = false;
        });
    }
    cleanupHandlers() {
        if (this.eventSource.isOpen) {
            this.eventSource.close();
        }
        if (this.updateConfigurationIntervalId) {
            clearInterval(this.updateConfigurationIntervalId);
        }
    }
    handleRealTimeUpdates() {
        this.cleanupHandlers();
        const updateEventCallback = (timestamp) => {
            this.updateClientConfiguration(timestamp).then((updateResult) => {
                if (updateResult.ok) {
                    this.eventManager.fireEvent(EventType.ConfigurationUpdate, {
                        timestamp,
                    });
                }
            });
        };
        this.eventSource.open(updateEventCallback);
        this.eventSource.onError((error) => {
            KameleoonLogger.error `Error occurred during real-time update: ${error}. Switching to polling updates while the connection is not restored.`;
            this.updateType = 0 /* UpdateType.Polling */;
            this.handlePollingUpdates();
        });
    }
    handlePollingUpdates() {
        // --- Note ---
        // If `initialize` is called again the interval will be cleared
        // so theoretically we will constantly defer config update
        // but `this.lastUpdate` with `checkShouldUpdate` will prevent that
        this.cleanupHandlers();
        // --- Note ---
        // Error Handling is for `setInterval` emergency cleanup
        try {
            const lastUpdateTime = this.lastUpdate.getTime();
            const now = Date.now();
            const timeToNextUpdate = Math.max(this.updateInterval - (now - lastUpdateTime), 0);
            setTimeout(() => __awaiter(this, void 0, void 0, function* () {
                yield this.updateClientConfiguration();
                this.updateConfigurationIntervalId = setInterval(this.updateClientConfiguration.bind(this), this.updateInterval);
            }), timeToNextUpdate);
        }
        catch (err) {
            if (this.updateConfigurationIntervalId) {
                clearInterval(this.updateConfigurationIntervalId);
            }
            throw err;
        }
    }
    get featureFlags() {
        return this.featureFlagsData;
    }
    get dataFile() {
        if (this.cachedDataFile) {
            return this.cachedDataFile;
        }
        const dataFile = {
            featureFlags: new Map(),
            dateModified: this.dateModified,
        };
        this.featureFlagsData.forEach((featureFlag, key) => {
            const variationsMap = new Map();
            featureFlag.variations.forEach((sourceVariation) => {
                var _a;
                const variablesMap = new Map();
                sourceVariation.variables.forEach((variable) => {
                    try {
                        const parsedVariable = Parser.parseFeatureVariable(variable).throw();
                        variablesMap.set(variable.key, parsedVariable);
                    }
                    catch (err) {
                        KameleoonLogger.error `Error parsing variable ${variable.key} of feature flag ${featureFlag.featureKey}: ${err}`;
                    }
                });
                variationsMap.set(sourceVariation.key, {
                    name: (_a = sourceVariation.name) !== null && _a !== void 0 ? _a : '',
                    key: sourceVariation.key,
                    id: null,
                    experimentId: null,
                    variables: variablesMap,
                });
            });
            const rules = featureFlag.rules.map((rule) => {
                const ruleVariations = new Map();
                rule.variationByExposition.forEach((varByExp) => {
                    const baseVariation = variationsMap.get(varByExp.variationKey);
                    if (!baseVariation)
                        return;
                    ruleVariations.set(baseVariation.key, {
                        name: baseVariation.name,
                        key: baseVariation.key,
                        id: varByExp.variationId,
                        experimentId: rule.experimentId,
                        variables: baseVariation.variables,
                    });
                });
                return { variations: ruleVariations };
            });
            dataFile.featureFlags.set(key, {
                variations: variationsMap,
                environmentEnabled: featureFlag.environmentEnabled,
                rules,
                defaultVariationKey: featureFlag.defaultVariationKey,
            });
        });
        this.cachedDataFile = dataFile;
        return dataFile;
    }
    get configuration() {
        return this.configurationData.configuration;
    }
    get dateModified() {
        var _a;
        return (_a = this.configurationData.dateModified) !== null && _a !== void 0 ? _a : 0;
    }
    get segments() {
        if (this.segmentsData) {
            return this.segmentsData;
        }
        const segmentsData = new Map();
        this.featureFlagsData.forEach((flag) => {
            flag.rules.forEach((rule) => {
                if (rule.segment && !segmentsData.has(rule.segment.id.toString())) {
                    segmentsData.set(rule.segment.id.toString(), rule.segment);
                }
            });
        });
        this.segmentsData = segmentsData;
        return segmentsData;
    }
    get ruleMap() {
        var _a;
        if ((_a = this.mappedRules) === null || _a === void 0 ? void 0 : _a.size) {
            return this.mappedRules;
        }
        const mappedRules = new Map();
        for (const featureFlag of this.featureFlags.values()) {
            for (const rule of featureFlag.rules) {
                const { id, experimentId, variationByExposition } = rule;
                const variationMap = new Map();
                variationByExposition.forEach(({ variationKey, variationId }) => {
                    if (typeof variationId === 'number') {
                        variationMap.set(variationKey, variationId);
                    }
                });
                mappedRules.set(id, {
                    featureId: featureFlag.id,
                    experimentId,
                    variations: variationMap,
                });
            }
        }
        this.mappedRules = mappedRules;
        return mappedRules;
    }
    get experimentMap() {
        var _a;
        if ((_a = this.mappedExperiments) === null || _a === void 0 ? void 0 : _a.size) {
            return this.mappedExperiments;
        }
        const mappedExperiments = new Map();
        for (const featureFlag of this.featureFlags.values()) {
            const hasJsCssVariables = this.hasFeatureFlagVariableJsCss(featureFlag);
            for (const rule of featureFlag.rules) {
                const { experimentId, variationByExposition } = rule;
                const variationMap = new Map();
                variationByExposition.forEach(({ variationKey, variationId }) => {
                    if (typeof variationId === 'number') {
                        variationMap.set(variationKey, variationId);
                    }
                });
                mappedExperiments.set(experimentId, {
                    type: rule.type,
                    variations: variationMap,
                    hasJsCssVariables,
                });
            }
        }
        this.mappedExperiments = mappedExperiments;
        return mappedExperiments;
    }
    hasFeatureFlagVariableJsCss(featureFlag) {
        var _a;
        return Boolean((_a = featureFlag.variations[0]) === null || _a === void 0 ? void 0 : _a.variables.some(({ type }) => type === VariableType.JS || type === VariableType.CSS));
    }
    get holdout() {
        return this.holdoutData;
    }
    get meGroups() {
        return this.meGroupsData;
    }
    get isConsentRequired() {
        return this.configuration.consentType === "REQUIRED" /* ConsentType.Required */;
    }
    get consentBlockingBehaviour() {
        return this.blockingBehaviourMode;
    }
    get hasAnyTargetedDeliveryRule() {
        if (this.isTargetedDeliveryRule !== null) {
            return this.isTargetedDeliveryRule;
        }
        for (const featureFlag of this.featureFlags.values()) {
            if (featureFlag.environmentEnabled &&
                featureFlag.rules.some((rule) => rule.type === "TARGETED_DELIVERY" /* RuleType.TARGETED_DELIVERY */)) {
                return true;
            }
        }
        return false;
    }
    checkShouldUpdate() {
        const { configuration } = this.configurationData;
        this.updateType = configuration.realTimeUpdate
            ? 1 /* UpdateType.RealTime */
            : 0 /* UpdateType.Polling */;
        if (!this.featureFlags.size) {
            return true;
        }
        const lastUpdateTime = this.lastUpdate.getTime();
        const updateWindowEdge = Date.now() - this.updateInterval;
        return lastUpdateTime < updateWindowEdge;
    }
    readStorageData() {
        var _a, _b, _c;
        KameleoonLogger.debug('CALL: ClientConfiguration.readStorageData()');
        const result = this.storage.read();
        if (result.ok) {
            let { data, lastUpdate, lastModified, requestTime } = result.data;
            let updateFeatureFlagsInfo = false;
            if (this.defaultDataFile) {
                try {
                    const defaultDataFile = JSON.parse(this.defaultDataFile);
                    this.defaultDataFile = undefined;
                    this.usedDefaultDataFile = true;
                    const localDateModified = (_b = (_a = data.dateModified) !== null && _a !== void 0 ? _a : requestTime) !== null && _b !== void 0 ? _b : -1;
                    const defaultDateModified = (_c = defaultDataFile.dateModified) !== null && _c !== void 0 ? _c : 0;
                    if (!requestTime || defaultDateModified > localDateModified) {
                        data = defaultDataFile;
                        updateFeatureFlagsInfo = true;
                    }
                }
                catch (error) {
                    KameleoonLogger.error `Error parsing default data file: ${String(error)}`;
                }
            }
            this.updateConfigurationData(data, updateFeatureFlagsInfo);
            this.lastUpdate = this.usedDefaultDataFile
                ? new Date(0)
                : new Date(Date.parse(lastUpdate));
            this.lastModified = lastModified;
            this.requestTime = requestTime;
        }
        KameleoonLogger.debug `RETURN: ClientConfiguration.readStorageData() -> (result: ${result.ok})`;
    }
    /**
     * Updates client configuration
     *
     * @param timeStamp - timestamp for real-time configuration update
     *
     * @returns `true` if current update type should be toggled (SSE/Polling)
     */
    updateClientConfiguration(timestamp) {
        return __awaiter(this, void 0, void 0, function* () {
            const currentTime = Date.now();
            if (this.usedDefaultDataFile) {
                this.updateClientConfigurationInBackground();
                return buildExports.Ok(false);
            }
            if (this.requestTime && !timestamp && !this.externalPackageInfo.isServer) {
                if (currentTime - this.requestTime <= this.CACHE_REVALIDATE_PERIOD) {
                    this.updateClientConfigurationInBackground();
                    return buildExports.Ok(false);
                }
                else {
                    KameleoonLogger.debug `Cached configuration data has expired. Fetching fresh data.`;
                }
            }
            return this.fetchClientConfiguration(timestamp);
        });
    }
    fetchClientConfiguration(timestamp) {
        return __awaiter(this, void 0, void 0, function* () {
            const clientConfigurationResult = yield this.requester.getClientConfiguration(timestamp, this.lastModified);
            return this.applyNewConfigurationDataFromResponse(clientConfigurationResult);
        });
    }
    updateClientConfigurationInBackground() {
        setTimeout(() => __awaiter(this, void 0, void 0, function* () {
            const clientConfigurationResult = yield this.requester.getClientConfiguration(undefined, this.lastModified);
            yield this.applyNewConfigurationDataFromResponse(clientConfigurationResult);
        }), 0);
    }
    applyNewConfigurationDataFromResponse(clientConfigurationResult) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            this.requestTime = Date.now();
            if (!clientConfigurationResult.ok) {
                if (this.featureFlags.size) {
                    KameleoonLogger.error('Error occurred while updating configuration. Existing configuration will be used as a fallback.');
                    return buildExports.Ok(true);
                }
                return clientConfigurationResult;
            }
            if (clientConfigurationResult.data.configuration === undefined) {
                // If configuration is undefined, it means that the server returned 304 Not Modified
                // and we should not update the configuration, but need to update the lastUpdate in storage
                this.updateStorageData();
                return buildExports.Ok(false);
            }
            const clientConfigurationData = clientConfigurationResult.data.configuration;
            this.updateConfigurationData(clientConfigurationData, true);
            this.dataManager.clearTrees();
            (_a = this.mappedRules) === null || _a === void 0 ? void 0 : _a.clear();
            (_b = this.experimentMap) === null || _b === void 0 ? void 0 : _b.clear();
            this.isTargetedDeliveryRule = null;
            if (clientConfigurationResult.data.lastModified) {
                this.lastModified = clientConfigurationResult.data.lastModified;
            }
            const result = this.updateStorageData();
            if (!result.ok) {
                return result;
            }
            const updateType = clientConfigurationData.configuration.realTimeUpdate
                ? 1 /* UpdateType.RealTime */
                : 0 /* UpdateType.Polling */;
            const toggleUpdateType = updateType !== this.updateType;
            if (toggleUpdateType) {
                this.updateType = updateType;
                KameleoonLogger.info `Configuration update type was toggled to ${updateType}`;
                yield this.initialize();
            }
            this.blockingBehaviourMode = this.consentBlockingBehaviourFromStr(clientConfigurationData.configuration.consentOptOutBehavior);
            return buildExports.Ok(toggleUpdateType);
        });
    }
    updateConfigurationData(data, updateFeatureFlagsInfo = true) {
        const { configuration, featureFlags, customData, holdout, segments, dateModified, } = data;
        let segmentsMap = segments
            ? new Map(segments.map((segment) => [segment.id.toString(), segment]))
            : null;
        let customDataIndexById = null;
        if (updateFeatureFlagsInfo) {
            if (customData === null || customData === void 0 ? void 0 : customData.length) {
                customDataIndexById = new Map();
                for (let data of customData) {
                    if (data.id !== undefined) {
                        customDataIndexById.set(data.id, data.index);
                    }
                    else {
                        customDataIndexById = null;
                        break;
                    }
                }
            }
        }
        const featureFlagsMap = new Map();
        for (const featureFlag of featureFlags) {
            featureFlagsMap.set(featureFlag.featureKey, featureFlag);
            // configurationFeatureFlag data from storage not needed to be modified
            if (updateFeatureFlagsInfo) {
                this.updateFeatureFlagSegments(featureFlag, segmentsMap);
                this.updateFeatureFlagBucketingCustomDataId(featureFlag, customDataIndexById);
            }
        }
        this.featureFlagsData = featureFlagsMap;
        if (customData === null || customData === void 0 ? void 0 : customData.length) {
            this.dataManager.customDataIndexes = customData;
        }
        this.meGroupsData = this.makeMEGroups(featureFlags);
        this.holdoutData = holdout !== null && holdout !== void 0 ? holdout : null;
        this.configurationData = {
            configuration,
            customData,
            holdout,
            dateModified,
        };
        this.urlProvider.dataApiDomain = data.configuration.dataApiDomain;
        this.updateConsentRequired();
        this.segmentsData = segmentsMap;
        this.cachedDataFile = null;
    }
    updateFeatureFlagSegments(featureFlag, segmentsMap) {
        if (segmentsMap !== null) {
            featureFlag.rules.forEach((rule) => {
                var _a;
                const segmentId = rule.segmentId;
                rule.segment =
                    segmentId == null
                        ? null
                        : (_a = segmentsMap.get(segmentId.toString())) !== null && _a !== void 0 ? _a : null;
            });
        }
    }
    updateFeatureFlagBucketingCustomDataId(featureFlag, customDataIndexById) {
        const bucketingCustomDataId = featureFlag.bucketingCustomDataId;
        if (bucketingCustomDataId != null && customDataIndexById) {
            featureFlag.bucketingCustomDataIndex = customDataIndexById.get(bucketingCustomDataId);
        }
    }
    makeMEGroups(featureFlags) {
        const meGroupLists = new Map();
        featureFlags.forEach((featureFlag) => {
            const groupName = featureFlag.mutuallyExclusiveGroup;
            if (groupName) {
                let meGroupList = meGroupLists.get(groupName);
                if (meGroupList) {
                    meGroupList.push(featureFlag);
                }
                else {
                    meGroupLists.set(groupName, [featureFlag]);
                }
            }
        });
        const meGroups = new Map();
        meGroupLists.forEach((featureFlags, groupName) => {
            meGroups.set(groupName, new MEGroup(featureFlags));
        });
        return meGroups;
    }
    updateStorageData() {
        this.lastUpdate = new Date();
        const configurationData = Object.assign(Object.assign({}, this.configurationData), { featureFlags: Array.from(this.featureFlags.values()), segments: this.segmentsData
                ? Array.from(this.segmentsData.values())
                : undefined });
        const data = {
            data: configurationData,
            lastUpdate: this.lastUpdate.toString(),
            lastModified: this.lastModified,
            requestTime: this.requestTime,
        };
        return this.storage.write(data);
    }
    updateConsentRequired() {
        // --- Note ---
        // According to GDPR policy we should set visitorCode if legal consent isn't required
        // or we have at least one Targeted Delivery rule in configuration
        this.visitorCodeManager.consentRequired =
            this.isConsentRequired && !this.hasAnyTargetedDeliveryRule;
    }
    consentBlockingBehaviourFromStr(str) {
        if (str === "PARTIALLY_BLOCK" /* ConsentBlockingBehaviour.PartiallyBlocked */ ||
            str === "FULLY_BLOCK" /* ConsentBlockingBehaviour.CompletelyBlocked */) {
            return str;
        }
        KameleoonLogger.error(`Unexpected consent blocking type '${str}'`);
        return "PARTIALLY_BLOCK" /* ConsentBlockingBehaviour.PartiallyBlocked */;
    }
}

var _a;
class ClientSettings {
    constructor(siteCode, configuration) {
        KameleoonLogger.debug `CALL: new ClientSettings(siteCode: ${siteCode}, configuration: ${configuration})`;
        this.siteCode = siteCode;
        this.environment = this.getEnvironment(configuration);
        this.networkDomain = this.getNetworkDomain(configuration);
        this.updateInterval = this.getUpdateInterval(configuration);
        this.cleanupInterval = this.getCleanupInterval(configuration);
        this.requestTimeout = this.getRequestTimeout(configuration);
        this.trackingInterval = this.getTrackingInterval(configuration);
        this.trackRetryDelay = 5 * 1000 /* Milliseconds.Second */;
        KameleoonLogger.debug `RETURN: new ClientSettings(siteCode: ${siteCode}, configuration: ${configuration})`;
    }
    getTrackingInterval(configuration) {
        const { MIN_TRACKING_INTERVAL_MS, MAX_TRACKING_INTERVAL_MS, DEFAULT_TRACKING_INTERVAL_MS, } = ClientSettings;
        if (typeof (configuration === null || configuration === void 0 ? void 0 : configuration.trackingInterval) === 'number') {
            if (configuration.trackingInterval < MIN_TRACKING_INTERVAL_MS) {
                KameleoonLogger.warning(`Tracking interval must not be shorter than ${MIN_TRACKING_INTERVAL_MS} ms. Minimum possible interval was applied.`);
                return MIN_TRACKING_INTERVAL_MS;
            }
            if (configuration.trackingInterval > MAX_TRACKING_INTERVAL_MS) {
                KameleoonLogger.warning(`Tracking interval must not be longer than ${MAX_TRACKING_INTERVAL_MS} ms. Maximum possible interval was applied.`);
                return MAX_TRACKING_INTERVAL_MS;
            }
            return configuration.trackingInterval;
        }
        return DEFAULT_TRACKING_INTERVAL_MS;
    }
    getEnvironment(configuration) {
        if (configuration === null || configuration === void 0 ? void 0 : configuration.environment) {
            return configuration.environment;
        }
        return Environment.Production;
    }
    getCleanupInterval(configuration) {
        if (typeof (configuration === null || configuration === void 0 ? void 0 : configuration.targetingDataCleanupInterval) === 'number') {
            if (configuration.targetingDataCleanupInterval < 1) {
                KameleoonLogger.warning('Targeting data cleanup interval must not be shorter than 1 minute. Minimum possible interval was applied.');
                return 1 * 60000 /* Milliseconds.Minute */;
            }
            return configuration.targetingDataCleanupInterval * 60000 /* Milliseconds.Minute */;
        }
        return null;
    }
    getUpdateInterval(configuration) {
        if (typeof (configuration === null || configuration === void 0 ? void 0 : configuration.updateInterval) === 'number') {
            if (configuration.updateInterval < 1) {
                KameleoonLogger.warning('Update interval must not be shorter than 1 minute. Minimum possible interval was applied.');
                return 1 * 60000 /* Milliseconds.Minute */;
            }
            return configuration.updateInterval * 60000 /* Milliseconds.Minute */;
        }
        return 60 * 60000 /* Milliseconds.Minute */;
    }
    getNetworkDomain(configuration) {
        const result = Validator.validateNetworkDomain(configuration === null || configuration === void 0 ? void 0 : configuration.networkDomain);
        if (!result.ok) {
            return null;
        }
        return result.data;
    }
    getRequestTimeout(configuration) {
        if (typeof (configuration === null || configuration === void 0 ? void 0 : configuration.requestTimeout) === 'number') {
            return configuration.requestTimeout;
        }
        return 10 * 1000 /* Milliseconds.Second */;
    }
    get settings() {
        return {
            trackingInterval: this.trackingInterval,
            trackRetryDelay: this.trackRetryDelay,
            cleanupInterval: this.cleanupInterval,
            updateInterval: this.updateInterval,
            requestTimeout: this.requestTimeout,
            networkDomain: this.networkDomain,
            environment: this.environment,
            siteCode: this.siteCode,
        };
    }
}
_a = ClientSettings;
ClientSettings.DEFAULT_TRACKING_INTERVAL_MS = 1000;
ClientSettings.MIN_TRACKING_INTERVAL_MS = _a.DEFAULT_TRACKING_INTERVAL_MS;
ClientSettings.MAX_TRACKING_INTERVAL_MS = 5000;

const OFF_VARIATION_KEY = 'off';
const WAREHOUSE_AUDIENCE_KEY = 'warehouseAudiences';
const HYBRID_TRACKING_CODE_EXPIRATION_PERIOD = 5000;
const IN_HOLDOUT_VARIATION_KEY = 'in-holdout';
/**
 * @readonly
 * @enum {string} an Enum of the JS supported Kameleoon SDK types
 * */
const SdkLanguageType = {
    NODEJS: 'NODEJS',
    REACT: 'REACT',
    JAVASCRIPT: 'JAVASCRIPT',
};
const DEFAULT_VISITOR_DATA_FILTERS = {
    previousVisitAmount: 1,
    currentVisit: true,
    customData: true,
    pageViews: false,
    geolocation: false,
    device: false,
    browser: false,
    operatingSystem: false,
    conversions: false,
    experiments: false,
    kcs: false,
    visitorCode: true,
    personalization: false,
};

/**
 * @class
 * Cookie - a class for creating an instance for defining user's cookie
 * */
let Cookie$1 = class Cookie {
    /**
     * @param {CookieType[]} cookie - a list of cookies
     * */
    constructor(cookie) {
        this.cookie = cookie;
        this.status = TrackingStatus.Sent;
    }
    /**
     * @method fromString - a static method for creating an instance of `Cookie` from a string
     * @param {string} cookieString - a string containing a list of cookies
     * @returns {Cookie} an instance of `Cookie`
     * */
    static fromString(cookieString) {
        if (!cookieString) {
            return new Cookie([]);
        }
        const pairs = cookieString.split(';');
        const cookie = pairs
            .map((item) => {
            const [key, value] = item.trim().split('=');
            if (!key) {
                KameleoonLogger.warning `Cookie string has an empty key: ${cookieString}`;
                return null;
            }
            return { key, value };
        })
            .filter((item) => item !== null);
        return new Cookie(cookie);
    }
    get url() {
        return '';
    }
    get data() {
        return {
            cookie: this.cookie,
            type: KameleoonData.Cookie,
            status: this.status,
        };
    }
};

/**
 * @class
 * UserAgent - a class for creating an instance for user agent
 * */
class UserAgent {
    constructor(value) {
        this.value = value;
        this.status = TrackingStatus.Sent;
    }
    get url() {
        return '';
    }
    get data() {
        return {
            value: this.value,
            type: KameleoonData.UserAgent,
            status: this.status,
        };
    }
}

class UniqueIdentifier {
    /**
     * @param {boolean} value - a boolean value that indicates if the visitor has a unique identifier
     * */
    constructor(value) {
        this._value = value;
        this.status = TrackingStatus.Sent;
    }
    get url() {
        return '';
    }
    get data() {
        return {
            value: this._value,
            type: KameleoonData.UniqueIdentifier,
            status: TrackingStatus.Sent,
        };
    }
    /**
     * @private
     * @method _fromRaw - an internal method for creating a UniqueIdentifier instance from raw data
     * @param {IdentifierDataType} data - a raw data
     * @return {UniqueIdentifier} a UniqueIdentifier instance
     * */
    static _fromRaw(data) {
        return new UniqueIdentifier(data.value);
    }
}

/**
 * @class
 * ApplicationVersion - a class for creating an instance for app version
 * */
let ApplicationVersion$1 = class ApplicationVersion {
    /**
     * @param {string} version - version of mobile application
     * */
    constructor(version) {
        this.version = version;
        this.status = TrackingStatus.Sent;
    }
    get url() {
        return '';
    }
    get data() {
        return {
            version: this.version,
            type: KameleoonData.ApplicationVersion,
            status: this.status,
        };
    }
};

/**
 * @class
 * StaticData - a class for creating static data for Kameleoon.
 * */
class StaticData {
    constructor({ browserType, visitNumber, timeSincePreviousVisit, os, deviceType, browserVersion, }) {
        this.browserType = browserType;
        this.visitNumber = visitNumber;
        this.timeSincePreviousVisit = timeSincePreviousVisit;
        this.os = os;
        this.deviceType = deviceType;
        this.browserVersion = browserVersion;
    }
    get url() {
        const browserVersion = this.browserVersion
            ? UrlParameter.BrowserVersion + this.browserVersion
            : '';
        const browserType = this.browserType
            ? UrlParameter.Browser + this.browserType
            : '';
        const browserIndex = this.browserType
            ? UrlParameter.BrowserIndex + BrowserIndexMap[this.browserType]
            : '';
        const os = this.os ? UrlParameter.Os + this.os : '';
        const osIndex = this.os
            ? UrlParameter.OsIndex + OperatingSystemIndexMap[this.os]
            : '';
        const deviceType = this.deviceType
            ? UrlParameter.DeviceType + this.deviceType
            : '';
        const visitNumber = this.visitNumber !== undefined
            ? UrlParameter.VisitNumber + this.visitNumber
            : '';
        const timeSincePreviousVisit = this.timeSincePreviousVisit !== undefined
            ? UrlParameter.TimeSincePreviousVisit + this.timeSincePreviousVisit
            : '';
        return (UrlEventType.StaticData +
            browserType +
            browserIndex +
            browserVersion +
            visitNumber +
            timeSincePreviousVisit +
            os +
            osIndex +
            deviceType);
    }
}

class ConditionFactoryInstance {
    static setConditionFactoryInstance(value) {
        this.conditionFactoryInstance = value;
    }
    static createCondition(data) {
        return this.conditionFactoryInstance.createCondition(data);
    }
}

class Node {
    constructor(value, left, right) {
        var _a;
        this.inverseResult = false;
        if (this.isOperator(value)) {
            this.nodeValue = value;
        }
        else {
            const result = ConditionFactoryInstance.createCondition(value);
            this.inverseResult = !((_a = value.isInclude) !== null && _a !== void 0 ? _a : true);
            if (result.ok) {
                this.nodeValue = result.data;
            }
            else {
                this.nodeError = result.error;
            }
        }
        this.leftChild = left;
        this.rightChild = right;
    }
    get value() {
        return this.nodeValue;
    }
    get error() {
        return this.nodeError;
    }
    get left() {
        return this.leftChild;
    }
    get right() {
        return this.rightChild;
    }
    get inverse() {
        return this.inverseResult;
    }
    isOperator(value) {
        return value === "AND" /* Operator.And */ || value === "OR" /* Operator.Or */;
    }
}

class Tree {
    constructor(segment) {
        this.error = null;
        this.targetingTypes = new Set();
        KameleoonLogger.debug `CALL: new Tree(segment: ${segment})`;
        const { nestedConditions, topLevelOperators } = this.flattenSegment(segment);
        // --- Note ---
        // - Targeting tree is built bottom-up, it's the only way to both get the consistent logic
        // (grouping nested conditions) and have human readable tree representation.
        // - Here is an example of how tree is built (we use strict complete binary tree)
        // Let's say we have such a condition `value < 10 || value > 20 && value < 30`
        // Following is pseudo code for building tree:
        //
        // `const operators = [Operator.Or, Operator.And]`
        // `const conditions = [
        //     {type: Condition.Less, value: 10},
        //     {type: Condition.Greater, value: 20},
        //     {type: Condition.Less, value: 30},
        // ]`
        //
        // After the first iteration we have node like this:
        //    AND
        //   /   \
        //  <30  >20
        //
        // After the second iteration tree looks as follows:
        //         OR
        //        /  \
        //    AND    <10
        //   /   \
        //  <30  >20
        //
        // As you can see Leaf Nodes contain conditions and Non-Leaf Nodes contain logical operators
        const nestedNodes = nestedConditions.map(({ conditions, operators }) => {
            const nodes = conditions.map((condition) => {
                // --- Note ---
                // We keep condition types to optimize
                // some external operations depending on what conditions are present
                // in a tree
                this.targetingTypes.add(condition.targetingType);
                return new Node(condition);
            });
            return this.buildTree(nodes, operators);
        });
        this.tree = this.buildTree(nestedNodes, topLevelOperators);
        KameleoonLogger.debug `RETURN: new Tree(segment: ${segment})`;
    }
    evaluate(data) {
        const result = this.evaluateNode(this.tree, data);
        if (this.error) {
            return buildExports.Err(this.error);
        }
        return buildExports.Ok(result);
    }
    hasTargetingType(targetingType) {
        return this.targetingTypes.has(targetingType);
    }
    evaluateNode(node, data) {
        if (this.isLeafNode(node)) {
            if (node.error) {
                // --- Note ---
                // Non-existing condition should not break targeting tree
                // instead it should be treated as `true` condition
                if (node.error.type === KameleoonException.TargetingCondition) {
                    return true;
                }
                return false;
            }
            const result = node.value.evaluate(data);
            if (!result.ok) {
                this.error = result.error;
                return false;
            }
            return node.inverse ? !result.data : result.data;
        }
        if (this.isNonLeafNode(node)) {
            switch (node.value) {
                case "AND" /* Operator.And */: {
                    return (this.evaluateNode(node.left, data) &&
                        this.evaluateNode(node.right, data));
                }
                case "OR" /* Operator.Or */: {
                    return (this.evaluateNode(node.left, data) ||
                        this.evaluateNode(node.right, data));
                }
            }
        }
        return false;
    }
    isLeafNode(node) {
        return !Boolean(node.left && node.right);
    }
    isNonLeafNode(node) {
        return Boolean(node.left &&
            node.right &&
            (node.value === "OR" /* Operator.Or */ || node.value === "AND" /* Operator.And */));
    }
    // --- Note ---
    // This method mutates `nodes` array
    // It's done for the sake of performance
    buildTree(nodes, operators) {
        if (nodes.length === 1) {
            return nodes[0];
        }
        for (const operator of operators) {
            const left = nodes.shift();
            const right = nodes.shift();
            const newNode = new Node(operator, left, right);
            nodes.unshift(newNode);
        }
        return nodes[0];
    }
    flattenSegment(segment) {
        const { firstLevel: conditions, firstLevelOrOperators: operators } = segment.conditionsData;
        const nestedConditions = [];
        conditions.forEach((condition) => {
            const { conditions: conditionList, orOperators } = condition;
            const group = {
                operators: this.convertOperators(orOperators),
                conditions: conditionList,
            };
            nestedConditions.push(group);
        });
        return {
            topLevelOperators: this.convertOperators(operators),
            nestedConditions,
        };
    }
    convertOperators(operators) {
        return operators.map((operator) => (operator ? "OR" /* Operator.Or */ : "AND" /* Operator.And */));
    }
}

function getVisitorLastStartTime({ targetingData, sdkInfo }, visitScope, visitCount) {
    var _a;
    const visitsData = targetingData === null || targetingData === void 0 ? void 0 : targetingData[KameleoonData.VisitsData];
    if (!((_a = visitsData === null || visitsData === void 0 ? void 0 : visitsData.visits) === null || _a === void 0 ? void 0 : _a.length) ||
        (visitScope == null && visitCount == null)) {
        return 0;
    }
    const { visits } = visitsData;
    let count = 1;
    if (visitScope !== "CURRENT_VISIT" /* VisitScope.CURRENT_VISIT */) {
        if (visitCount != null) {
            count = sdkInfo.isServer ? visitCount - 1 : visitCount;
        }
        else {
            count = visits.length;
        }
    }
    const index = Math.max(0, visits.length - count);
    const visit = visits[index];
    return typeof visit === 'number' ? visit : visit.timeStarted;
}

class ExclusiveExperimentCondition {
    constructor({ campaignType, visitCount, visitScope }) {
        this.campaignType = campaignType;
        this.visitCount = visitCount;
        this.visitScope = visitScope;
    }
    evaluate(data) {
        return buildExports.Ok(this.checkCondition(data));
    }
    checkCondition(data) {
        const lastVisitTime = getVisitorLastStartTime(data, this.visitScope, this.visitCount);
        switch (this.campaignType) {
            case "EXPERIMENT" /* CampaignType.Experiment */:
                return this.checkExperiment(data, lastVisitTime);
            case "PERSONALIZATION" /* CampaignType.Personalization */:
                return this.checkPersonalization(data, lastVisitTime);
            case "ANY" /* CampaignType.Any */:
                return (this.checkPersonalization(data, lastVisitTime) &&
                    this.checkExperiment(data, lastVisitTime));
            default:
                return false;
        }
    }
    checkExperiment(data, assignmentThreshold) {
        const keys = Object.keys(data.variationData);
        let count = 0;
        let lastKey = null;
        for (const key of keys) {
            const variation = data.variationData[key];
            if (!(variation === null || variation === void 0 ? void 0 : variation.assignedTime) ||
                variation.assignedTime >= assignmentThreshold) {
                count++;
                lastKey = key;
                if (count > 1) {
                    break;
                }
            }
        }
        return (count === 0 ||
            (count === 1 &&
                data.experimentId !== null &&
                lastKey === String(data.experimentId)));
    }
    checkPersonalization(data, assignmentThreshold) {
        var _a;
        const personalizations = Object.values(((_a = data.targetingData) === null || _a === void 0 ? void 0 : _a.personalization) || {});
        for (const personalization of personalizations) {
            if ((personalization === null || personalization === void 0 ? void 0 : personalization.assignedTime) &&
                personalization.assignedTime >= assignmentThreshold) {
                return false;
            }
        }
        return true;
    }
}

class Device {
    constructor({ device }) {
        this.device = device;
    }
    evaluate({ targetingData, }) {
        const deviceData = targetingData === null || targetingData === void 0 ? void 0 : targetingData[KameleoonData.Device];
        if (deviceData) {
            const { device } = deviceData;
            return buildExports.Ok(device === this.device);
        }
        return buildExports.Ok(false);
    }
}

class Browser {
    constructor({ browser, version, versionMatchType }) {
        this.browser = browser;
        this.version = version;
        this.versionMatchType = versionMatchType;
    }
    evaluate({ targetingData, }) {
        const browserData = targetingData === null || targetingData === void 0 ? void 0 : targetingData[KameleoonData.Browser];
        if (browserData) {
            const result = this.checkCondition(browserData);
            if (this.error) {
                return buildExports.Err(this.error);
            }
            return buildExports.Ok(result);
        }
        return buildExports.Ok(false);
    }
    checkCondition(browserData) {
        const { browser, version } = browserData;
        if (typeof this.browser !== 'string') {
            return false;
        }
        if (!this.version) {
            return browser === this.browser;
        }
        if (!this.versionMatchType || typeof version !== 'number') {
            return false;
        }
        const parsedVersion = parseFloat(this.version);
        if (isNaN(parsedVersion)) {
            KameleoonLogger.error `Failed to parse version: ${this.version} in Browser condition`;
            this.error = new KameleoonError(KameleoonException.VersionParse, this.version);
        }
        switch (this.versionMatchType) {
            case "EQUAL" /* VersionMatchType.EQUAL */:
                return browser === this.browser && version === parsedVersion;
            case "GREATER" /* VersionMatchType.GREATER */:
                return browser === this.browser && version > parsedVersion;
            case "LOWER" /* VersionMatchType.LOWER */:
                return browser === this.browser && version < parsedVersion;
            default:
                KameleoonLogger.error `Unexpected comparing operation for Browser condition: ${this.versionMatchType}`;
                exhaustCheck(this.versionMatchType);
        }
    }
}

class Conversion {
    constructor({ goalId, visitCount, visitScope }) {
        this.goalId = goalId;
        this.visitCount = visitCount;
        this.visitScope = visitScope;
    }
    evaluate(data) {
        const { targetingData } = data;
        const conversionData = targetingData === null || targetingData === void 0 ? void 0 : targetingData[KameleoonData.Conversion];
        if (!conversionData) {
            return buildExports.Ok(false);
        }
        const conversions = Object.values(conversionData);
        if (!conversions.length) {
            return buildExports.Ok(false);
        }
        const lastVisitTime = getVisitorLastStartTime(data, this.visitScope, this.visitCount);
        return buildExports.Ok(conversions.some((conversion) => {
            if (!conversion)
                return false;
            if (this.goalId != null && conversion.goalId !== this.goalId) {
                return false;
            }
            return (!conversion.assignedTime || conversion.assignedTime >= lastVisitTime);
        }));
    }
}

class CustomData {
    constructor({ customDataIndex, valueMatchType, value, range, }) {
        this.customDataIndex = customDataIndex ? Number(customDataIndex) : -1;
        this.matchType = valueMatchType;
        this.conditionValue = value;
        this.range = range;
    }
    evaluate({ targetingData, }) {
        var _a;
        const customData = (_a = targetingData === null || targetingData === void 0 ? void 0 : targetingData[KameleoonData.CustomData]) === null || _a === void 0 ? void 0 : _a[this.customDataIndex];
        if (this.matchType === "UNDEFINED" /* ValueMatchType.UNDEFINED */) {
            return buildExports.Ok(!customData);
        }
        if (customData) {
            const { value: customDataValue } = customData;
            const result = this.checkCondition(customDataValue);
            if (this.error) {
                return buildExports.Err(this.error);
            }
            return buildExports.Ok(result);
        }
        return buildExports.Ok(false);
    }
    checkCondition(customDataValue) {
        if (typeof this.conditionValue !== 'string' &&
            this.matchType !== "TRUE" /* ValueMatchType.TRUE */ &&
            this.matchType !== "FALSE" /* ValueMatchType.FALSE */ &&
            this.matchType !== "RANGE" /* ValueMatchType.RANGE */) {
            KameleoonLogger.error `Unexpected condition value for CustomData condition: ${this.conditionValue}`;
            return false;
        }
        // --- Note ---
        // `TRUE`/`FALSE`/`RANGE` do not use condition value
        // so we can safely assume that `this.conditionValue` is a string at this point
        // for other match types
        const conditionValue = this.conditionValue;
        // --- Note ---
        // `AMONG_VALUES` and `RANGE` are checked separately to avoid recursion overhead
        // for `JSON.parse` inside `this.parseArray`
        if (this.matchType === "AMONG_VALUES" /* ValueMatchType.AMONG_VALUES */) {
            const result = this.parseArray(conditionValue);
            if (!result.ok) {
                this.error = result.error;
                return false;
            }
            const resultData = new Set(result.data);
            return Array.isArray(customDataValue)
                ? customDataValue.some((value) => resultData.has(value))
                : result.data.includes(customDataValue);
        }
        if (this.matchType === "RANGE" /* ValueMatchType.RANGE */) {
            const result = this.parseRange(this.range);
            if (!result.ok) {
                this.error = result.error;
                return false;
            }
            const [lowerBound, upperBound] = result.data;
            const isInRange = (value) => value >= lowerBound && value <= upperBound;
            return Array.isArray(customDataValue)
                ? customDataValue.some((value) => isInRange(Number(value)))
                : isInRange(Number(customDataValue));
        }
        if (Array.isArray(customDataValue)) {
            return customDataValue.some((value) => this.checkCondition(value));
        }
        switch (this.matchType) {
            case "CONTAINS" /* ValueMatchType.CONTAINS */:
                return customDataValue.includes(conditionValue);
            case "EXACT" /* ValueMatchType.EXACT */:
                return customDataValue === this.conditionValue;
            case "REGULAR_EXPRESSION" /* ValueMatchType.REGULAR_EXPRESSION */:
                return Parser.parseRegExp(conditionValue).test(customDataValue);
            case "LOWER" /* ValueMatchType.LOWER */:
                return Number(customDataValue) < Number(this.conditionValue);
            case "EQUAL" /* ValueMatchType.EQUAL */:
                return Number(customDataValue) === Number(this.conditionValue);
            case "GREATER" /* ValueMatchType.GREATER */:
                return Number(customDataValue) > Number(this.conditionValue);
            case "TRUE" /* ValueMatchType.TRUE */:
                return customDataValue.toLowerCase() === 'true';
            case "FALSE" /* ValueMatchType.FALSE */:
                return customDataValue.toLowerCase() === 'false';
            default:
                KameleoonLogger.error `Unexpected comparing operation for CustomData condition: ${this.matchType}`;
                return false;
        }
    }
    parseArray(value) {
        try {
            const result = JSON.parse(value);
            if (Array.isArray(result)) {
                return buildExports.Ok(result);
            }
        }
        catch (err) {
            KameleoonLogger.error `Failed to parse array: ${value} in CustomData condition`;
            return buildExports.Err(new KameleoonError(KameleoonException.AmongValuesCheck, err, value));
        }
        return buildExports.Ok([]);
    }
    parseRange(array) {
        if (!array || array.length !== 2) {
            KameleoonLogger.error `Failed to parse range: ${array} in CustomData condition`;
            return buildExports.Err(new KameleoonError(KameleoonException.RangeCheck, array));
        }
        return buildExports.Ok(array);
    }
}

class PageUtils {
    static getLatest(pageViewData) {
        return Object.values(pageViewData).reduce((latest, current) => latest.timestamps[latest.timestamps.length - 1].time >
            current.timestamps[current.timestamps.length - 1].time
            ? latest
            : current);
    }
}

class PageTitle {
    constructor({ matchType, title }) {
        this.matchType = matchType;
        this.conditionValue = title;
    }
    evaluate({ targetingData, }) {
        const pageViewData = targetingData === null || targetingData === void 0 ? void 0 : targetingData[KameleoonData.PageView];
        if (!pageViewData) {
            return buildExports.Ok(false);
        }
        const latestPageView = PageUtils.getLatest(pageViewData);
        return buildExports.Ok(this.checkCondition(latestPageView.title));
    }
    checkCondition(title) {
        if (!this.matchType || !this.conditionValue) {
            return false;
        }
        switch (this.matchType) {
            case "CONTAINS" /* MatchType.CONTAINS */:
                return title.includes(this.conditionValue);
            case "EXACT" /* MatchType.EXACT */:
                return title === this.conditionValue;
            case "REGULAR_EXPRESSION" /* MatchType.REGULAR_EXPRESSION */:
                return Parser.parseRegExp(this.conditionValue).test(title);
            default:
                KameleoonLogger.error `Unexpected comparing operation for PageTitle condition: ${this.matchType}`;
                return false;
        }
    }
}

class PageUrl {
    constructor({ matchType, url }) {
        this.matchType = matchType;
        this.conditionValue = url;
    }
    evaluate({ targetingData, }) {
        const pageViewData = targetingData === null || targetingData === void 0 ? void 0 : targetingData[KameleoonData.PageView];
        if (!pageViewData) {
            return buildExports.Ok(false);
        }
        const latestPageView = PageUtils.getLatest(pageViewData);
        return buildExports.Ok(this.checkCondition(latestPageView.urlAddress));
    }
    checkCondition(url) {
        if (!this.matchType || !this.conditionValue) {
            return false;
        }
        switch (this.matchType) {
            case "CONTAINS" /* MatchType.CONTAINS */:
                return url.includes(this.conditionValue);
            case "EXACT" /* MatchType.EXACT */:
                return url === this.conditionValue;
            case "REGULAR_EXPRESSION" /* MatchType.REGULAR_EXPRESSION */:
                return Parser.parseRegExp(this.conditionValue).test(url);
            default:
                KameleoonLogger.error `Unexpected comparing operation for PageUrl condition: ${this.matchType}`;
                return false;
        }
    }
}

class SdkLanguage {
    constructor({ sdkLanguage, version, versionMatchType }) {
        this.sdkLanguage = sdkLanguage;
        this.conditionValue = version;
        this.versionMatchType = versionMatchType;
    }
    evaluate({ sdkInfo, }) {
        return this.checkCondition(sdkInfo);
    }
    checkCondition(sdkInfo) {
        const { type: sdkType, version } = sdkInfo;
        if (!this.sdkLanguage) {
            return buildExports.Ok(false);
        }
        if (typeof this.conditionValue !== 'string') {
            return buildExports.Ok(sdkType === this.sdkLanguage);
        }
        if (!this.versionMatchType) {
            return buildExports.Ok(false);
        }
        if (sdkType !== this.sdkLanguage) {
            return buildExports.Ok(false);
        }
        const result = Utilities.compareSemVer({
            version,
            compareVersion: this.conditionValue,
            operator: this.versionMatchType,
        });
        if (!result.ok) {
            return buildExports.Err(result.error);
        }
        return buildExports.Ok(result.data);
    }
}

class VisitorCode {
    constructor({ visitorCode, matchType }) {
        this.matchType = matchType;
        this.conditionValue = visitorCode;
    }
    evaluate({ visitorCode, }) {
        return buildExports.Ok(this.checkCondition(visitorCode));
    }
    checkCondition(visitorCode) {
        if (!this.matchType || !this.conditionValue) {
            return false;
        }
        switch (this.matchType) {
            case "CONTAINS" /* MatchType.CONTAINS */:
                return visitorCode.includes(this.conditionValue);
            case "EXACT" /* MatchType.EXACT */:
                return visitorCode === this.conditionValue;
            case "REGULAR_EXPRESSION" /* MatchType.REGULAR_EXPRESSION */:
                return Parser.parseRegExp(this.conditionValue).test(visitorCode);
            default:
                KameleoonLogger.error `Unexpected comparing operation for VisitorCode condition: ${this.matchType}`;
                return false;
        }
    }
}

class Cookie {
    constructor({ name, value, nameMatchType, valueMatchType, }) {
        this.cookie = {
            key: name !== null && name !== void 0 ? name : undefined,
            value: value !== null && value !== void 0 ? value : undefined,
        };
        this.keyMatchType = nameMatchType;
        this.valueMatchType = valueMatchType;
    }
    evaluate({ targetingData, }) {
        var _a;
        const isEmptyCookie = !this.cookie.key && !this.cookie.value;
        const isValidMatchType = Boolean(this.valueMatchType) && Boolean(this.keyMatchType);
        if (isEmptyCookie || !isValidMatchType) {
            return buildExports.Ok(false);
        }
        const extractedCookie = this.extractCookie();
        const cookieData = ((_a = targetingData === null || targetingData === void 0 ? void 0 : targetingData[KameleoonData.Cookie]) === null || _a === void 0 ? void 0 : _a.cookie) || [];
        return buildExports.Ok(extractedCookie.some((pair) => this.checkCondition(pair)) ||
            cookieData.some((pair) => this.checkCondition(pair)));
    }
    extractCookie() {
        if (typeof document !== 'undefined' && document.cookie) {
            return Cookie$1.fromString(document.cookie).data.cookie;
        }
        return [];
    }
    checkCondition(dataCookie) {
        const cookieMatchType = this.keyMatchType;
        const { key, value } = dataCookie;
        if (cookieMatchType === "OPTIONAL" /* NameMatchType.OPTIONAL */) {
            const conditionCookie = this.cookie;
            return this.isOptionalCookie(conditionCookie)
                ? this.compareCookieValue(value, conditionCookie.value)
                : false;
        }
        const { key: compareKey, value: compareValue } = this.cookie;
        let keyMatch;
        switch (cookieMatchType) {
            case "EXACT" /* NameMatchType.EXACT */:
                keyMatch = key === compareKey;
                break;
            case "CONTAINS" /* NameMatchType.CONTAINS */:
                keyMatch = key.includes(compareKey);
                break;
            case "REGULAR_EXPRESSION" /* NameMatchType.REGULAR_EXPRESSION */:
                keyMatch = Parser.parseRegExp(compareKey).test(key);
                break;
            default:
                KameleoonLogger.error `Unexpected comparing operation for Cookie condition: ${cookieMatchType}`;
                exhaustCheck(cookieMatchType);
        }
        return keyMatch && this.compareCookieValue(value, compareValue);
    }
    compareCookieValue(value, compareValue) {
        const valueMatchType = this.valueMatchType;
        switch (valueMatchType) {
            case "EXACT" /* ValueMatchType.EXACT */:
                return value === compareValue;
            case "CONTAINS" /* ValueMatchType.CONTAINS */:
                return value.includes(compareValue);
            case "REGULAR_EXPRESSION" /* ValueMatchType.REGULAR_EXPRESSION */:
                return Parser.parseRegExp(compareValue).test(value);
            default:
                KameleoonLogger.error `Unexpected comparing operation for Cookie condition: ${valueMatchType}`;
                return false;
        }
    }
    isOptionalCookie(cookie) {
        const { value } = cookie;
        return typeof value !== 'undefined';
    }
}

class OperatingSystem {
    constructor({ os }) {
        this.operatingSystem = os;
    }
    evaluate({ targetingData, }) {
        const operatingSystemData = targetingData === null || targetingData === void 0 ? void 0 : targetingData[KameleoonData.OperatingSystem];
        if (operatingSystemData) {
            const { operatingSystem } = operatingSystemData;
            return buildExports.Ok(operatingSystem === this.operatingSystem);
        }
        return buildExports.Ok(false);
    }
}

// --- Note ---
// `GeolocationCondition` uses `Condition` in the naming to avoid confusion with
// native `Geolocation` API
class GeolocationCondition {
    constructor({ country, region, city }) {
        this.country = country;
        this.region = region;
        this.city = city;
    }
    evaluate({ targetingData, }) {
        const geolocationData = targetingData === null || targetingData === void 0 ? void 0 : targetingData[KameleoonData.GeolocationData];
        if (geolocationData) {
            const { country: dataCountry, region: dataRegion, city: dataCity, } = geolocationData;
            const [conditionCountry, conditionRegion, conditionCity] = [
                this.country,
                this.region,
                this.city,
            ];
            if (!conditionCountry || !dataCountry) {
                return buildExports.Ok(false);
            }
            const result = dataCountry.toLowerCase() === conditionCountry.toLowerCase() &&
                (!conditionRegion ||
                    (dataRegion === null || dataRegion === void 0 ? void 0 : dataRegion.toLowerCase()) === conditionRegion.toLowerCase()) &&
                (!conditionCity ||
                    (dataCity === null || dataCity === void 0 ? void 0 : dataCity.toLowerCase()) === conditionCity.toLowerCase());
            return buildExports.Ok(result);
        }
        return buildExports.Ok(false);
    }
}

class Segment {
    constructor({ segmentId }) {
        this.segmentId = segmentId;
    }
    evaluate(evaluationData) {
        var _a;
        const { segments, trees } = evaluationData;
        if (!this.segmentId) {
            return buildExports.Ok(false);
        }
        const segment = segments === null || segments === void 0 ? void 0 : segments.get(this.segmentId.toString());
        if (!segment) {
            return buildExports.Ok(false);
        }
        const tree = (_a = trees === null || trees === void 0 ? void 0 : trees.get(this.segmentId.toString())) !== null && _a !== void 0 ? _a : trees === null || trees === void 0 ? void 0 : trees.get(this.segmentId);
        if (tree) {
            return tree.evaluate(evaluationData);
        }
        return new Tree(segment).evaluate(evaluationData);
    }
}

class TargetFeatureFlag {
    constructor({ featureFlagId, variationKey, ruleId, visitCount, visitScope, }) {
        this.featureId = featureFlagId;
        this.ruleId = ruleId;
        this.variationKey = variationKey;
        this.visitCount = visitCount;
        this.visitScope = visitScope;
    }
    evaluate(data) {
        const { variationData, ruleMap } = data;
        if (!this.featureId || !ruleMap) {
            return buildExports.Ok(false);
        }
        const lastVisitTime = getVisitorLastStartTime(data, this.visitScope, this.visitCount);
        const isAssignedInVisit = (assignedTime, lastVisitTime) => {
            return !assignedTime || assignedTime >= lastVisitTime;
        };
        // -- Visitor took part in any experiment of the feature flag
        //    with any variation
        if (this.featureId && !this.ruleId && !this.variationKey) {
            for (const rule of ruleMap.values()) {
                const { featureId, experimentId } = rule;
                const experiment = variationData[experimentId];
                if (featureId === this.featureId &&
                    typeof (experiment === null || experiment === void 0 ? void 0 : experiment.variationId) === 'number' &&
                    isAssignedInVisit(experiment === null || experiment === void 0 ? void 0 : experiment.assignedTime, lastVisitTime)) {
                    return buildExports.Ok(true);
                }
            }
            return buildExports.Ok(false);
        }
        // -- Visitor took part in certain experiment of the feature flag
        //    with any/exact variation
        if (this.featureId && this.ruleId) {
            const rule = ruleMap.get(this.ruleId);
            if ((rule === null || rule === void 0 ? void 0 : rule.featureId) !== this.featureId) {
                return buildExports.Ok(false);
            }
            const { experimentId, variations } = rule;
            const experiment = variationData[experimentId];
            if (this.variationKey) {
                const variationId = variations.get(this.variationKey);
                return buildExports.Ok(Boolean(variationId) &&
                    (experiment === null || experiment === void 0 ? void 0 : experiment.variationId) === variationId &&
                    isAssignedInVisit(experiment === null || experiment === void 0 ? void 0 : experiment.assignedTime, lastVisitTime));
            }
            return buildExports.Ok(Boolean(experiment === null || experiment === void 0 ? void 0 : experiment.variationId) &&
                isAssignedInVisit(experiment === null || experiment === void 0 ? void 0 : experiment.assignedTime, lastVisitTime));
        }
        // -- Visitor took part in any experiment of the feature flag
        //    with certain variation
        if (this.featureId && !this.ruleId && this.variationKey) {
            for (const rule of ruleMap.values()) {
                const { featureId, experimentId, variations } = rule;
                if (featureId === this.featureId && variations.has(this.variationKey)) {
                    const variationId = variations.get(this.variationKey);
                    const experiment = variationData[experimentId];
                    if (Boolean(variationId) &&
                        (experiment === null || experiment === void 0 ? void 0 : experiment.variationId) === variationId &&
                        isAssignedInVisit(experiment === null || experiment === void 0 ? void 0 : experiment.assignedTime, lastVisitTime)) {
                        return buildExports.Ok(true);
                    }
                }
            }
        }
        return buildExports.Ok(false);
    }
}

class PreviousPage {
    constructor({ matchType, url }) {
        this.conditionValue = url;
        this.matchType = matchType;
    }
    evaluate({ targetingData, }) {
        const pageViewsData = targetingData === null || targetingData === void 0 ? void 0 : targetingData[KameleoonData.PageView];
        if (!pageViewsData) {
            return buildExports.Ok(false);
        }
        // --- Note ---
        // There is more concise way to find previous latest page, but it's less performant,
        // here we only ever check two latest timestamps of page and use one loop
        // The second latest can't be equal to the latest
        const secondLatestPageView = this.getSecondLatestPageView(Object.values(pageViewsData));
        if (!secondLatestPageView) {
            return buildExports.Ok(false);
        }
        const url = secondLatestPageView.urlAddress;
        return buildExports.Ok(this.checkCondition(url));
    }
    checkCondition(url) {
        if (!this.matchType || !this.conditionValue) {
            return false;
        }
        switch (this.matchType) {
            case "CONTAINS" /* MatchType.CONTAINS */:
                return url.includes(this.conditionValue);
            case "EXACT" /* MatchType.EXACT */:
                return url === this.conditionValue;
            case "REGULAR_EXPRESSION" /* MatchType.REGULAR_EXPRESSION */:
                return Parser.parseRegExp(this.conditionValue).test(url);
            default:
                KameleoonLogger.error `Unexpected comparing operation for PreviousPage condition: ${this.matchType}`;
                return false;
        }
    }
    getSecondLatestPageView(pageViewsData) {
        if (pageViewsData.length < 2) {
            return undefined;
        }
        // --- Note ---
        // Arguments and variables named with abbreviations for better readability
        // `second` in this context is `second to latest`
        let latestPV;
        let secondPV;
        pageViewsData.forEach((currentPV) => {
            const currentLatestTs = currentPV.timestamps[currentPV.timestamps.length - 1].time;
            // -- Initial check
            if (!latestPV) {
                latestPV = currentPV;
                return;
            }
            const latestTs = latestPV.timestamps[latestPV.timestamps.length - 1].time;
            // -- Covering a case where latest needs to be updated
            if (currentLatestTs > latestTs) {
                secondPV = latestPV;
                latestPV = currentPV;
                return;
            }
            // -- Covering a case where only second needs to be updated
            const secondTs = secondPV
                ? secondPV.timestamps[secondPV.timestamps.length - 1].time
                : 0;
            // -- Second may need to be updated
            if (currentLatestTs > secondTs) {
                secondPV = currentPV;
            }
        });
        return secondPV;
    }
}

class VisitedPages {
    constructor({ matchType, pageCount }) {
        this.matchType = matchType;
        this.conditionValue = pageCount;
    }
    evaluate({ targetingData, }) {
        const pageViewsData = targetingData === null || targetingData === void 0 ? void 0 : targetingData[KameleoonData.PageView];
        if (!pageViewsData) {
            return buildExports.Ok(false);
        }
        let pagesAmount = 0;
        Object.values(pageViewsData).forEach((pageView) => {
            pagesAmount += pageView.timestamps.length;
        });
        return buildExports.Ok(this.checkCondition(pagesAmount));
    }
    checkCondition(pagesAmount) {
        if (!this.matchType || typeof this.conditionValue !== 'number') {
            return false;
        }
        switch (this.matchType) {
            case "EQUAL" /* MatchType.EQUAL */:
                return pagesAmount === this.conditionValue;
            case "GREATER" /* MatchType.GREATER */:
                return pagesAmount > this.conditionValue;
            case "LOWER" /* MatchType.LOWER */:
                return pagesAmount < this.conditionValue;
            default:
                KameleoonLogger.error `Unexpected comparing operation for VisitedPages condition: ${this.matchType}`;
                return false;
        }
    }
}

class FirstVisit {
    constructor({ matchType, count, unitOfTime }) {
        this.matchType = matchType;
        this.conditionValue = count;
        this.timeUnit = unitOfTime;
    }
    evaluate({ targetingData, sdkInfo, }) {
        const visitsData = targetingData === null || targetingData === void 0 ? void 0 : targetingData[KameleoonData.VisitsData];
        if (sdkInfo.isServer
            ? !(visitsData === null || visitsData === void 0 ? void 0 : visitsData.visits.length)
            : !(visitsData === null || visitsData === void 0 ? void 0 : visitsData.visits) || visitsData.visits.length < 2) {
            return buildExports.Ok(false);
        }
        const firstVisit = visitsData.visits[0];
        return buildExports.Ok(this.checkCondition(typeof firstVisit === 'number' ? firstVisit : firstVisit.timeStarted));
    }
    checkCondition(firstVisitTimestamp) {
        if (!this.matchType ||
            typeof this.conditionValue !== 'number' ||
            !this.timeUnit) {
            return false;
        }
        const elapsedTimeMilliseconds = Date.now() - firstVisitTimestamp;
        const elapsedTimeUnit = Utilities.convertTimeUnit(elapsedTimeMilliseconds, this.timeUnit);
        switch (this.matchType) {
            case "GREATER" /* MatchType.GREATER */:
                return elapsedTimeUnit > this.conditionValue;
            case "LOWER" /* MatchType.LOWER */:
                return elapsedTimeUnit < this.conditionValue;
            default:
                KameleoonLogger.error `Unexpected comparing operation for FirstVisit condition: ${this.matchType}`;
                return false;
        }
    }
}

class LastVisit {
    constructor({ matchType, count, unitOfTime }) {
        this.matchType = matchType;
        this.conditionValue = count;
        this.timeUnit = unitOfTime;
    }
    evaluate({ targetingData, sdkInfo, }) {
        const visitsData = targetingData === null || targetingData === void 0 ? void 0 : targetingData[KameleoonData.VisitsData];
        if (sdkInfo.isServer
            ? !(visitsData === null || visitsData === void 0 ? void 0 : visitsData.visits.length)
            : !(visitsData === null || visitsData === void 0 ? void 0 : visitsData.visits) || visitsData.visits.length < 2) {
            return buildExports.Ok(false);
        }
        const visits = visitsData.visits;
        // --- Note ---
        // Takes the timestamp of latest previous visit
        const indexLastVisit = sdkInfo.isServer
            ? visits.length - 1
            : visits.length - 2;
        const latestPreviousVisit = visits[indexLastVisit];
        return buildExports.Ok(this.checkCondition(typeof latestPreviousVisit === 'number'
            ? latestPreviousVisit
            : latestPreviousVisit.timeStarted));
    }
    checkCondition(lastVisitTimestamp) {
        if (!this.matchType ||
            typeof this.conditionValue !== 'number' ||
            !this.timeUnit) {
            return false;
        }
        const elapsedTimeMilliseconds = Date.now() - lastVisitTimestamp;
        const elapsedTimeUnit = Utilities.convertTimeUnit(elapsedTimeMilliseconds, this.timeUnit);
        switch (this.matchType) {
            case "GREATER" /* MatchType.GREATER */:
                return elapsedTimeUnit > this.conditionValue;
            case "LOWER" /* MatchType.LOWER */:
                return elapsedTimeUnit < this.conditionValue;
            default:
                KameleoonLogger.error `Unexpected comparing operation for LastVisit condition: ${this.matchType}`;
                return false;
        }
    }
}

class SameDayVisits {
    constructor({ matchType, visitCount }) {
        this.matchType = matchType;
        this.conditionValue = visitCount;
    }
    evaluate({ targetingData, sdkInfo, }) {
        const visitsData = targetingData === null || targetingData === void 0 ? void 0 : targetingData[KameleoonData.VisitsData];
        if (!visitsData) {
            return buildExports.Ok(false);
        }
        let todayVisits = 0;
        const todayTimestamp = new Date().setHours(0, 0, 0, 0);
        const { visits } = visitsData;
        visits.forEach((item) => {
            let timeStarted;
            if (typeof item === 'number') {
                timeStarted = item;
            }
            else {
                timeStarted = item.timeStarted;
            }
            if (timeStarted >= todayTimestamp) {
                todayVisits++;
            }
        });
        if (sdkInfo.isServer) {
            // --- Note ---
            // +1 is current visit
            todayVisits += 1;
        }
        return buildExports.Ok(this.checkCondition(todayVisits));
    }
    checkCondition(todayVisitsAmount) {
        if (!this.matchType || typeof this.conditionValue !== 'number') {
            return false;
        }
        switch (this.matchType) {
            case "EQUAL" /* MatchType.EQUAL */:
                return todayVisitsAmount === this.conditionValue;
            case "GREATER" /* MatchType.GREATER */:
                return todayVisitsAmount > this.conditionValue;
            case "LOWER" /* MatchType.LOWER */:
                return todayVisitsAmount < this.conditionValue;
            default:
                KameleoonLogger.error `Unexpected comparing operation for SameDayVisits condition: ${this.matchType}`;
                return false;
        }
    }
}

class Visits {
    constructor({ matchType, visitCount }) {
        this.matchType = matchType;
        this.conditionValue = visitCount;
    }
    evaluate({ targetingData, sdkInfo, }) {
        const visitsData = targetingData === null || targetingData === void 0 ? void 0 : targetingData[KameleoonData.VisitsData];
        if (!visitsData) {
            return buildExports.Ok(false);
        }
        // --- Note ---
        // +1 is current visit for server sdk
        const visits = visitsData.visits.length + (sdkInfo.isServer ? 1 : 0);
        return buildExports.Ok(this.checkCondition(visits));
    }
    checkCondition(visitsAmount) {
        if (!this.matchType || typeof this.conditionValue !== 'number') {
            return false;
        }
        switch (this.matchType) {
            case "EQUAL" /* MatchType.EQUAL */:
                return visitsAmount === this.conditionValue;
            case "GREATER" /* MatchType.GREATER */:
                return visitsAmount > this.conditionValue;
            case "LOWER" /* MatchType.LOWER */:
                return visitsAmount < this.conditionValue;
            default:
                KameleoonLogger.error `Unexpected comparing operation for Visits condition: ${this.matchType}`;
                return false;
        }
    }
}

class NewVisitor {
    constructor({ visitorType }) {
        this.visitorType = visitorType;
    }
    evaluate({ targetingData, sdkInfo, }) {
        const visitsData = targetingData === null || targetingData === void 0 ? void 0 : targetingData[KameleoonData.VisitsData];
        if (!visitsData || !this.visitorType) {
            return buildExports.Ok(false);
        }
        const { visits } = visitsData;
        // --- Note ---
        // Second case handles situation when user didn't use `addData` that
        // creates new current visit
        const isNewVisitor = sdkInfo.isServer
            ? !visits.length
            : visits.length <= 1;
        switch (this.visitorType) {
            case "NEW" /* VisitorType.NEW */:
                return buildExports.Ok(isNewVisitor);
            case "RETURNING" /* VisitorType.RETURNING */:
                return buildExports.Ok(!isNewVisitor);
            default:
                KameleoonLogger.error `Unexpected visitor type for NewVisitor condition: ${this.visitorType}`;
                exhaustCheck(this.visitorType);
        }
    }
}

class ApplicationVersion {
    constructor({ version, versionMatchType }) {
        this.conditionValue = version;
        this.versionMatchType = versionMatchType;
    }
    evaluate({ targetingData, }) {
        var _a;
        const version = (_a = targetingData === null || targetingData === void 0 ? void 0 : targetingData[KameleoonData.ApplicationVersion]) === null || _a === void 0 ? void 0 : _a.version;
        if (!version || !this.conditionValue || !this.versionMatchType) {
            return buildExports.Ok(false);
        }
        const result = Utilities.compareSemVer({
            version,
            compareVersion: this.conditionValue,
            operator: this.versionMatchType,
        });
        if (!result.ok) {
            return buildExports.Err(result.error);
        }
        return buildExports.Ok(result.data);
    }
}

class ConversionLikelihood {
    constructor({ lowerBound, upperBound, keyMomentId, goalId, }) {
        this.lowerBound = lowerBound;
        this.upperBound = upperBound;
        this.keyMomentId = keyMomentId;
        this.goalId = goalId;
    }
    evaluate({ targetingData, }) {
        var _a;
        const kcsData = targetingData === null || targetingData === void 0 ? void 0 : targetingData[KameleoonData.KameleoonConversionScore];
        if (typeof this.keyMomentId !== 'number' ||
            typeof this.goalId !== 'number' ||
            typeof this.lowerBound !== 'number' ||
            typeof this.upperBound !== 'number' ||
            !kcsData) {
            return buildExports.Ok(false);
        }
        const score = (_a = kcsData.kcs[this.keyMomentId.toString()]) === null || _a === void 0 ? void 0 : _a[this.goalId.toString()];
        if (typeof score !== 'number') {
            return buildExports.Ok(false);
        }
        return buildExports.Ok(score >= this.lowerBound && score <= this.upperBound);
    }
}

class TargetExperimentCondition {
    constructor({ variationMatchType, variationId, experimentId, visitCount, visitScope, }) {
        this.variationMatchType = variationMatchType;
        this.variationId = variationId !== null && variationId !== void 0 ? variationId : -1;
        this.experimentId = experimentId !== null && experimentId !== void 0 ? experimentId : -1;
        this.visitCount = visitCount;
        this.visitScope = visitScope;
    }
    evaluate(data) {
        return buildExports.Ok(this.checkCondition(data));
    }
    checkCondition(data) {
        const variation = data.variationData[this.experimentId];
        if (!variation) {
            return false;
        }
        const lastVisitTime = getVisitorLastStartTime(data, this.visitScope, this.visitCount);
        if (variation.assignedTime && variation.assignedTime < lastVisitTime) {
            return false;
        }
        switch (this.variationMatchType) {
            case "ANY" /* MatchTypeVariation.ANY */:
                return true;
            case "EXACT" /* MatchTypeVariation.EXACT */:
                return variation.variationId === this.variationId;
            default:
                return false;
        }
    }
}

class TargetPersonalizationCondition {
    constructor({ personalizationId, visitCount, visitScope, }) {
        this.personalizationId = personalizationId;
        this.visitCount = visitCount;
        this.visitScope = visitScope;
    }
    evaluate(data) {
        if (!data.targetingData) {
            return buildExports.Ok(false);
        }
        return buildExports.Ok(this.checkCondition(data));
    }
    checkCondition(data) {
        var _a, _b;
        if (!this.personalizationId) {
            return false;
        }
        const personalization = (_b = (_a = data.targetingData) === null || _a === void 0 ? void 0 : _a[KameleoonData.Personalization]) === null || _b === void 0 ? void 0 : _b[this.personalizationId];
        if (!personalization) {
            return false;
        }
        const { assignedTime } = personalization;
        return (!assignedTime ||
            assignedTime >=
                getVisitorLastStartTime(data, this.visitScope, this.visitCount));
    }
}

class ConditionFactory {
    createCondition(data) {
        const { targetingType } = data;
        switch (targetingType) {
            case "CUSTOM_DATUM" /* TargetingType.CUSTOM_DATUM */:
                return buildExports.Ok(new CustomData(data));
            case "EXCLUSIVE_EXPERIMENT" /* TargetingType.EXCLUSIVE_EXPERIMENT */:
                return buildExports.Ok(new ExclusiveExperimentCondition(data));
            case "TARGET_EXPERIMENT" /* TargetingType.TARGET_EXPERIMENT */:
                return buildExports.Ok(new TargetExperimentCondition(data));
            case "TARGET_FEATURE_FLAG" /* TargetingType.TARGET_FEATURE_FLAG */:
                return buildExports.Ok(new TargetFeatureFlag(data));
            case "TARGET_PERSONALIZATION" /* TargetingType.TARGET_PERSONALIZATION */:
                return buildExports.Ok(new TargetPersonalizationCondition(data));
            case "DEVICE_TYPE" /* TargetingType.DEVICE_TYPE */:
                return buildExports.Ok(new Device(data));
            case "BROWSER" /* TargetingType.BROWSER */:
                return buildExports.Ok(new Browser(data));
            case "PAGE_URL" /* TargetingType.PAGE_URL */:
                return buildExports.Ok(new PageUrl(data));
            case "PAGE_TITLE" /* TargetingType.PAGE_TITLE */:
                return buildExports.Ok(new PageTitle(data));
            case "CONVERSIONS" /* TargetingType.CONVERSIONS */:
                return buildExports.Ok(new Conversion(data));
            case "VISITOR_CODE" /* TargetingType.VISITOR_CODE */:
                return buildExports.Ok(new VisitorCode(data));
            case "SDK_LANGUAGE" /* TargetingType.SDK_LANGUAGE */:
                return buildExports.Ok(new SdkLanguage(data));
            case "COOKIE" /* TargetingType.COOKIE */:
                return buildExports.Ok(new Cookie(data));
            case "OPERATING_SYSTEM" /* TargetingType.OPERATING_SYSTEM */:
                return buildExports.Ok(new OperatingSystem(data));
            case "GEOLOCATION" /* TargetingType.GEOLOCATION */:
                return buildExports.Ok(new GeolocationCondition(data));
            case "SEGMENT" /* TargetingType.SEGMENT */:
                return buildExports.Ok(new Segment(data));
            case "APPLICATION_VERSION" /* TargetingType.APPLICATION_VERSION */:
                return buildExports.Ok(new ApplicationVersion(data));
            case "PREVIOUS_PAGE" /* TargetingType.PREVIOUS_PAGE */:
                return buildExports.Ok(new PreviousPage(data));
            case "PAGE_VIEWS" /* TargetingType.PAGE_VIEWS */:
                return buildExports.Ok(new VisitedPages(data));
            case "LAST_VISIT" /* TargetingType.LAST_VISIT */:
                return buildExports.Ok(new LastVisit(data));
            case "FIRST_VISIT" /* TargetingType.FIRST_VISIT */:
                return buildExports.Ok(new FirstVisit(data));
            case "SAME_DAY_VISITS" /* TargetingType.SAME_DAY_VISITS */:
                return buildExports.Ok(new SameDayVisits(data));
            case "VISITS" /* TargetingType.VISITS */:
                return buildExports.Ok(new Visits(data));
            case "NEW_VISITORS" /* TargetingType.NEW_VISITORS */:
                return buildExports.Ok(new NewVisitor(data));
            case "HEAT_SLICE" /* TargetingType.HEAT_SLICE */:
                return buildExports.Ok(new ConversionLikelihood(data));
            default:
                KameleoonLogger.info `Unsupported targeted condition type found: ${targetingType}`;
                return buildExports.Err(new KameleoonError(KameleoonException.TargetingCondition, targetingType));
        }
    }
}

class DataProcessor {
    constructor(cleanupInterval = null, packageInfo) {
        this.cleanupInterval = cleanupInterval;
        this.packageInfo = packageInfo;
    }
    mutUpdateData({ infoData, visitorCode, mutData, dataItem, extendTtl, }) {
        let { visitorReference, data, isReference } = this.dereferenceData(mutData, visitorCode);
        if (this.packageInfo.isServer &&
            isReference &&
            !mutData[visitorReference]) {
            if (infoData.mappingIdentifiers) {
                delete infoData.mappingIdentifiers[visitorCode];
            }
            delete mutData[visitorCode];
            visitorReference = visitorCode;
        }
        let expirationTime;
        if (extendTtl) {
            expirationTime = this.cleanupInterval
                ? Date.now() + this.cleanupInterval
                : 0;
        }
        switch (dataItem.data.type) {
            case KameleoonData.CustomData: {
                this.updateCustomData({
                    expirationTime,
                    customData: dataItem,
                    visitorCode: visitorReference,
                    mutData: data,
                });
                break;
            }
            case KameleoonData.PageView: {
                this.updatePageView({
                    expirationTime,
                    pageView: dataItem,
                    visitorCode: visitorReference,
                    mutData: data,
                });
                break;
            }
            case KameleoonData.Conversion: {
                this.updateConversion({
                    expirationTime,
                    conversion: dataItem,
                    visitorCode: visitorReference,
                    mutData: data,
                });
                break;
            }
            case KameleoonData.VisitsData: {
                this.updateVisitsData({
                    expirationTime,
                    visitsData: dataItem,
                    visitorCode: visitorReference,
                    mutData: data,
                });
                break;
            }
            case KameleoonData.Personalization: {
                this.updatePersonalization({
                    expirationTime,
                    personalization: dataItem,
                    visitorCode: visitorReference,
                    mutData: data,
                });
                break;
            }
            case KameleoonData.TargetedSegment: {
                this.updateTargetedSegment({
                    expirationTime,
                    targetedSegment: dataItem,
                    visitorCode: visitorReference,
                    mutData: data,
                });
                break;
            }
            default: {
                this.updateCommonData({
                    expirationTime,
                    commonData: dataItem,
                    visitorCode: visitorReference,
                    mutData: data,
                });
            }
        }
        return expirationTime;
    }
    mutCleanupData(mutData, infoData) {
        var _a;
        if (!this.cleanupInterval) {
            return null;
        }
        let nextCleanupTime = 0;
        for (const [visitorCode, data] of Object.entries(mutData)) {
            if (typeof data === 'string') {
                this.removeReference({
                    mutData,
                    visitorCode,
                    linkedVisitor: data,
                    infoData,
                });
                continue;
            }
            let closestCleanupTime = 0;
            for (const key of Object.keys(data)) {
                const dataKey = key;
                let time;
                switch (dataKey) {
                    case KameleoonData.CustomData:
                    case KameleoonData.PageView:
                    case KameleoonData.Conversion:
                    case KameleoonData.Personalization: {
                        time = this.deleteNestedExpiredField(data, dataKey);
                        break;
                    }
                    default: {
                        time = this.deleteExpiredField(data, dataKey);
                    }
                }
                if (!closestCleanupTime || (time && time < closestCleanupTime)) {
                    closestCleanupTime = time;
                }
            }
            if (!Object.keys(mutData[visitorCode]).length) {
                delete mutData[visitorCode];
                if (this.packageInfo.isServer) {
                    (_a = infoData.mappingIdentifiers) !== null && _a !== void 0 ? _a : (infoData.mappingIdentifiers = {});
                    delete infoData.mappingIdentifiers[visitorCode];
                }
            }
            else if (!nextCleanupTime ||
                (closestCleanupTime && closestCleanupTime < nextCleanupTime)) {
                nextCleanupTime = closestCleanupTime;
            }
        }
        return nextCleanupTime;
    }
    mutAddUnsentData({ mutData, visitorCode, dataType, }) {
        const unsentData = mutData.unsentData[visitorCode];
        if (!unsentData || !unsentData.length) {
            mutData.unsentData[visitorCode] = [dataType];
        }
        else {
            const set = new Set([...unsentData]);
            set.add(dataType);
            mutData.unsentData[visitorCode] = Array.from(set);
        }
    }
    createReference({ mutData, visitorCode, linkedVisitor, }) {
        // --- Note ---
        // Provided(linked) visitor is now pointing to the visitor code
        mutData[linkedVisitor] = visitorCode;
    }
    removeReference({ mutData, visitorCode, linkedVisitor, infoData, }) {
        if (this.packageInfo.isServer) {
            if (!mutData[linkedVisitor]) {
                delete mutData[visitorCode];
                if (infoData.mappingIdentifiers) {
                    delete infoData.mappingIdentifiers[visitorCode];
                }
            }
        }
    }
    updatePageView({ visitorCode, mutData, pageView, expirationTime, }) {
        const { data } = pageView;
        const isExist = mutData[visitorCode] &&
            KameleoonData.PageView in mutData[visitorCode] &&
            data.urlAddress in mutData[visitorCode][KameleoonData.PageView];
        const parameters = {
            expirationTime,
            visitorCode,
            data: mutData,
            key: KameleoonData.PageView,
            nestedKey: data.urlAddress,
            value: data,
        };
        if (isExist) {
            const existingData = mutData[visitorCode][KameleoonData.PageView][data.urlAddress];
            const existingTimestamps = existingData.timestamps;
            // --- Note ---
            // Merging existing timestamps with added
            for (const existingTimestamp of existingTimestamps) {
                const { time: existingTime } = existingTimestamp;
                if (data.timestamps.some(({ time }) => time === existingTime)) {
                    continue;
                }
                const index = data.timestamps.findIndex(({ time }) => time >= existingTime);
                if (index === -1) {
                    data.timestamps.push(existingTimestamp);
                }
                else {
                    data.timestamps.splice(index, 0, existingTimestamp);
                }
            }
            this.updateNestedField(parameters);
        }
        else {
            this.createNestedField(parameters);
        }
    }
    updateCustomData({ visitorCode, customData, mutData, expirationTime, }) {
        const { data } = customData;
        const isExist = mutData[visitorCode] && KameleoonData.CustomData in mutData[visitorCode];
        const parameters = {
            expirationTime,
            visitorCode,
            data: mutData,
            key: KameleoonData.CustomData,
            nestedKey: data.index.toString(),
            value: data,
        };
        if (isExist) {
            this.updateNestedField(parameters);
        }
        else {
            this.createNestedField(parameters);
        }
    }
    updateConversion({ conversion, mutData, visitorCode, expirationTime, }) {
        const { data } = conversion;
        const isExist = mutData[visitorCode] && KameleoonData.Conversion in mutData[visitorCode];
        const parameters = {
            expirationTime,
            visitorCode,
            data: mutData,
            key: KameleoonData.Conversion,
            nestedKey: data.id.toString(),
            value: data,
        };
        if (isExist) {
            this.updateNestedField(parameters);
        }
        else {
            this.createNestedField(parameters);
        }
    }
    updateVisitsData({ visitorCode, mutData, visitsData, expirationTime, }) {
        var _a, _b;
        const { data } = visitsData;
        const isExist = mutData[visitorCode] && KameleoonData.VisitsData in mutData[visitorCode];
        const parameters = {
            expirationTime,
            data: mutData,
            key: KameleoonData.VisitsData,
            value: data,
            visitorCode,
        };
        if (isExist) {
            const existingVisits = mutData[visitorCode][KameleoonData.VisitsData];
            // --- Note ---
            // We are preserving the order of visits
            existingVisits.visits.forEach((visit) => {
                ListUtilities.insertVisitInOrderedListMutably({
                    list: data.visits,
                    visit: visit,
                });
            });
            const visitNumber = Math.max((_a = data.visitNumber) !== null && _a !== void 0 ? _a : data.visits.length - 1, data.visits.length - 1, (_b = existingVisits.visitNumber) !== null && _b !== void 0 ? _b : 0);
            this.updateField(Object.assign(Object.assign({}, parameters), { value: Object.assign(Object.assign({}, data), { visits: data.visits, visitNumber: visitNumber }) }));
        }
        else {
            this.createField(parameters);
        }
    }
    updatePersonalization({ visitorCode, mutData, personalization, expirationTime, }) {
        const { data } = personalization;
        const isExist = mutData[visitorCode] &&
            KameleoonData.Personalization in mutData[visitorCode];
        const parameters = {
            expirationTime,
            visitorCode,
            data: mutData,
            key: KameleoonData.Personalization,
            nestedKey: data.id.toString(),
            value: data,
        };
        if (isExist) {
            this.updateNestedField(parameters);
        }
        else {
            this.createNestedField(parameters);
        }
    }
    updateTargetedSegment({ visitorCode, mutData, targetedSegment, expirationTime, }) {
        const { data } = targetedSegment;
        const isExist = mutData[visitorCode] &&
            KameleoonData.TargetedSegment in mutData[visitorCode];
        const parameters = {
            expirationTime,
            visitorCode,
            data: mutData,
            key: KameleoonData.TargetedSegment,
            nestedKey: data.id.toString(),
            value: data,
        };
        if (isExist) {
            this.updateNestedField(parameters);
        }
        else {
            this.createNestedField(parameters);
        }
    }
    updateCommonData({ visitorCode, mutData, commonData, expirationTime, }) {
        const { data } = commonData;
        const isExist = mutData[visitorCode] && data.type in mutData[visitorCode];
        const parameters = {
            expirationTime,
            data: mutData,
            key: data.type,
            visitorCode,
            value: data,
        };
        if (isExist) {
            this.updateField(parameters);
        }
        else {
            this.createField(parameters);
        }
    }
    dereferenceData(data, visitorCode) {
        // --- Note ---
        // Visitor reference can not point to another visitor reference
        if (typeof data[visitorCode] === 'string') {
            return {
                visitorReference: data[visitorCode],
                data: data,
                isReference: true,
            };
        }
        return {
            visitorReference: visitorCode,
            data: data,
            isReference: false,
        };
    }
    deleteExpiredField(data, key) {
        if (!data) {
            return 0;
        }
        const dataKey = key;
        const isExpired = data[dataKey].expirationTime < Date.now();
        if (!isExpired) {
            return data[dataKey].expirationTime;
        }
        delete data[dataKey];
        return 0;
    }
    deleteNestedExpiredField(data, key) {
        if (!data[key]) {
            return 0;
        }
        const existingData = data[key];
        let closestCleanupTime;
        for (const [nestedKey, value] of Object.entries(existingData)) {
            if (!value) {
                continue;
            }
            const isExpired = value.expirationTime < Date.now();
            if (isExpired) {
                delete existingData[nestedKey];
            }
            else if (!closestCleanupTime ||
                value.expirationTime < closestCleanupTime) {
                closestCleanupTime = value.expirationTime;
            }
        }
        if (!Object.keys(existingData).length) {
            delete data[key];
        }
        return closestCleanupTime;
    }
    updateField({ key, value, data, visitorCode, expirationTime, }) {
        var _a;
        const existing = data[visitorCode][key];
        data[visitorCode][key] = Object.assign(Object.assign({}, value), { expirationTime: (_a = expirationTime !== null && expirationTime !== void 0 ? expirationTime : (existing.expirationTime && existing.expirationTime)) !== null && _a !== void 0 ? _a : Date.now() });
    }
    createField({ key, value, data, visitorCode, expirationTime, }) {
        data[visitorCode] = Object.assign(Object.assign({}, data[visitorCode]), { [key]: Object.assign(Object.assign({}, value), { expirationTime }) });
    }
    updateNestedField({ key, nestedKey, value, data, visitorCode, expirationTime, }) {
        var _a;
        const existing = data[visitorCode][key][nestedKey];
        data[visitorCode][key][nestedKey] = Object.assign(Object.assign({}, value), { expirationTime: (_a = expirationTime !== null && expirationTime !== void 0 ? expirationTime : existing === null || existing === void 0 ? void 0 : existing.expirationTime) !== null && _a !== void 0 ? _a : Date.now() });
    }
    createNestedField({ key, nestedKey, value, data, visitorCode, expirationTime, }) {
        var _a;
        if (!((_a = data[visitorCode]) === null || _a === void 0 ? void 0 : _a[key])) {
            data[visitorCode] = Object.assign(Object.assign({}, data[visitorCode]), { [key]: {
                    [nestedKey]: Object.assign(Object.assign({}, value), { expirationTime }),
                } });
        }
        else {
            data[visitorCode] = Object.assign(Object.assign({}, data[visitorCode]), { [key]: Object.assign(Object.assign({}, data[visitorCode][key]), { [nestedKey]: Object.assign(Object.assign({}, value), { expirationTime }) }) });
        }
    }
}

/**
 * @readonly
 * @enum {string} an Enum containing keys for Kameleoon SDK related data stored on storage
 * */
var KameleoonStorageKey;
(function (KameleoonStorageKey) {
    KameleoonStorageKey["ClientData"] = "kameleoonClientData";
    KameleoonStorageKey["TargetingData"] = "kameleoonTargetingData";
    KameleoonStorageKey["TrackingData"] = "kameleoonTrackingData";
    KameleoonStorageKey["VariationData"] = "kameleoonVariationData";
    KameleoonStorageKey["VisitorCode"] = "kameleoonVisitorCode";
    KameleoonStorageKey["ConsentData"] = "kameleoonConsentData";
    KameleoonStorageKey["DataInfo"] = "kameleoonDataInfo";
    KameleoonStorageKey["KameleoonSimulationFFData"] = "kameleoonSimulationFFData";
    KameleoonStorageKey["ForcedFeatureVariation"] = "kameleoonForcedFeatureVariation";
    KameleoonStorageKey["ForcedExperimentVariation"] = "kameleoonForcedExperimentVariation";
})(KameleoonStorageKey || (KameleoonStorageKey = {}));
const DEFAULT_CLIENT_CONFIGURATION = {
    data: DEFAULT_DATA_FILE_CONFIGURATION,
    lastUpdate: '',
};
// --- Note ---
// Not a real visit duration, rather a guaranteed minimum time
const VISIT_DURATION = 29 * 60000 /* Milliseconds.Minute */;

class IntegrityChecker {
    constructor(key) {
        this.key = key;
    }
    isDataValid(data) {
        switch (this.key) {
            case KameleoonStorageKey.ClientData:
                return this.checkClientDataIntegrity(data);
            case KameleoonStorageKey.TargetingData:
                return this.checkTargetingDataIntegrity(data);
            case KameleoonStorageKey.DataInfo:
                return this.checkDataInfoIntegrity(data);
            case KameleoonStorageKey.VariationData:
                return this.checkVariationDataIntegrity(data);
            case KameleoonStorageKey.TrackingData:
                return this.checkTrackingDataIntegrity(data);
            default:
                return true;
        }
    }
    getDefaultData() {
        switch (this.key) {
            case KameleoonStorageKey.ClientData:
                return this.getDefaultClientData();
            case KameleoonStorageKey.DataInfo:
                return { unsentData: {}, nextVisitTime: 0, mappingIdentifiers: {} };
            case KameleoonStorageKey.TrackingData:
                return { scheduledVisitors: {} };
            case KameleoonStorageKey.TargetingData:
            case KameleoonStorageKey.VariationData:
            case KameleoonStorageKey.ConsentData:
                return {};
            case KameleoonStorageKey.VisitorCode:
                return '';
            case KameleoonStorageKey.KameleoonSimulationFFData:
                return '';
            case KameleoonStorageKey.ForcedExperimentVariation:
                return {};
            case KameleoonStorageKey.ForcedFeatureVariation:
                return {};
            default:
                exhaustCheck(this.key);
        }
    }
    checkTrackingDataIntegrity(data) {
        return this.hasFields(data, ['scheduledVisitors']);
    }
    checkDataInfoIntegrity(data) {
        return this.hasFields(data, ['unsentData', 'nextVisitTime']);
    }
    checkVariationDataIntegrity(data) {
        const variations = Object.values(data);
        if (!variations.length) {
            return true;
        }
        const hasInvalidFields = (obj) => !this.hasFields(obj, ['status']) || this.hasFields(obj, ['isSent']);
        for (const variation of variations) {
            for (const value of Object.values(variation)) {
                if (hasInvalidFields(value)) {
                    return false;
                }
            }
        }
        return true;
    }
    checkClientDataIntegrity(data) {
        return this.hasFields(data, Object.keys(DEFAULT_CLIENT_CONFIGURATION));
    }
    checkTargetingDataIntegrity(data) {
        const visitorValues = Object.values(data);
        if (!visitorValues.length) {
            return true;
        }
        for (const visitorData of visitorValues) {
            // --- Note ---
            // If `visitorData` is a string, it means that it's a visitor reference
            if (typeof visitorData === 'string') {
                continue;
            }
            const hasInvalidFields = (obj) => !this.hasFields(obj, ['status']) ||
                this.hasFields(obj, ['sent']) ||
                this.hasFields(obj, ['timestampList']);
            for (const [key, data] of Object.entries(visitorData)) {
                if (Array.isArray(data)) {
                    return false;
                }
                switch (key) {
                    case KameleoonData.PageView:
                    case KameleoonData.Conversion:
                    case KameleoonData.Personalization:
                    case KameleoonData.TargetedSegment:
                    case KameleoonData.CustomData: {
                        const hasBadFields = Object.values(data).some((obj) => hasInvalidFields(obj));
                        if (hasBadFields) {
                            return false;
                        }
                        continue;
                    }
                    default: {
                        if (hasInvalidFields(data)) {
                            return false;
                        }
                    }
                }
            }
        }
        return true;
    }
    getDefaultClientData() {
        return Object.assign(Object.assign({}, DEFAULT_CLIENT_CONFIGURATION), { lastUpdate: new Date().toString() });
    }
    hasFields(obj, fields) {
        const keys = Object.keys(obj);
        if (!keys.length || !fields.length) {
            return false;
        }
        return fields.every((field) => keys.includes(field));
    }
}

// --- Note ---
// Named `DataStorage` to avoid collision with `Storage` from `window` API
class DataStorage {
    constructor(externalStorage, storageKey) {
        this.externalStorage = externalStorage;
        this.storageKey = storageKey;
        const integrityChecker = new IntegrityChecker(storageKey);
        const result = this.read();
        if (!result.ok) {
            if (result.error.type === KameleoonException.StorageEmpty) {
                const defaultData = integrityChecker.getDefaultData();
                this.write(defaultData);
            }
            return;
        }
        const data = result.data;
        if (!integrityChecker.isDataValid(data)) {
            const defaultData = integrityChecker.getDefaultData();
            this.write(defaultData);
        }
    }
    read() {
        try {
            const result = this.externalStorage.read(this.storageKey);
            if (result === null) {
                return buildExports.Err(new KameleoonError(KameleoonException.StorageEmpty));
            }
            // --- Note ---
            // Have to cast the type here to tell TS that `result.data` type  is a subset of `T` as we check it already in the default generic `StorageDataType` for `IExternalStorage`
            return buildExports.Ok(result);
        }
        catch (_) {
            KameleoonLogger.error `Failed to read data from storage: ${this.storageKey}`;
            return buildExports.Err(new KameleoonError(KameleoonException.StorageRead, this.storageKey));
        }
    }
    write(data) {
        try {
            this.externalStorage.write(this.storageKey, data);
            return buildExports.Ok();
        }
        catch (_) {
            KameleoonLogger.error `Failed to write data to storage: ${this.storageKey}`;
            return buildExports.Err(new KameleoonError(KameleoonException.StorageWrite, this.storageKey));
        }
    }
    update(data) {
        const result = this.read();
        if (!result.ok) {
            if (result.error.type === KameleoonException.StorageEmpty) {
                return this.write(data);
            }
            else {
                return result;
            }
        }
        const existingData = result.data;
        let newData;
        if (typeof existingData === 'string') {
            newData = data;
        }
        else {
            newData = Object.assign(Object.assign({}, existingData), data);
        }
        return this.write(newData);
    }
}

class StorageCleanupManager {
    constructor(externalStorage, cleanupInterval) {
        this.externalStorage = externalStorage;
        this.cleanupInterval = cleanupInterval;
        if (cleanupInterval > 0) {
            this.initCleanupInterval();
        }
    }
    initCleanupInterval() {
        for (const storageKey of Object.values(KameleoonStorageKey)) {
            let cleanupInterval = null;
            try {
                switch (storageKey) {
                    case KameleoonStorageKey.ForcedFeatureVariation:
                    case KameleoonStorageKey.ForcedExperimentVariation:
                    case KameleoonStorageKey.VariationData:
                    case KameleoonStorageKey.ConsentData:
                        KameleoonLogger.info `Starting cleanup for ${storageKey} with interval ${this.cleanupInterval}`;
                        cleanupInterval = setInterval(() => this.cleanupData(storageKey), this.cleanupInterval);
                        break;
                    case KameleoonStorageKey.ClientData:
                    case KameleoonStorageKey.TargetingData:
                    case KameleoonStorageKey.TrackingData:
                    case KameleoonStorageKey.VisitorCode:
                    case KameleoonStorageKey.DataInfo:
                    case KameleoonStorageKey.KameleoonSimulationFFData:
                        break;
                    default:
                        // check if all cases are handled
                        KameleoonLogger.error `Unknown storage key: ${storageKey} for initCleanupInterval.`;
                }
            }
            catch (Error) {
                if (cleanupInterval) {
                    clearInterval(cleanupInterval);
                }
                KameleoonLogger.error `Error while starting cleanup for ${storageKey} with interval ${this.cleanupInterval}`;
            }
        }
    }
    cleanupData(storageKey) {
        const dataResult = this.externalStorage.read(storageKey);
        if (!dataResult) {
            return;
        }
        const currentTime = Date.now();
        switch (storageKey) {
            case KameleoonStorageKey.VariationData:
                this.cleanupVariationData(dataResult, currentTime);
                break;
            case KameleoonStorageKey.ForcedFeatureVariation:
                this.cleanupForcedFeatureVariationData(dataResult, currentTime);
                break;
            case KameleoonStorageKey.ForcedExperimentVariation:
                this.cleanupForcedExperimentVariationData(dataResult, currentTime);
                break;
            case KameleoonStorageKey.ConsentData:
                this.cleanupConsentData(dataResult, currentTime);
                break;
            case KameleoonStorageKey.ClientData:
            case KameleoonStorageKey.TargetingData:
            case KameleoonStorageKey.TrackingData:
            case KameleoonStorageKey.VisitorCode:
            case KameleoonStorageKey.DataInfo:
            case KameleoonStorageKey.KameleoonSimulationFFData:
                break;
            default:
                KameleoonLogger.error `Unknown storage key: ${storageKey} for cleanupData.`;
        }
        this.externalStorage.write(storageKey, dataResult);
    }
    cleanupConsentData(consentData, currentTime) {
        for (const [visitorCode, consent] of Object.entries(consentData)) {
            // for consistency with the old data in the storage
            if (typeof consent === 'boolean') {
                consentData[visitorCode] = {
                    consent,
                    expirationTime: currentTime + this.cleanupInterval,
                };
                continue;
            }
            const value = consent;
            if (typeof value.expirationTime === 'number') {
                if (value.expirationTime < currentTime) {
                    delete consentData[visitorCode];
                }
            }
            else {
                value.expirationTime = currentTime + this.cleanupInterval;
            }
        }
    }
    cleanupVariationData(variationData, currentTime) {
        for (const [visitorCode, featureVariations] of Object.entries(variationData)) {
            this.cleanupObjectValues(featureVariations, currentTime);
            if (Object.keys(variationData[visitorCode]).length === 0) {
                delete variationData[visitorCode];
            }
        }
    }
    cleanupForcedFeatureVariationData(forcedFeatureVariationData, currentTime) {
        for (const [simulated, visitorData] of Object.entries(forcedFeatureVariationData)) {
            for (const [visitorCode, features] of Object.entries(visitorData)) {
                this.cleanupObjectValues(features, currentTime);
                if (Object.keys(forcedFeatureVariationData[Number(simulated)][visitorCode]).length === 0) {
                    delete forcedFeatureVariationData[Number(simulated)][visitorCode];
                }
            }
        }
    }
    cleanupForcedExperimentVariationData(forcedExperimentVariationData, currentTime) {
        for (const [visitorCode, experiments] of Object.entries(forcedExperimentVariationData)) {
            this.cleanupObjectValues(experiments, currentTime);
            if (Object.keys(forcedExperimentVariationData[visitorCode]).length === 0) {
                delete forcedExperimentVariationData[visitorCode];
            }
        }
    }
    cleanupObjectValues(obj, currentTime) {
        for (const [key, value] of Object.entries(obj)) {
            if (typeof value.expirationTime === 'number') {
                if (value.expirationTime < currentTime) {
                    delete obj[key];
                }
            }
            else {
                value.expirationTime = currentTime + this.cleanupInterval;
            }
        }
    }
}

var LegalConsent;
(function (LegalConsent) {
    LegalConsent[LegalConsent["Unknown"] = 0] = "Unknown";
    LegalConsent[LegalConsent["Given"] = 1] = "Given";
    LegalConsent[LegalConsent["NotGiven"] = 2] = "NotGiven";
})(LegalConsent || (LegalConsent = {}));

class TargetedSegment {
    constructor(id) {
        this.id = id;
        this.status = TrackingStatus.Unsent;
    }
    get url() {
        return UrlEventType.TargetingSegment + UrlParameter.Id + this.id;
    }
    get data() {
        return {
            id: this.id,
            type: KameleoonData.TargetedSegment,
            status: this.status,
        };
    }
    static _fromRaw(data) {
        const { id, status } = data;
        const targetedSegment = new TargetedSegment(id);
        targetedSegment.status = status;
        return targetedSegment;
    }
}

class DataManager {
    constructor({ dataStorage, infoStorage, cleanupInterval, packageInfo, }) {
        this.targetingTrees = new Map();
        this.mappingIdentifierCustomDataIndex = null;
        this.persistentCustomDataIndexes = new Set();
        this.localCustomDataIndexes = new Set();
        this.customDataIndexByName = new Map();
        this.cleanupIntervalId = null;
        KameleoonLogger.debug `CALL: new DataManager(dataStorage, infoStorage, cleanupInterval: ${cleanupInterval})`;
        this.dataStorage = dataStorage;
        this.infoStorage = infoStorage;
        this.dataProcessor = new DataProcessor(cleanupInterval, packageInfo);
        this.packageInfo = packageInfo;
        if (cleanupInterval) {
            const cleanupCallback = () => {
                this.cleanupData();
            };
            // --- Note ---
            // We can not make delayed code execution recoverable, as it might lead
            // to targeting data storage size overflow
            try {
                this.cleanupIntervalId = setInterval(cleanupCallback, cleanupInterval);
            }
            catch (err) {
                if (this.cleanupIntervalId) {
                    clearInterval(this.cleanupIntervalId);
                }
                KameleoonLogger.error `Failed to set cleanup interval: ${cleanupInterval}`;
                throw err;
            }
        }
        KameleoonLogger.debug `RETURN: new DataManager(dataStorage, infoStorage, cleanupInterval: ${cleanupInterval})`;
    }
    getUnsentData(visitorCode) {
        const infoResult = this.infoStorage.read();
        if (!infoResult.ok) {
            return [];
        }
        const infoData = infoResult.data;
        const targetingData = this.getVisitorData(visitorCode);
        if (!infoData.unsentData[visitorCode] || !targetingData) {
            return [];
        }
        const unsentDataKeys = infoData.unsentData[visitorCode];
        const isNextVisit = infoData.nextVisitTime <= Date.now();
        const filter = ({ status, key, cdIndex }) => {
            if (typeof cdIndex === 'number') {
                // --- Note ---
                // Persistent CustomData is mandatory for sending each time
                // but only once per visit
                if (this.persistentCustomDataIndexes.has(cdIndex) && isNextVisit) {
                    return true;
                }
            }
            return unsentDataKeys.includes(key) && status === TrackingStatus.Unsent;
        };
        if (isNextVisit) {
            infoData.nextVisitTime = Date.now() + VISIT_DURATION;
            this.infoStorage.write(infoData);
        }
        return this.getDataFromRaw(targetingData, filter);
    }
    getPendingData(visitorCode) {
        const targetingData = this.getVisitorData(visitorCode);
        if (!targetingData) {
            return [];
        }
        const filter = ({ status }) => status === TrackingStatus.Pending;
        return this.getDataFromRaw(targetingData, filter);
    }
    getDataFromRaw(targetingData, filter) {
        const resultData = [];
        for (const [key, data] of Object.entries(targetingData)) {
            if (!data) {
                continue;
            }
            switch (key) {
                case KameleoonData.CustomData: {
                    for (const customData of Object.values(data)) {
                        if (!customData) {
                            continue;
                        }
                        const { status, index } = customData;
                        if (filter({ status, key, cdIndex: index })) {
                            const customDataItem = CustomData$1._fromRaw(customData);
                            resultData.push(customDataItem);
                        }
                    }
                    break;
                }
                case KameleoonData.Conversion: {
                    for (const conversion of Object.values(data)) {
                        if (!conversion) {
                            continue;
                        }
                        if (filter({ status: conversion.status, key })) {
                            const customDataItem = Conversion$1._fromRaw(conversion);
                            resultData.push(customDataItem);
                        }
                    }
                    break;
                }
                case KameleoonData.PageView: {
                    const pageViewData = data;
                    for (const pageView of Object.values(pageViewData)) {
                        if (filter({ status: pageView.status, key })) {
                            const pageViewItem = PageView._fromRaw(pageView);
                            resultData.push(pageViewItem);
                        }
                    }
                    break;
                }
                case KameleoonData.TargetedSegment: {
                    const targetedSegmentData = data;
                    for (const targetedSegment of Object.values(targetedSegmentData)) {
                        if (filter({ status: targetedSegment.status, key })) {
                            const targetedSegmentItem = TargetedSegment._fromRaw(targetedSegment);
                            resultData.push(targetedSegmentItem);
                        }
                    }
                    break;
                }
                case KameleoonData.GeolocationData: {
                    const geolocationData = data;
                    if (!data) {
                        continue;
                    }
                    if (filter({ status: geolocationData.status, key })) {
                        const geolocationItem = GeolocationData._fromRaw(geolocationData);
                        resultData.push(geolocationItem);
                    }
                    break;
                }
                case KameleoonData.Browser: {
                    const browserData = data;
                    if (filter({ status: browserData.status, key })) {
                        const browserItem = Browser$1._fromRaw(browserData);
                        resultData.push(browserItem);
                    }
                    break;
                }
                case KameleoonData.Device: {
                    const deviceData = data;
                    if (filter({ status: deviceData.status, key })) {
                        const deviceItem = Device$1._fromRaw(deviceData);
                        resultData.push(deviceItem);
                    }
                    break;
                }
                case KameleoonData.OperatingSystem: {
                    const osData = data;
                    if (filter({ status: osData.status, key })) {
                        const osItem = OperatingSystem$1._fromRaw(osData);
                        resultData.push(osItem);
                    }
                }
            }
        }
        return resultData;
    }
    storeTrackedData(data) {
        this.storeDataForVisitors(data, false);
        const infoResult = this.infoStorage.read();
        if (!infoResult.ok) {
            return;
        }
        const unsentData = infoResult.data.unsentData;
        for (const [visitorCode, kameleoonData] of Object.entries(data)) {
            if (!unsentData[visitorCode]) {
                return;
            }
            const unsentDataKeys = new Set(unsentData[visitorCode]);
            kameleoonData.forEach(({ data }) => {
                if (unsentDataKeys.has(data.type)) {
                    unsentDataKeys.delete(data.type);
                }
            });
            const hasPersistentCustomData = kameleoonData.some(({ data }) => {
                if (data.type !== KameleoonData.CustomData) {
                    return false;
                }
                const { index } = data;
                return (this.persistentCustomDataIndexes.has(index) ||
                    this.mappingIdentifierCustomDataIndex === index);
            });
            if (hasPersistentCustomData) {
                unsentDataKeys.add(KameleoonData.CustomData);
            }
            unsentData[visitorCode] = Array.from(unsentDataKeys);
            if (!unsentData[visitorCode].length) {
                delete unsentData[visitorCode];
            }
        }
        this.infoStorage.write(infoResult.data);
    }
    /**
     * Store data for a single visitor
     */
    storeData({ visitorCode, data, track, }) {
        KameleoonLogger.debug `CALL: DataManager.storeDataForVisitor(vc: ${visitorCode}, track: ${track}, data: ${data})`;
        const result = this.storeDataInternal((infoData, targetingData) => {
            this.mutUpdateTargetingData({
                infoData,
                targetingData,
                visitorCode,
                kameleoonData: data,
                extendTtl: true,
                track,
            });
        });
        KameleoonLogger.debug `RETURN: DataManager.storeDataForVisitor(vc: ${visitorCode}, track: ${track}, data: ${data}) -> ${result}`;
        return result;
    }
    /**
     * Store data for multiple visitors
     */
    storeDataForVisitors(data, extendTtl) {
        KameleoonLogger.debug `CALL: DataManager.storeDataForVisitors(data: ${data}, extendTtl: ${extendTtl})`;
        const result = this.storeDataInternal((infoData, targetingData) => {
            for (const [visitorCode, kameleoonData] of Object.entries(data)) {
                this.mutUpdateTargetingData({
                    infoData,
                    targetingData,
                    visitorCode,
                    kameleoonData,
                    extendTtl,
                });
            }
        });
        KameleoonLogger.debug `RETURN: DataManager.storeDataForVisitors(data: ${data}, extendTtl: ${extendTtl}) -> ${result}`;
        return result;
    }
    // ========= Internal shared logic =========
    storeDataInternal(updater) {
        const dataResult = this.dataStorage.read();
        if (!dataResult.ok) {
            return dataResult;
        }
        const infoResult = this.infoStorage.read();
        if (!infoResult.ok) {
            return infoResult;
        }
        const targetingData = dataResult.data;
        const infoData = infoResult.data;
        updater(infoData, targetingData);
        this.cleanupData();
        this.infoStorage.write(infoData);
        return this.dataStorage.write(targetingData);
    }
    getTree(segment) {
        if (this.targetingTrees.has(segment.id)) {
            return this.targetingTrees.get(segment.id);
        }
        const targetingTree = new Tree(segment);
        this.targetingTrees.set(segment.id, targetingTree);
        return targetingTree;
    }
    clearTrees() {
        this.targetingTrees.clear();
    }
    isPersistentCustomData(dataItem) {
        if (!this.persistentCustomDataIndexes.size) {
            return false;
        }
        if (Utilities.isCustomData(dataItem)) {
            return this.persistentCustomDataIndexes.has(dataItem.data.index);
        }
        return false;
    }
    isUniqueIdentifier(visitorCode) {
        var _a;
        const targetingData = this.getVisitorData(visitorCode);
        const uniqueIdentifier = targetingData === null || targetingData === void 0 ? void 0 : targetingData[KameleoonData.UniqueIdentifier];
        return (_a = uniqueIdentifier === null || uniqueIdentifier === void 0 ? void 0 : uniqueIdentifier.value) !== null && _a !== void 0 ? _a : false;
    }
    getVisitorIdentifier(visitorCode) {
        var _a, _b, _c;
        const infoResult = this.infoStorage.read();
        if (!infoResult.ok) {
            return visitorCode;
        }
        const infoData = infoResult.data;
        (_a = infoData.mappingIdentifiers) !== null && _a !== void 0 ? _a : (infoData.mappingIdentifiers = {});
        return ((_c = (_b = infoData.mappingIdentifiers[visitorCode]) === null || _b === void 0 ? void 0 : _b.mappingIdentifier) !== null && _c !== void 0 ? _c : visitorCode);
    }
    getMappingIdentifier(visitorCode) {
        const infoResult = this.infoStorage.read();
        if (!infoResult.ok) {
            return undefined;
        }
        const infoData = infoResult.data;
        if (infoData.mappingIdentifiers) {
            return infoData.mappingIdentifiers[visitorCode];
        }
        return undefined;
    }
    setMappingIdentifier(visitorCode, mappingIdentifier) {
        var _a;
        const infoResult = this.infoStorage.read();
        if (!infoResult.ok) {
            return;
        }
        const infoData = infoResult.data;
        (_a = infoData.mappingIdentifiers) !== null && _a !== void 0 ? _a : (infoData.mappingIdentifiers = {});
        const currentMappingIdentifier = infoData.mappingIdentifiers[visitorCode];
        if (!currentMappingIdentifier ||
            currentMappingIdentifier.timestamp < mappingIdentifier.timestamp) {
            infoData.mappingIdentifiers[visitorCode] = mappingIdentifier;
            this.infoStorage.write(infoData);
        }
    }
    getVisitorData(visitorCode) {
        this.cleanupData();
        const storageData = this.dataStorage.read();
        if (!storageData.ok) {
            return undefined;
        }
        let { visitorReference, data, isReference } = this.dataProcessor.dereferenceData(storageData.data, visitorCode);
        if (this.packageInfo.isServer && isReference && !data[visitorReference]) {
            const infoData = this.infoStorage.read();
            if (infoData.ok && infoData.data.mappingIdentifiers) {
                delete infoData.data.mappingIdentifiers[visitorCode];
            }
            delete data[visitorCode];
            visitorReference = visitorCode;
        }
        return data[visitorReference];
    }
    getVisitorStoredDataTypes(visitorCode) {
        const targetingData = this.getVisitorData(visitorCode);
        if (!targetingData) {
            return new Set();
        }
        return new Set(Object.keys(targetingData));
    }
    getLinkedVisitor(visitorCode) {
        var _a, _b, _c;
        const storageData = this.dataStorage.read();
        if (!storageData.ok) {
            return null;
        }
        const visitorDataOrRef = storageData.data[visitorCode];
        // Direct reference case
        if (typeof visitorDataOrRef === 'string') {
            return visitorDataOrRef;
        }
        // No mapping index or no visitor data
        if (visitorDataOrRef == null ||
            this.mappingIdentifierCustomDataIndex == null) {
            return null;
        }
        const value = (_c = (_b = (_a = visitorDataOrRef[KameleoonData.CustomData]) === null || _a === void 0 ? void 0 : _a[this.mappingIdentifierCustomDataIndex]) === null || _b === void 0 ? void 0 : _b.value) === null || _c === void 0 ? void 0 : _c[0];
        return value !== null && value !== void 0 ? value : null;
    }
    mutUpdateTargetingData({ infoData, visitorCode, kameleoonData, targetingData, extendTtl, track, }) {
        var _a, _b, _c;
        for (const dataItem of kameleoonData) {
            // prcoess track status
            if (track === false) {
                dataItem.status = TrackingStatus.Sent;
            }
            // process custom data
            if (dataItem.data.type === KameleoonData.CustomData) {
                const customDataIsValid = this.processCustomData({
                    infoData,
                    customData: dataItem,
                    mutData: targetingData,
                    visitorCode,
                });
                if (!customDataIsValid) {
                    continue;
                }
            }
            //   process metadata of conversions
            if (dataItem.data.type === KameleoonData.Conversion) {
                const conversion = dataItem;
                if (((_b = (_a = conversion._metadata) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) > 0) {
                    conversion._metadata = (_c = conversion._metadata) === null || _c === void 0 ? void 0 : _c.filter((item) => this.trySetCustomDataIndexByName(item));
                }
            }
            const expirationTime = this.dataProcessor.mutUpdateData({
                infoData,
                visitorCode,
                mutData: targetingData,
                dataItem,
                extendTtl,
            });
            const nextCleanup = infoData.nextDataCleanup;
            if (!nextCleanup ||
                (nextCleanup && expirationTime && expirationTime < nextCleanup)) {
                infoData.nextDataCleanup = expirationTime;
            }
            if (dataItem.data.status === TrackingStatus.Unsent) {
                this.dataProcessor.mutAddUnsentData({
                    mutData: infoData,
                    visitorCode,
                    dataType: dataItem.data.type,
                });
            }
        }
    }
    cleanupData() {
        const result = this.dataStorage.read();
        const infoResult = this.infoStorage.read();
        if (!result.ok || !infoResult.ok) {
            return;
        }
        const data = result.data;
        const infoData = infoResult.data;
        const nextCleanup = infoData.nextDataCleanup;
        if (nextCleanup && nextCleanup < Date.now()) {
            const nextCleanupTime = this.dataProcessor.mutCleanupData(data, infoData);
            infoData.nextDataCleanup = nextCleanupTime || undefined;
            this.infoStorage.write(infoData);
            this.dataStorage.write(data);
        }
    }
    processCustomData({ infoData, mutData, customData, visitorCode, }) {
        var _a;
        const { data } = customData;
        const isDataValid = Boolean(data.value.length && data.value[0].length);
        if (!this.trySetCustomDataIndexByName(customData)) {
            return false;
        }
        if (data.index == CustomData$1.UNDEFINED_INDEX) {
            data.index = customData.index;
        }
        if (this.mappingIdentifierCustomDataIndex === data.index && isDataValid) {
            customData._isMappingIdentifier = true;
            const userId = data.value[0];
            if (visitorCode !== userId) {
                KameleoonLogger.info `Linked anonymous visitor ${visitorCode} with user ${userId}`;
                // --- Note ---
                // Associate linked visitor codes
                this.dataProcessor.createReference({
                    infoData,
                    mutData,
                    visitorCode,
                    linkedVisitor: data.value[0],
                });
                (_a = infoData.mappingIdentifiers) !== null && _a !== void 0 ? _a : (infoData.mappingIdentifiers = {});
                infoData.mappingIdentifiers[userId] = {
                    mappingIdentifier: visitorCode,
                    timestamp: Date.now(),
                };
            }
        }
        if (this.localCustomDataIndexes.has(data.index)) {
            customData.status = TrackingStatus.Sent;
        }
        return true;
    }
    trySetCustomDataIndexByName(customData) {
        if (customData.index !== CustomData$1.UNDEFINED_INDEX)
            return true;
        if (!customData.name)
            return false;
        const cdIndex = this.customDataIndexByName.get(customData.name);
        if (cdIndex == null)
            return false;
        customData.index = cdIndex;
        return true;
    }
    get unsentDataVisitors() {
        const infoResult = this.infoStorage.read();
        if (!infoResult.ok) {
            return [];
        }
        return Object.keys(infoResult.data.unsentData);
    }
    get identifierCustomDataIndex() {
        return this.mappingIdentifierCustomDataIndex;
    }
    get trees() {
        return this.targetingTrees;
    }
    get storedCustomDataIndexes() {
        const result = this.dataStorage.read();
        if (!result.ok) {
            return new Set();
        }
        const targetingData = result.data;
        if (!(KameleoonData.CustomData in targetingData)) {
            return new Set();
        }
        const indexes = new Set();
        for (const index in Object.keys(targetingData[KameleoonData.CustomData])) {
            indexes.add(Number(index));
        }
        return indexes;
    }
    set customDataIndexes(customData) {
        var _a;
        const [customDataLocalOnlyIndexes, persistentCustomDataIndexes] = [[], []];
        const customDataIndexByName = new Map();
        customData.forEach((customData) => {
            if (customData.localOnly) {
                customDataLocalOnlyIndexes.push(customData.index);
            }
            if (customData.scope === "VISITOR" /* CustomDataScope.Visitor */) {
                persistentCustomDataIndexes.push(customData.index);
            }
            if (customData.name) {
                customDataIndexByName.set(customData.name, customData.index);
            }
        });
        this.mappingIdentifierCustomDataIndex =
            ((_a = customData.find((customData) => customData.isMappingIdentifier)) === null || _a === void 0 ? void 0 : _a.index) ||
                null;
        this.localCustomDataIndexes = new Set(customDataLocalOnlyIndexes);
        this.persistentCustomDataIndexes = new Set(persistentCustomDataIndexes);
        this.customDataIndexByName = customDataIndexByName;
    }
    getCustomDataIndexByName(name) {
        return this.customDataIndexByName.get(name);
    }
}

const VISITOR_CODE_LENGTH = 16;
const VISITOR_CODE_MAX_LENGTH = 255;
const DEFAULT_MAX_AGE = 60 * 60 * 24 * 365;
const PATH = '/';

/**
 * VisitorCodeManager - a class which manages visitor codes using cookies, offering functions to generate, retrieve,
 * and handle these codes while considering user consent.
 **/
class VisitorCodeManager {
    constructor() {
        this.isConsentRequired = false;
    }
    set consentRequired(isRequired) {
        this.isConsentRequired = isRequired;
    }
    get consentRequired() {
        return this.isConsentRequired;
    }
    set getData(callback) {
        this.getDataCallback = callback;
    }
    set setData(callback) {
        this.setDataCallback = callback;
    }
    get setData() {
        if (this.setDataCallback) {
            return this.setDataCallback;
        }
        throw new Error('Missing setDataCallback!');
    }
    validateVisitorCode(visitorCode) {
        if (visitorCode.length === 0) {
            return buildExports.Err(new KameleoonError(KameleoonException.VisitorCodeEmpty));
        }
        if (visitorCode.length > VISITOR_CODE_MAX_LENGTH) {
            return buildExports.Err(new KameleoonError(KameleoonException.VisitorCodeMaxLength));
        }
        return buildExports.Ok();
    }
    getVisitorCode(defaultVisitorCode) {
        KameleoonLogger.debug `CALL: VisitorCodeManager.getVisitorCode(defaultVisitorCode: ${defaultVisitorCode})`;
        if (!this.getDataCallback || !this.setDataCallback) {
            throw new Error('Missing getDataCallback or setDataCallback methods in getVisitorCode!');
        }
        let visitorCode;
        const existingVisitorCode = this.getDataCallback(KameleoonStorageKey.VisitorCode);
        if (existingVisitorCode) {
            visitorCode = existingVisitorCode;
        }
        if (!visitorCode) {
            if (defaultVisitorCode) {
                this.validateVisitorCode(defaultVisitorCode).throw();
                visitorCode = defaultVisitorCode;
                KameleoonLogger.debug `Used default visitor code: ${visitorCode}`;
            }
            else {
                visitorCode = this.generateVisitorCode();
                KameleoonLogger.debug `Generated new visitor code: ${visitorCode}`;
            }
        }
        this.processSimulatedVariations(visitorCode);
        if (!this.isConsentRequired) {
            this.setDataCallback({
                visitorCode,
                key: KameleoonStorageKey.VisitorCode,
                maxAge: DEFAULT_MAX_AGE,
                path: PATH,
            });
        }
        KameleoonLogger.debug `RETURN: VisitorCodeManager.getVisitorCode(defaultVisitorCode: ${defaultVisitorCode}) -> (visitorCode: ${visitorCode})`;
        return visitorCode;
    }
    processSimulatedVariations(visitorCode) {
        if (this.variationConfiguration) {
            const simulatedVariationsData = this.getSimulatedVariations(visitorCode);
            try {
                this.variationConfiguration
                    .clearSimulatedVariations(visitorCode)
                    .throw();
                if (simulatedVariationsData !== null &&
                    simulatedVariationsData.length > 0) {
                    this.variationConfiguration
                        .updateForcedFeatureVariations(visitorCode, simulatedVariationsData)
                        .throw();
                }
            }
            catch (error) {
                if (error instanceof Error) {
                    KameleoonLogger.error `Failed to process simulated variations: ${error.message}`;
                }
            }
        }
    }
    getSimulatedVariations(visitorCode) {
        KameleoonLogger.debug `CALL: VisitorCodeManager.getSimulatedVariations(visitorCode: ${visitorCode})`;
        const simulatedVariationsData = this.getDataCallback(KameleoonStorageKey.KameleoonSimulationFFData);
        let variations = null;
        if (typeof simulatedVariationsData === 'string' &&
            simulatedVariationsData.length > 0) {
            try {
                const parsed = JSON.parse(decodeURIComponent(simulatedVariationsData));
                if (parsed && typeof parsed === 'object') {
                    variations = Object.entries(parsed)
                        .map(([key, value]) => {
                        return this.variationConfiguration.simulatedVariationFromJson(key, value);
                    })
                        .filter((variation) => variation !== null);
                }
            }
            catch (error) {
                if (error instanceof Error) {
                    KameleoonLogger.error `Failed to parse simulated variations: ${error.message}`;
                }
            }
        }
        KameleoonLogger.debug `RETURN: VisitorCodeManager.getSimulatedVariations(visitorCode: ${visitorCode}) -> (variations: ${variations})`;
        return variations;
    }
    generateVisitorCode() {
        const characters = 'abcdefghijklmnopqrstuvwxyz0123456789';
        const randomCharacterArray = [];
        for (let i = 0; i < VISITOR_CODE_LENGTH; i++) {
            randomCharacterArray.push(characters[Math.floor(Math.random() * characters.length)]);
        }
        return randomCharacterArray.join('');
    }
    setVariationConfiguration(variationConfiguration) {
        if (!this.variationConfiguration) {
            this.variationConfiguration = variationConfiguration;
        }
    }
}

var sha256$2 = {exports: {}};

function commonjsRequire(path) {
	throw new Error('Could not dynamically require "' + path + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}

var core$1 = {exports: {}};

var _nodeResolve_empty = {};

var _nodeResolve_empty$1 = /*#__PURE__*/Object.freeze({
	__proto__: null,
	default: _nodeResolve_empty
});

var require$$0 = /*@__PURE__*/getAugmentedNamespace(_nodeResolve_empty$1);

var core = core$1.exports;

var hasRequiredCore;

function requireCore () {
	if (hasRequiredCore) return core$1.exports;
	hasRequiredCore = 1;
	(function (module, exports) {
(function (root, factory) {
			{
				// CommonJS
				module.exports = factory();
			}
		}(core, function () {

			/*globals window, global, require*/

			/**
			 * CryptoJS core components.
			 */
			var CryptoJS = CryptoJS || (function (Math, undefined$1) {

			    var crypto;

			    // Native crypto from window (Browser)
			    if (typeof window !== 'undefined' && window.crypto) {
			        crypto = window.crypto;
			    }

			    // Native crypto in web worker (Browser)
			    if (typeof self !== 'undefined' && self.crypto) {
			        crypto = self.crypto;
			    }

			    // Native crypto from worker
			    if (typeof globalThis !== 'undefined' && globalThis.crypto) {
			        crypto = globalThis.crypto;
			    }

			    // Native (experimental IE 11) crypto from window (Browser)
			    if (!crypto && typeof window !== 'undefined' && window.msCrypto) {
			        crypto = window.msCrypto;
			    }

			    // Native crypto from global (NodeJS)
			    if (!crypto && typeof commonjsGlobal !== 'undefined' && commonjsGlobal.crypto) {
			        crypto = commonjsGlobal.crypto;
			    }

			    // Native crypto import via require (NodeJS)
			    if (!crypto && typeof commonjsRequire === 'function') {
			        try {
			            crypto = require$$0;
			        } catch (err) {}
			    }

			    /*
			     * Cryptographically secure pseudorandom number generator
			     *
			     * As Math.random() is cryptographically not safe to use
			     */
			    var cryptoSecureRandomInt = function () {
			        if (crypto) {
			            // Use getRandomValues method (Browser)
			            if (typeof crypto.getRandomValues === 'function') {
			                try {
			                    return crypto.getRandomValues(new Uint32Array(1))[0];
			                } catch (err) {}
			            }

			            // Use randomBytes method (NodeJS)
			            if (typeof crypto.randomBytes === 'function') {
			                try {
			                    return crypto.randomBytes(4).readInt32LE();
			                } catch (err) {}
			            }
			        }

			        throw new Error('Native crypto module could not be used to get secure random number.');
			    };

			    /*
			     * Local polyfill of Object.create

			     */
			    var create = Object.create || (function () {
			        function F() {}

			        return function (obj) {
			            var subtype;

			            F.prototype = obj;

			            subtype = new F();

			            F.prototype = null;

			            return subtype;
			        };
			    }());

			    /**
			     * CryptoJS namespace.
			     */
			    var C = {};

			    /**
			     * Library namespace.
			     */
			    var C_lib = C.lib = {};

			    /**
			     * Base object for prototypal inheritance.
			     */
			    var Base = C_lib.Base = (function () {


			        return {
			            /**
			             * Creates a new object that inherits from this object.
			             *
			             * @param {Object} overrides Properties to copy into the new object.
			             *
			             * @return {Object} The new object.
			             *
			             * @static
			             *
			             * @example
			             *
			             *     var MyType = CryptoJS.lib.Base.extend({
			             *         field: 'value',
			             *
			             *         method: function () {
			             *         }
			             *     });
			             */
			            extend: function (overrides) {
			                // Spawn
			                var subtype = create(this);

			                // Augment
			                if (overrides) {
			                    subtype.mixIn(overrides);
			                }

			                // Create default initializer
			                if (!subtype.hasOwnProperty('init') || this.init === subtype.init) {
			                    subtype.init = function () {
			                        subtype.$super.init.apply(this, arguments);
			                    };
			                }

			                // Initializer's prototype is the subtype object
			                subtype.init.prototype = subtype;

			                // Reference supertype
			                subtype.$super = this;

			                return subtype;
			            },

			            /**
			             * Extends this object and runs the init method.
			             * Arguments to create() will be passed to init().
			             *
			             * @return {Object} The new object.
			             *
			             * @static
			             *
			             * @example
			             *
			             *     var instance = MyType.create();
			             */
			            create: function () {
			                var instance = this.extend();
			                instance.init.apply(instance, arguments);

			                return instance;
			            },

			            /**
			             * Initializes a newly created object.
			             * Override this method to add some logic when your objects are created.
			             *
			             * @example
			             *
			             *     var MyType = CryptoJS.lib.Base.extend({
			             *         init: function () {
			             *             // ...
			             *         }
			             *     });
			             */
			            init: function () {
			            },

			            /**
			             * Copies properties into this object.
			             *
			             * @param {Object} properties The properties to mix in.
			             *
			             * @example
			             *
			             *     MyType.mixIn({
			             *         field: 'value'
			             *     });
			             */
			            mixIn: function (properties) {
			                for (var propertyName in properties) {
			                    if (properties.hasOwnProperty(propertyName)) {
			                        this[propertyName] = properties[propertyName];
			                    }
			                }

			                // IE won't copy toString using the loop above
			                if (properties.hasOwnProperty('toString')) {
			                    this.toString = properties.toString;
			                }
			            },

			            /**
			             * Creates a copy of this object.
			             *
			             * @return {Object} The clone.
			             *
			             * @example
			             *
			             *     var clone = instance.clone();
			             */
			            clone: function () {
			                return this.init.prototype.extend(this);
			            }
			        };
			    }());

			    /**
			     * An array of 32-bit words.
			     *
			     * @property {Array} words The array of 32-bit words.
			     * @property {number} sigBytes The number of significant bytes in this word array.
			     */
			    var WordArray = C_lib.WordArray = Base.extend({
			        /**
			         * Initializes a newly created word array.
			         *
			         * @param {Array} words (Optional) An array of 32-bit words.
			         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
			         *
			         * @example
			         *
			         *     var wordArray = CryptoJS.lib.WordArray.create();
			         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
			         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
			         */
			        init: function (words, sigBytes) {
			            words = this.words = words || [];

			            if (sigBytes != undefined$1) {
			                this.sigBytes = sigBytes;
			            } else {
			                this.sigBytes = words.length * 4;
			            }
			        },

			        /**
			         * Converts this word array to a string.
			         *
			         * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
			         *
			         * @return {string} The stringified word array.
			         *
			         * @example
			         *
			         *     var string = wordArray + '';
			         *     var string = wordArray.toString();
			         *     var string = wordArray.toString(CryptoJS.enc.Utf8);
			         */
			        toString: function (encoder) {
			            return (encoder || Hex).stringify(this);
			        },

			        /**
			         * Concatenates a word array to this word array.
			         *
			         * @param {WordArray} wordArray The word array to append.
			         *
			         * @return {WordArray} This word array.
			         *
			         * @example
			         *
			         *     wordArray1.concat(wordArray2);
			         */
			        concat: function (wordArray) {
			            // Shortcuts
			            var thisWords = this.words;
			            var thatWords = wordArray.words;
			            var thisSigBytes = this.sigBytes;
			            var thatSigBytes = wordArray.sigBytes;

			            // Clamp excess bits
			            this.clamp();

			            // Concat
			            if (thisSigBytes % 4) {
			                // Copy one byte at a time
			                for (var i = 0; i < thatSigBytes; i++) {
			                    var thatByte = (thatWords[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
			                    thisWords[(thisSigBytes + i) >>> 2] |= thatByte << (24 - ((thisSigBytes + i) % 4) * 8);
			                }
			            } else {
			                // Copy one word at a time
			                for (var j = 0; j < thatSigBytes; j += 4) {
			                    thisWords[(thisSigBytes + j) >>> 2] = thatWords[j >>> 2];
			                }
			            }
			            this.sigBytes += thatSigBytes;

			            // Chainable
			            return this;
			        },

			        /**
			         * Removes insignificant bits.
			         *
			         * @example
			         *
			         *     wordArray.clamp();
			         */
			        clamp: function () {
			            // Shortcuts
			            var words = this.words;
			            var sigBytes = this.sigBytes;

			            // Clamp
			            words[sigBytes >>> 2] &= 0xffffffff << (32 - (sigBytes % 4) * 8);
			            words.length = Math.ceil(sigBytes / 4);
			        },

			        /**
			         * Creates a copy of this word array.
			         *
			         * @return {WordArray} The clone.
			         *
			         * @example
			         *
			         *     var clone = wordArray.clone();
			         */
			        clone: function () {
			            var clone = Base.clone.call(this);
			            clone.words = this.words.slice(0);

			            return clone;
			        },

			        /**
			         * Creates a word array filled with random bytes.
			         *
			         * @param {number} nBytes The number of random bytes to generate.
			         *
			         * @return {WordArray} The random word array.
			         *
			         * @static
			         *
			         * @example
			         *
			         *     var wordArray = CryptoJS.lib.WordArray.random(16);
			         */
			        random: function (nBytes) {
			            var words = [];

			            for (var i = 0; i < nBytes; i += 4) {
			                words.push(cryptoSecureRandomInt());
			            }

			            return new WordArray.init(words, nBytes);
			        }
			    });

			    /**
			     * Encoder namespace.
			     */
			    var C_enc = C.enc = {};

			    /**
			     * Hex encoding strategy.
			     */
			    var Hex = C_enc.Hex = {
			        /**
			         * Converts a word array to a hex string.
			         *
			         * @param {WordArray} wordArray The word array.
			         *
			         * @return {string} The hex string.
			         *
			         * @static
			         *
			         * @example
			         *
			         *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
			         */
			        stringify: function (wordArray) {
			            // Shortcuts
			            var words = wordArray.words;
			            var sigBytes = wordArray.sigBytes;

			            // Convert
			            var hexChars = [];
			            for (var i = 0; i < sigBytes; i++) {
			                var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
			                hexChars.push((bite >>> 4).toString(16));
			                hexChars.push((bite & 0x0f).toString(16));
			            }

			            return hexChars.join('');
			        },

			        /**
			         * Converts a hex string to a word array.
			         *
			         * @param {string} hexStr The hex string.
			         *
			         * @return {WordArray} The word array.
			         *
			         * @static
			         *
			         * @example
			         *
			         *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
			         */
			        parse: function (hexStr) {
			            // Shortcut
			            var hexStrLength = hexStr.length;

			            // Convert
			            var words = [];
			            for (var i = 0; i < hexStrLength; i += 2) {
			                words[i >>> 3] |= parseInt(hexStr.substr(i, 2), 16) << (24 - (i % 8) * 4);
			            }

			            return new WordArray.init(words, hexStrLength / 2);
			        }
			    };

			    /**
			     * Latin1 encoding strategy.
			     */
			    var Latin1 = C_enc.Latin1 = {
			        /**
			         * Converts a word array to a Latin1 string.
			         *
			         * @param {WordArray} wordArray The word array.
			         *
			         * @return {string} The Latin1 string.
			         *
			         * @static
			         *
			         * @example
			         *
			         *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
			         */
			        stringify: function (wordArray) {
			            // Shortcuts
			            var words = wordArray.words;
			            var sigBytes = wordArray.sigBytes;

			            // Convert
			            var latin1Chars = [];
			            for (var i = 0; i < sigBytes; i++) {
			                var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
			                latin1Chars.push(String.fromCharCode(bite));
			            }

			            return latin1Chars.join('');
			        },

			        /**
			         * Converts a Latin1 string to a word array.
			         *
			         * @param {string} latin1Str The Latin1 string.
			         *
			         * @return {WordArray} The word array.
			         *
			         * @static
			         *
			         * @example
			         *
			         *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
			         */
			        parse: function (latin1Str) {
			            // Shortcut
			            var latin1StrLength = latin1Str.length;

			            // Convert
			            var words = [];
			            for (var i = 0; i < latin1StrLength; i++) {
			                words[i >>> 2] |= (latin1Str.charCodeAt(i) & 0xff) << (24 - (i % 4) * 8);
			            }

			            return new WordArray.init(words, latin1StrLength);
			        }
			    };

			    /**
			     * UTF-8 encoding strategy.
			     */
			    var Utf8 = C_enc.Utf8 = {
			        /**
			         * Converts a word array to a UTF-8 string.
			         *
			         * @param {WordArray} wordArray The word array.
			         *
			         * @return {string} The UTF-8 string.
			         *
			         * @static
			         *
			         * @example
			         *
			         *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
			         */
			        stringify: function (wordArray) {
			            try {
			                return decodeURIComponent(escape(Latin1.stringify(wordArray)));
			            } catch (e) {
			                throw new Error('Malformed UTF-8 data');
			            }
			        },

			        /**
			         * Converts a UTF-8 string to a word array.
			         *
			         * @param {string} utf8Str The UTF-8 string.
			         *
			         * @return {WordArray} The word array.
			         *
			         * @static
			         *
			         * @example
			         *
			         *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
			         */
			        parse: function (utf8Str) {
			            return Latin1.parse(unescape(encodeURIComponent(utf8Str)));
			        }
			    };

			    /**
			     * Abstract buffered block algorithm template.
			     *
			     * The property blockSize must be implemented in a concrete subtype.
			     *
			     * @property {number} _minBufferSize The number of blocks that should be kept unprocessed in the buffer. Default: 0
			     */
			    var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm = Base.extend({
			        /**
			         * Resets this block algorithm's data buffer to its initial state.
			         *
			         * @example
			         *
			         *     bufferedBlockAlgorithm.reset();
			         */
			        reset: function () {
			            // Initial values
			            this._data = new WordArray.init();
			            this._nDataBytes = 0;
			        },

			        /**
			         * Adds new data to this block algorithm's buffer.
			         *
			         * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
			         *
			         * @example
			         *
			         *     bufferedBlockAlgorithm._append('data');
			         *     bufferedBlockAlgorithm._append(wordArray);
			         */
			        _append: function (data) {
			            // Convert string to WordArray, else assume WordArray already
			            if (typeof data == 'string') {
			                data = Utf8.parse(data);
			            }

			            // Append
			            this._data.concat(data);
			            this._nDataBytes += data.sigBytes;
			        },

			        /**
			         * Processes available data blocks.
			         *
			         * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
			         *
			         * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
			         *
			         * @return {WordArray} The processed data.
			         *
			         * @example
			         *
			         *     var processedData = bufferedBlockAlgorithm._process();
			         *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
			         */
			        _process: function (doFlush) {
			            var processedWords;

			            // Shortcuts
			            var data = this._data;
			            var dataWords = data.words;
			            var dataSigBytes = data.sigBytes;
			            var blockSize = this.blockSize;
			            var blockSizeBytes = blockSize * 4;

			            // Count blocks ready
			            var nBlocksReady = dataSigBytes / blockSizeBytes;
			            if (doFlush) {
			                // Round up to include partial blocks
			                nBlocksReady = Math.ceil(nBlocksReady);
			            } else {
			                // Round down to include only full blocks,
			                // less the number of blocks that must remain in the buffer
			                nBlocksReady = Math.max((nBlocksReady | 0) - this._minBufferSize, 0);
			            }

			            // Count words ready
			            var nWordsReady = nBlocksReady * blockSize;

			            // Count bytes ready
			            var nBytesReady = Math.min(nWordsReady * 4, dataSigBytes);

			            // Process blocks
			            if (nWordsReady) {
			                for (var offset = 0; offset < nWordsReady; offset += blockSize) {
			                    // Perform concrete-algorithm logic
			                    this._doProcessBlock(dataWords, offset);
			                }

			                // Remove processed words
			                processedWords = dataWords.splice(0, nWordsReady);
			                data.sigBytes -= nBytesReady;
			            }

			            // Return processed words
			            return new WordArray.init(processedWords, nBytesReady);
			        },

			        /**
			         * Creates a copy of this object.
			         *
			         * @return {Object} The clone.
			         *
			         * @example
			         *
			         *     var clone = bufferedBlockAlgorithm.clone();
			         */
			        clone: function () {
			            var clone = Base.clone.call(this);
			            clone._data = this._data.clone();

			            return clone;
			        },

			        _minBufferSize: 0
			    });

			    /**
			     * Abstract hasher template.
			     *
			     * @property {number} blockSize The number of 32-bit words this hasher operates on. Default: 16 (512 bits)
			     */
			    C_lib.Hasher = BufferedBlockAlgorithm.extend({
			        /**
			         * Configuration options.
			         */
			        cfg: Base.extend(),

			        /**
			         * Initializes a newly created hasher.
			         *
			         * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
			         *
			         * @example
			         *
			         *     var hasher = CryptoJS.algo.SHA256.create();
			         */
			        init: function (cfg) {
			            // Apply config defaults
			            this.cfg = this.cfg.extend(cfg);

			            // Set initial values
			            this.reset();
			        },

			        /**
			         * Resets this hasher to its initial state.
			         *
			         * @example
			         *
			         *     hasher.reset();
			         */
			        reset: function () {
			            // Reset data buffer
			            BufferedBlockAlgorithm.reset.call(this);

			            // Perform concrete-hasher logic
			            this._doReset();
			        },

			        /**
			         * Updates this hasher with a message.
			         *
			         * @param {WordArray|string} messageUpdate The message to append.
			         *
			         * @return {Hasher} This hasher.
			         *
			         * @example
			         *
			         *     hasher.update('message');
			         *     hasher.update(wordArray);
			         */
			        update: function (messageUpdate) {
			            // Append
			            this._append(messageUpdate);

			            // Update the hash
			            this._process();

			            // Chainable
			            return this;
			        },

			        /**
			         * Finalizes the hash computation.
			         * Note that the finalize operation is effectively a destructive, read-once operation.
			         *
			         * @param {WordArray|string} messageUpdate (Optional) A final message update.
			         *
			         * @return {WordArray} The hash.
			         *
			         * @example
			         *
			         *     var hash = hasher.finalize();
			         *     var hash = hasher.finalize('message');
			         *     var hash = hasher.finalize(wordArray);
			         */
			        finalize: function (messageUpdate) {
			            // Final message update
			            if (messageUpdate) {
			                this._append(messageUpdate);
			            }

			            // Perform concrete-hasher logic
			            var hash = this._doFinalize();

			            return hash;
			        },

			        blockSize: 512/32,

			        /**
			         * Creates a shortcut function to a hasher's object interface.
			         *
			         * @param {Hasher} hasher The hasher to create a helper for.
			         *
			         * @return {Function} The shortcut function.
			         *
			         * @static
			         *
			         * @example
			         *
			         *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
			         */
			        _createHelper: function (hasher) {
			            return function (message, cfg) {
			                return new hasher.init(cfg).finalize(message);
			            };
			        },

			        /**
			         * Creates a shortcut function to the HMAC's object interface.
			         *
			         * @param {Hasher} hasher The hasher to use in this HMAC helper.
			         *
			         * @return {Function} The shortcut function.
			         *
			         * @static
			         *
			         * @example
			         *
			         *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
			         */
			        _createHmacHelper: function (hasher) {
			            return function (message, key) {
			                return new C_algo.HMAC.init(hasher, key).finalize(message);
			            };
			        }
			    });

			    /**
			     * Algorithm namespace.
			     */
			    var C_algo = C.algo = {};

			    return C;
			}(Math));


			return CryptoJS;

		})); 
	} (core$1));
	return core$1.exports;
}

var sha256$1 = sha256$2.exports;

var hasRequiredSha256;

function requireSha256 () {
	if (hasRequiredSha256) return sha256$2.exports;
	hasRequiredSha256 = 1;
	(function (module, exports) {
(function (root, factory) {
			{
				// CommonJS
				module.exports = factory(requireCore());
			}
		}(sha256$1, function (CryptoJS) {

			(function (Math) {
			    // Shortcuts
			    var C = CryptoJS;
			    var C_lib = C.lib;
			    var WordArray = C_lib.WordArray;
			    var Hasher = C_lib.Hasher;
			    var C_algo = C.algo;

			    // Initialization and round constants tables
			    var H = [];
			    var K = [];

			    // Compute constants
			    (function () {
			        function isPrime(n) {
			            var sqrtN = Math.sqrt(n);
			            for (var factor = 2; factor <= sqrtN; factor++) {
			                if (!(n % factor)) {
			                    return false;
			                }
			            }

			            return true;
			        }

			        function getFractionalBits(n) {
			            return ((n - (n | 0)) * 0x100000000) | 0;
			        }

			        var n = 2;
			        var nPrime = 0;
			        while (nPrime < 64) {
			            if (isPrime(n)) {
			                if (nPrime < 8) {
			                    H[nPrime] = getFractionalBits(Math.pow(n, 1 / 2));
			                }
			                K[nPrime] = getFractionalBits(Math.pow(n, 1 / 3));

			                nPrime++;
			            }

			            n++;
			        }
			    }());

			    // Reusable object
			    var W = [];

			    /**
			     * SHA-256 hash algorithm.
			     */
			    var SHA256 = C_algo.SHA256 = Hasher.extend({
			        _doReset: function () {
			            this._hash = new WordArray.init(H.slice(0));
			        },

			        _doProcessBlock: function (M, offset) {
			            // Shortcut
			            var H = this._hash.words;

			            // Working variables
			            var a = H[0];
			            var b = H[1];
			            var c = H[2];
			            var d = H[3];
			            var e = H[4];
			            var f = H[5];
			            var g = H[6];
			            var h = H[7];

			            // Computation
			            for (var i = 0; i < 64; i++) {
			                if (i < 16) {
			                    W[i] = M[offset + i] | 0;
			                } else {
			                    var gamma0x = W[i - 15];
			                    var gamma0  = ((gamma0x << 25) | (gamma0x >>> 7))  ^
			                                  ((gamma0x << 14) | (gamma0x >>> 18)) ^
			                                   (gamma0x >>> 3);

			                    var gamma1x = W[i - 2];
			                    var gamma1  = ((gamma1x << 15) | (gamma1x >>> 17)) ^
			                                  ((gamma1x << 13) | (gamma1x >>> 19)) ^
			                                   (gamma1x >>> 10);

			                    W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16];
			                }

			                var ch  = (e & f) ^ (~e & g);
			                var maj = (a & b) ^ (a & c) ^ (b & c);

			                var sigma0 = ((a << 30) | (a >>> 2)) ^ ((a << 19) | (a >>> 13)) ^ ((a << 10) | (a >>> 22));
			                var sigma1 = ((e << 26) | (e >>> 6)) ^ ((e << 21) | (e >>> 11)) ^ ((e << 7)  | (e >>> 25));

			                var t1 = h + sigma1 + ch + K[i] + W[i];
			                var t2 = sigma0 + maj;

			                h = g;
			                g = f;
			                f = e;
			                e = (d + t1) | 0;
			                d = c;
			                c = b;
			                b = a;
			                a = (t1 + t2) | 0;
			            }

			            // Intermediate hash value
			            H[0] = (H[0] + a) | 0;
			            H[1] = (H[1] + b) | 0;
			            H[2] = (H[2] + c) | 0;
			            H[3] = (H[3] + d) | 0;
			            H[4] = (H[4] + e) | 0;
			            H[5] = (H[5] + f) | 0;
			            H[6] = (H[6] + g) | 0;
			            H[7] = (H[7] + h) | 0;
			        },

			        _doFinalize: function () {
			            // Shortcuts
			            var data = this._data;
			            var dataWords = data.words;

			            var nBitsTotal = this._nDataBytes * 8;
			            var nBitsLeft = data.sigBytes * 8;

			            // Add padding
			            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
			            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
			            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = nBitsTotal;
			            data.sigBytes = dataWords.length * 4;

			            // Hash final blocks
			            this._process();

			            // Return final computed hash
			            return this._hash;
			        },

			        clone: function () {
			            var clone = Hasher.clone.call(this);
			            clone._hash = this._hash.clone();

			            return clone;
			        }
			    });

			    /**
			     * Shortcut function to the hasher's object interface.
			     *
			     * @param {WordArray|string} message The message to hash.
			     *
			     * @return {WordArray} The hash.
			     *
			     * @static
			     *
			     * @example
			     *
			     *     var hash = CryptoJS.SHA256('message');
			     *     var hash = CryptoJS.SHA256(wordArray);
			     */
			    C.SHA256 = Hasher._createHelper(SHA256);

			    /**
			     * Shortcut function to the HMAC's object interface.
			     *
			     * @param {WordArray|string} message The message to hash.
			     * @param {WordArray|string} key The secret key.
			     *
			     * @return {WordArray} The HMAC.
			     *
			     * @static
			     *
			     * @example
			     *
			     *     var hmac = CryptoJS.HmacSHA256(message, key);
			     */
			    C.HmacSHA256 = Hasher._createHmacHelper(SHA256);
			}(Math));


			return CryptoJS.SHA256;

		})); 
	} (sha256$2));
	return sha256$2.exports;
}

var sha256Exports = requireSha256();
var sha256 = /*@__PURE__*/getDefaultExportFromCjs(sha256Exports);

class Hasher {
    static getHashDoubleForMEGroup(visitorIdentifier, meGroupName) {
        return this.calculateHash(visitorIdentifier + meGroupName);
    }
    static getHashDouble({ visitorIdentifier, id, respoolTime, }) {
        let suffix = '';
        if (respoolTime) {
            suffix += String(respoolTime);
        }
        return this.calculateHash(visitorIdentifier + id + suffix);
    }
    // --- Note ---
    // `hashDouble` is a seeded pseudo-random number between 0 and 1
    // used for deciding what variation to assign
    // `calculateHash` algorithm is consistent between every SDK
    // and will always provide same pseudo-random value for the same input parameters
    static calculateHash(seed) {
        const hashDigest = sha256(seed).toString();
        return parseInt(hashDigest, 16) / Math.pow(2, 256);
    }
}

class VariationConfiguration {
    constructor(externalStorage, externalStorageForcedExperimentVariations, externalStorageForcedFeatureVariations, visitorCodeManager, clientConfiguration) {
        this.storage = externalStorage;
        this.storageForcedExperimentVariations =
            externalStorageForcedExperimentVariations;
        this.storageForcedFeatureVariations =
            externalStorageForcedFeatureVariations;
        this.visitorCodeManager = visitorCodeManager;
        this.clientConfiguration = clientConfiguration;
        visitorCodeManager.setVariationConfiguration(this);
    }
    updateDataStatus({ visitorCode, experimentIdList, status, }) {
        const result = this.storage.read();
        if (!result.ok) {
            return result;
        }
        let updatedVariationData = result.data;
        if (!updatedVariationData[visitorCode]) {
            updatedVariationData[visitorCode] = {};
        }
        for (const experimentId of experimentIdList) {
            updatedVariationData[visitorCode][experimentId] = Object.assign(Object.assign({}, updatedVariationData[visitorCode][experimentId]), { status });
        }
        return this.storage.write(updatedVariationData);
    }
    getUnsentData(visitorCode) {
        return this.getVariationData(visitorCode, (status) => status === TrackingStatus.Unsent);
    }
    getVisitorsWithUnsentData() {
        KameleoonLogger.debug `CALL: VariationConfiguration.unsentDataVisitors()`;
        const result = this.storage.read();
        if (!result.ok) {
            KameleoonLogger.debug `RETURN: VariationConfiguration.unsentDataVisitors() -> (result: ${result})`;
            return [];
        }
        const visitors = [];
        for (const [visitorCode, variations] of Object.entries(result.data)) {
            if (Object.values(variations).some((v) => v.status === TrackingStatus.Unsent)) {
                visitors.push(visitorCode);
            }
        }
        KameleoonLogger.debug `RETURN: VariationConfiguration.unsentDataVisitors() -> (visitors: ${visitors})`;
        return visitors;
    }
    getPendingData(visitorCode) {
        return this.getVariationData(visitorCode, (status) => status === TrackingStatus.Pending);
    }
    getStoredVariations(visitorCode) {
        const result = this.storage.read();
        if (!result.ok) {
            return result;
        }
        const featureFlagVariations = result.data[visitorCode];
        if (!featureFlagVariations) {
            return buildExports.Err(new KameleoonError(KameleoonException.StorageRead, visitorCode));
        }
        return buildExports.Ok(featureFlagVariations);
    }
    getVariation({ visitorCode, visitorIdentifier, featureFlag, targetingData, packageInfo, clientConfiguration, dataManager, legalConsent, track = true, withAssignment = false, }) {
        KameleoonLogger.debug `CALL: VariationConfiguration.getVariation(visitorCode: ${visitorCode}, visitorIdentifier: ${visitorIdentifier}, featureFlag: ${featureFlag}, targetingData: ${targetingData}, packageInfo: ${packageInfo}, clientConfiguration, dataManager, withAssignment: ${withAssignment})`;
        const { rules, featureKey, id: featureFlagId, defaultVariationKey, } = featureFlag;
        const consent = clientConfiguration.isConsentRequired
            ? legalConsent
            : LegalConsent.Given;
        for (const rule of rules) {
            const { segment, experimentId, id, exposition, respoolTime, variationByExposition, } = rule;
            const assignedTime = Date.now();
            const forcedVariationData = this.getForcedExperimentVariation(visitorCode, rule.experimentId);
            let forcedVariation = null;
            if (forcedVariationData.ok) {
                forcedVariation = forcedVariationData.data;
                if (forcedVariation === null || forcedVariation === void 0 ? void 0 : forcedVariation.forceTargeting) {
                    KameleoonLogger.info `Visitor ${visitorCode} has been forced targeted for ${rule}`;
                    const targetedVariation = this.createAndSaveForcedTargetedVariation(visitorCode, featureFlag, rule, forcedVariation, track, withAssignment, assignedTime);
                    KameleoonLogger.debug `RETURN: VariationConfiguration.getVariation(visitorCode: ${visitorCode}, visitorIdentifier: ${visitorIdentifier}, featureFlag: ${featureFlag}, targetingData: ${targetingData}, packageInfo: ${packageInfo}, clientConfiguration, dataManager, withAssignment: ${withAssignment}) -> (targetedVariation: ${targetedVariation})`;
                    return buildExports.Ok(targetedVariation);
                }
            }
            const targetingResult = Utilities.checkTargeting({
                segment,
                visitorCode,
                experimentId,
                targetingData,
                packageInfo,
                clientConfiguration,
                dataManager,
                variationConfiguration: this,
            });
            if (!targetingResult.ok) {
                KameleoonLogger.debug `RETURN: VariationConfiguration.getVariation(visitorCode: ${visitorCode}, visitorIdentifier: ${visitorIdentifier}, featureFlag: ${featureFlag}, targetingData: ${targetingData}, packageInfo: ${packageInfo}, clientConfiguration, dataManager, withAssignment: ${withAssignment}) -> (targetedVariation: ${targetingResult})`;
                return targetingResult;
            }
            if (!targetingResult.data) {
                continue;
            }
            KameleoonLogger.info `Visitor ${visitorCode} has been targeted for ${rule}`;
            if (forcedVariation) {
                const targetedVariation = this.createAndSaveForcedTargetedVariation(visitorCode, featureFlag, rule, forcedVariation, track, withAssignment, assignedTime);
                KameleoonLogger.debug `RETURN: VariationConfiguration.getVariation(visitorCode: ${visitorCode}, visitorIdentifier: ${visitorIdentifier}, featureFlag: ${featureFlag}, targetingData: ${targetingData}, packageInfo: ${packageInfo}, clientConfiguration, dataManager, withAssignment: ${withAssignment}) -> (targetedVariation: ${targetedVariation})`;
                return buildExports.Ok(targetedVariation);
            }
            // --- Note ---
            // Calculate new variation (and assign it if `withAssignment` is `true`)
            // First the the exposed rule is calculated and then the variation inside of it
            const ruleHash = Hasher.getHashDouble({
                visitorIdentifier,
                respoolTime,
                id: String(id),
            });
            KameleoonLogger.debug `Calculated ruleHash: ${ruleHash} for code: ${visitorIdentifier}`;
            if (ruleHash <= exposition) {
                // Checking if the evaluation is blocked due to the consent policy
                if (consent == LegalConsent.NotGiven &&
                    rule.type == "EXPERIMENTATION" /* RuleType.EXPERIMENTATION */) {
                    const behaviour = clientConfiguration.consentBlockingBehaviour;
                    if (behaviour == "PARTIALLY_BLOCK" /* ConsentBlockingBehaviour.PartiallyBlocked */) {
                        break;
                    }
                    return buildExports.Err(new KameleoonError(KameleoonException.FeatureFlagEnvironmentDisabled, `Evaluation of ${rule} is blocked because consent is not provided for visitor '${visitorCode}'`));
                }
                // evaluate with CB scores if applicable
                let variation = this.evaluateCBScores(rule, visitorIdentifier, targetingData);
                if (!variation) {
                    const variationHash = Hasher.getHashDouble({
                        visitorIdentifier,
                        respoolTime,
                        id: String(experimentId),
                    });
                    KameleoonLogger.debug `Calculated variationHash: ${variationHash} for code: ${visitorIdentifier}`;
                    variation = Utilities.getVariationByHash(variationByExposition, variationHash);
                }
                if (variation) {
                    if (withAssignment) {
                        this.updateStoredVariations(visitorCode, {
                            [experimentId]: {
                                variationId: variation.variationId,
                                isTargetedRule: rule.type === "TARGETED_DELIVERY" /* RuleType.TARGETED_DELIVERY */,
                                status: track ? TrackingStatus.Unsent : TrackingStatus.Sent,
                                assignedTime,
                            },
                        });
                    }
                    const targetedVariation = {
                        variationId: variation.variationId,
                        variationKey: variation.variationKey,
                        rule,
                        featureFlagId,
                        featureKey,
                        experimentId,
                        isTargetedRule: rule.type === "TARGETED_DELIVERY" /* RuleType.TARGETED_DELIVERY */,
                    };
                    KameleoonLogger.debug `RETURN: VariationConfiguration.getVariation(visitorCode: ${visitorCode}, visitorIdentifier: ${visitorIdentifier}, featureFlag: ${featureFlag}, targetingData: ${targetingData}, packageInfo: ${packageInfo}, clientConfiguration, dataManager, withAssignment: ${withAssignment}) -> (targetedVariation: ${targetedVariation})`;
                    return buildExports.Ok(targetedVariation);
                }
            }
            if (rule.type === "TARGETED_DELIVERY" /* RuleType.TARGETED_DELIVERY */) {
                const targetedVariation = {
                    featureKey,
                    featureFlagId,
                    experimentId: null,
                    variationKey: defaultVariationKey,
                    variationId: null,
                    rule: null,
                    isTargetedRule: true,
                };
                KameleoonLogger.debug `RETURN: VariationConfiguration.getVariation(visitorCode: ${visitorCode}, visitorIdentifier: ${visitorIdentifier}, featureFlag: ${featureFlag}, targetingData: ${targetingData}, packageInfo: ${packageInfo}, clientConfiguration, dataManager, withAssignment: ${withAssignment}) -> (targetedVariation: ${targetedVariation})`;
                return buildExports.Ok(targetedVariation);
            }
        }
        const targetedVariation = {
            featureKey,
            featureFlagId,
            experimentId: null,
            variationKey: defaultVariationKey,
            variationId: null,
            rule: null,
            isTargetedRule: false,
        };
        KameleoonLogger.debug `RETURN: VariationConfiguration.getVariation(visitorCode: ${visitorCode}, visitorIdentifier: ${visitorIdentifier}, featureFlag: ${featureFlag}, targetingData: ${targetingData}, packageInfo: ${packageInfo}, clientConfiguration, dataManager, withAssignment: ${withAssignment}) -> (targetedVariation: ${targetedVariation})`;
        return buildExports.Ok(targetedVariation);
    }
    createAndSaveForcedTargetedVariation(visitorCode, featureFlag, rule, forcedVariation, track, withAssignment, assignedTime) {
        const targetedVariation = {
            variationKey: forcedVariation.varByExp.variationKey,
            variationId: forcedVariation.varByExp.variationId,
            rule,
            featureFlagId: featureFlag.id,
            featureKey: featureFlag.featureKey,
            experimentId: rule.experimentId,
            isTargetedRule: rule.type === "TARGETED_DELIVERY" /* RuleType.TARGETED_DELIVERY */,
        };
        if (withAssignment) {
            this.updateStoredVariations(visitorCode, {
                [rule.experimentId]: {
                    variationId: targetedVariation.variationId,
                    isTargetedRule: rule.type === "TARGETED_DELIVERY" /* RuleType.TARGETED_DELIVERY */,
                    status: track ? TrackingStatus.Unsent : TrackingStatus.Sent,
                    assignedTime,
                },
            });
        }
        return targetedVariation;
    }
    updateStoredVariations(visitorCode, variationData) {
        KameleoonLogger.debug `CALL: VariationConfiguration.updateStoredVariations(visitorCode: ${visitorCode}, variationData: ${variationData})`;
        const result = this.storage.read();
        if (!result.ok) {
            KameleoonLogger.debug `RETURN: VariationConfiguration.updateStoredVariations(visitorCode: ${visitorCode}, variationData: ${variationData}) -> (result: ${result})`;
            return result;
        }
        let updatedVariationData = result.data;
        if (!updatedVariationData[visitorCode]) {
            updatedVariationData[visitorCode] = {};
        }
        for (const experimentId in variationData) {
            updatedVariationData[visitorCode][experimentId] =
                variationData[experimentId];
        }
        const resultWrite = this.storage.write(updatedVariationData);
        KameleoonLogger.debug `RETURN: VariationConfiguration.updateStoredVariations(visitorCode: ${visitorCode}, variationData: ${variationData}) -> (resultWrite: ${resultWrite})`;
        return resultWrite;
    }
    getVariationData(visitorCode, filter) {
        const result = this.getStoredVariations(visitorCode);
        if (!result.ok) {
            return [];
        }
        const resultData = [];
        for (const [experimentId, variationData] of Object.entries(result.data)) {
            if (filter(variationData.status)) {
                resultData.push({
                    experimentId: Number(experimentId),
                    variationId: variationData.variationId,
                    isTargetedRule: variationData.isTargetedRule,
                });
            }
        }
        return resultData;
    }
    updateForcedExperimentVariation(visitorCode, experimentId, forcedExperimentVariation) {
        KameleoonLogger.debug `CALL: VariationConfiguration.updateForcedExperimentVariation(visitorCode: ${visitorCode}, experimentId: ${experimentId}, forcedExperimentVariation: ${forcedExperimentVariation})`;
        const result = this.storageForcedExperimentVariations.read();
        if (!result.ok) {
            KameleoonLogger.debug `RETURN: VariationConfiguration.updateForcedExperimentVariation(visitorCode: ${visitorCode}, experimentId: ${experimentId}, forcedExperimentVariation: ${forcedExperimentVariation}) -> (result: ${result})`;
            return result;
        }
        let updatedForcedVariationData = result.data;
        if (!updatedForcedVariationData[visitorCode]) {
            updatedForcedVariationData[visitorCode] = {};
        }
        if (forcedExperimentVariation) {
            updatedForcedVariationData[visitorCode][experimentId] =
                forcedExperimentVariation;
        }
        else {
            delete updatedForcedVariationData[visitorCode][experimentId];
        }
        const resultWrite = this.storageForcedExperimentVariations.write(updatedForcedVariationData);
        KameleoonLogger.debug `RETURN: VariationConfiguration.updateForcedExperimentVariation(visitorCode: ${visitorCode}, experimentId: ${experimentId}, forcedExperimentVariation: ${forcedExperimentVariation}) -> (resultWrite: ${resultWrite})`;
        return resultWrite;
    }
    updateForcedFeatureVariations(visitorCode, forcedFeatureVariations) {
        KameleoonLogger.debug `CALL: VariationConfiguration.updateForcedFeatureVariations(visitorCode: ${visitorCode}, forcedFeatureVariations: ${forcedFeatureVariations})`;
        const result = this.storageForcedFeatureVariations.read();
        if (!result.ok) {
            KameleoonLogger.debug `RETURN: VariationConfiguration.updateForcedFeatureVariations(visitorCode: ${visitorCode}, forcedFeatureVariations: ${forcedFeatureVariations}) -> (result: ${result})`;
            return result;
        }
        let updatedVariationData = result.data;
        if (!updatedVariationData[0]) {
            updatedVariationData[0] = {};
        }
        if (!updatedVariationData[1]) {
            updatedVariationData[1] = {};
        }
        const updatedForcedFeatureVariationData = updatedVariationData[0];
        const updatedSimulatedFeatureVariationData = updatedVariationData[1];
        if (!updatedForcedFeatureVariationData[visitorCode]) {
            updatedForcedFeatureVariationData[visitorCode] = {};
        }
        if (!updatedSimulatedFeatureVariationData[visitorCode]) {
            updatedSimulatedFeatureVariationData[visitorCode] = {};
        }
        forcedFeatureVariations.forEach((forcedFeatureVariation) => {
            const targetData = forcedFeatureVariation.simulated
                ? updatedSimulatedFeatureVariationData[visitorCode]
                : updatedForcedFeatureVariationData[visitorCode];
            targetData[forcedFeatureVariation.featureKey] = forcedFeatureVariation;
        });
        const resultWrite = this.storageForcedFeatureVariations.write(updatedVariationData);
        KameleoonLogger.debug `RETURN: VariationConfiguration.updateForcedFeatureVariations(visitorCode: ${visitorCode}, forcedFeatureVariations: ${forcedFeatureVariations}) -> (resultWrite: ${resultWrite})`;
        return resultWrite;
    }
    clearSimulatedVariations(visitorCode) {
        var _a;
        KameleoonLogger.debug `CALL: VariationConfiguration.clearSimulatedVariations(visitorCode: ${visitorCode})`;
        const result = this.storageForcedFeatureVariations.read();
        if (!result.ok) {
            KameleoonLogger.debug `RETURN: VariationConfiguration.clearSimulatedVariations(visitorCode: ${visitorCode}) -> (result: ${result})`;
            return result;
        }
        let resultWrite;
        const updatedVariationData = result.data;
        if ((_a = updatedVariationData === null || updatedVariationData === void 0 ? void 0 : updatedVariationData[1]) === null || _a === void 0 ? void 0 : _a[visitorCode]) {
            delete updatedVariationData[1][visitorCode];
            resultWrite =
                this.storageForcedFeatureVariations.write(updatedVariationData);
        }
        else {
            resultWrite = buildExports.Ok();
        }
        KameleoonLogger.debug `RETURN: VariationConfiguration.clearSimulatedVariations(visitorCode: ${visitorCode}) -> (resultWrite: ${resultWrite})`;
        return resultWrite;
    }
    getForcedFeatureVariation(visitorCode, featureKey) {
        var _a, _b, _c, _d;
        KameleoonLogger.debug `CALL: VariationConfiguration.getForcedFeatureVariation(visitorCode: ${visitorCode}, featureKey: ${featureKey})`;
        const result = this.storageForcedFeatureVariations.read();
        if (!result.ok) {
            KameleoonLogger.debug `RETURN: VariationConfiguration.getForcedFeatureVariation(visitorCode: ${visitorCode}, featureKey: ${featureKey}) -> (simulatedResult: ${result})`;
            return result;
        }
        const simulatedData = (_b = (_a = result.data[1]) === null || _a === void 0 ? void 0 : _a[visitorCode]) === null || _b === void 0 ? void 0 : _b[featureKey];
        if (simulatedData) {
            KameleoonLogger.debug `RETURN: VariationConfiguration.getForcedFeatureVariation(visitorCode: ${visitorCode}, featureKey: ${featureKey}) -> (simulatedData: ${simulatedData})`;
            return buildExports.Ok(simulatedData);
        }
        const forcedData = (_d = (_c = result.data[0]) === null || _c === void 0 ? void 0 : _c[visitorCode]) === null || _d === void 0 ? void 0 : _d[featureKey];
        KameleoonLogger.debug `RETURN: VariationConfiguration.getForcedFeatureVariation(visitorCode: ${visitorCode}, featureKey: ${featureKey}) -> (forcedData: ${forcedData})`;
        return buildExports.Ok(forcedData);
    }
    getForcedExperimentVariation(visitorCode, experimentId) {
        var _a;
        KameleoonLogger.debug `CALL: VariationConfiguration.getForcedExperimentVariation(visitorCode: ${visitorCode}, experimentId: ${experimentId})`;
        const forcedResult = this.storageForcedExperimentVariations.read();
        if (!forcedResult.ok) {
            KameleoonLogger.debug `RETURN: VariationConfiguration.getForcedExperimentVariation(visitorCode: ${visitorCode}, experimentId: ${experimentId}) -> (forcedResult: ${forcedResult})`;
            return forcedResult;
        }
        const forcedData = (_a = forcedResult.data[visitorCode]) === null || _a === void 0 ? void 0 : _a[experimentId];
        KameleoonLogger.debug `RETURN: VariationConfiguration.getForcedExperimentVariation(visitorCode: ${visitorCode}, experimentId: ${experimentId}) -> (forcedExperiment: ${forcedData})`;
        return buildExports.Ok(forcedData);
    }
    parseForcedVariationData(simulatedVariation, simulated) {
        const featureFlag = this.clientConfiguration.featureFlags.get(simulatedVariation.featureKey);
        if (!featureFlag) {
            KameleoonLogger.error `Simulated feature flag '${simulatedVariation.featureKey}' not found`;
            return null;
        }
        let forcedVariation = null;
        if (simulatedVariation.experimentId === 0) {
            forcedVariation = {
                featureKey: simulatedVariation.featureKey,
                rule: null,
                varByExp: null,
                simulated: simulated,
            };
            return forcedVariation;
        }
        for (const rule of featureFlag.rules) {
            if (simulatedVariation.experimentId !== rule.experimentId) {
                continue;
            }
            const varByExp = rule.variationByExposition.find((varByExp) => varByExp.variationId === simulatedVariation.variationId);
            if (varByExp) {
                forcedVariation = {
                    featureKey: simulatedVariation.featureKey,
                    rule: {
                        type: rule.type,
                        experimentId: rule.experimentId,
                    },
                    varByExp: {
                        variationKey: varByExp.variationKey,
                        variationId: varByExp.variationId,
                    },
                    simulated: simulated,
                };
                return forcedVariation;
            }
        }
        KameleoonLogger.error `Simulated variation ${simulatedVariation.variationId} not found`;
        return null;
    }
    simulatedVariationFromJson(featureKey, data) {
        KameleoonLogger.debug `CALL: VariationConfiguration.simulatedVariationFromJson(featureKey: ${featureKey}, data: ${data})`;
        if (!this.isSimulatedVariationJson(data)) {
            return null;
        }
        const forcedVariation = this.parseForcedVariationData({
            featureKey,
            variationId: data.varId,
            experimentId: data.expId,
        }, true);
        KameleoonLogger.debug `RETURN: VariationConfiguration.simulatedVariationFromJson(featureKey: ${featureKey}, data: ${data}) -> (forcedVariation: ${forcedVariation})`;
        return forcedVariation;
    }
    isSimulatedVariationJson(value) {
        return value && (typeof value.expId === 'number' || value.expId === null);
    }
    evaluateCBScores(rule, visitorIdentifier, targetingData) {
        if (!(targetingData === null || targetingData === void 0 ? void 0 : targetingData.cbScores)) {
            return null;
        }
        KameleoonLogger.debug `CALL: KameleoonClientImpl.evaluateCBScores(rule: ${rule}, targetingData: ${targetingData}, visitorIdentifier: ${visitorIdentifier})`;
        const experimentId = rule.experimentId;
        const varIdGroupByScores = new CBScores(targetingData.cbScores.cbs)
            .getValues()
            .get(experimentId);
        let variation = null;
        if (varIdGroupByScores !== undefined) {
            const varByExps = rule.variationByExposition;
            const varByExpExistInCBS = varIdGroupByScores
                .map((varGroup) => varByExps.filter((varByExp) => varGroup.ids.includes(varByExp.variationId)))
                .find((varByExpExistInCBS) => varByExpExistInCBS.length > 0);
            if (varByExpExistInCBS) {
                let idx = 0;
                if (varByExpExistInCBS.length > 1) {
                    const variationHash = Hasher.getHashDouble({
                        visitorIdentifier,
                        respoolTime: rule.respoolTime,
                        id: String(experimentId),
                    });
                    KameleoonLogger.debug `Calculated cbs hash ${variationHash} for code ${visitorIdentifier}`;
                    idx = Math.min(Math.floor(variationHash * varByExpExistInCBS.length), varByExpExistInCBS.length - 1);
                }
                variation = varByExpExistInCBS[idx];
            }
        }
        KameleoonLogger.debug `RETURN: KameleoonClientImpl.evaluateCBScores(rule: ${rule}, targetingData: ${targetingData}, visitorIdentifier: ${visitorIdentifier}) -> (variation: ${variation})`;
        return variation;
    }
}

const REAL_TIME_EVENT = 'configuration-update-event';

// --- Note ---
// Named `KameleoonEventSource` to avoid collision with native `EventSource`
class KameleoonEventSource {
    constructor({ siteCode, externalEventSource, urlProvider, }) {
        this.url = urlProvider.getEventSourceUrl();
        this.siteCode = siteCode;
        this.eventSource = externalEventSource;
        this.isConnectionOpen = false;
    }
    get isOpen() {
        return this.isConnectionOpen;
    }
    open(onEvent) {
        this.eventSource.open({
            onEvent: this.handleMessage(onEvent),
            url: this.url,
            eventType: REAL_TIME_EVENT,
        });
        this.isConnectionOpen = true;
        KameleoonLogger.info `Established a new SSE connection with: ${this.url}`;
    }
    close() {
        this.eventSource.close();
        this.isConnectionOpen = false;
        KameleoonLogger.info `SSE connection: '${this.url}' was successfully closed`;
    }
    onError(callback) {
        if (!this.eventSource.onError) {
            KameleoonLogger.warning("EventSource does not have `onError` method provided. Real-time errors won't be handled.");
            return;
        }
        this.eventSource.onError(callback);
    }
    handleMessage(onEvent) {
        const onMessage = (message) => {
            KameleoonLogger.debug `Received new message from: ${this.url}`;
            const event = JSON.parse(message.data);
            const { siteCode: eventSiteCode, ts } = event;
            if (this.siteCode === eventSiteCode) {
                onEvent(ts);
            }
        };
        return onMessage;
    }
}

const MAX_BODY_SIZE = 10 * 1000000 /* Byte.Mb */;
const SYMBOL_SIZE = 4;

class BodyProvider {
    constructor(prng) {
        this.currentSize = 0;
        this.resultBody = [];
        this.hasUserAgent = false;
        this.trackingVisitors = {};
        this.prng = prng;
    }
    getTrackingBody() {
        const result = {
            body: this.resultBody.join('\n'),
            hasUserAgent: this.hasUserAgent,
        };
        this.cleanup();
        return result;
    }
    addData({ visitorCode, variationData, visitorData, userAgent, isConsentProvided, isMappingIdentifier, }) {
        const lines = [];
        const variationDataLines = this.getVariationDataLines(variationData);
        const visitorDataLines = this.getVisitorDataLines(visitorData);
        lines.push(...variationDataLines, ...visitorDataLines);
        return this.addVisitorTrackingLines({
            visitorCode,
            lines,
            userAgent,
            isConsentProvided,
            isMappingIdentifier,
        });
    }
    getVisitorDataLines(visitorData) {
        const lines = [];
        for (const data of visitorData) {
            let nonce;
            if (!(data instanceof StaticData) &&
                (data.data.type === KameleoonData.Conversion ||
                    data.data.type === KameleoonData.PageView)) {
                const nonceValue = data.data.nonce;
                if (nonceValue) {
                    nonce = nonceValue;
                }
                else {
                    nonce = Utilities.getNonce(this.prng);
                    data.data.nonce = nonce;
                }
            }
            if (!nonce) {
                nonce = Utilities.getNonce(this.prng);
            }
            lines.push(data.url + UrlParameter.Nonce + nonce);
        }
        return lines;
    }
    getVariationDataLines(variationData) {
        const lines = [];
        variationData.forEach((item) => {
            lines.push(UrlEventType.Experiment +
                UrlParameter.Id +
                item.experimentId +
                UrlParameter.VariationId +
                item.variationId +
                UrlParameter.Nonce +
                Utilities.getNonce(this.prng));
        });
        return lines;
    }
    prepareVisitorBody(visitorCode) {
        const visitorData = this.trackingVisitors[visitorCode];
        if (!visitorData) {
            return buildExports.Err();
        }
        const { lines, userAgent, isMappingIdentifier, isConsentProvided } = visitorData;
        const identifier = this.getIdentifier(visitorCode, isMappingIdentifier);
        if (lines.length) {
            lines.forEach((value, index) => {
                lines[index] = value + identifier;
            });
            KameleoonLogger.debug `Sending tracking request for unsent data ${lines} of visitor ${visitorCode} with given (or not required) consent ${isConsentProvided}`;
        }
        else if (isConsentProvided) {
            const activityLine = this.getActivityLine();
            lines.push(activityLine + identifier);
            KameleoonLogger.debug `Sending tracking request for activity of visitor ${visitorCode} with given consent`;
        }
        else {
            KameleoonLogger.debug `No data to send for visitor ${visitorCode} with no consent`;
        }
        if (userAgent && lines.length) {
            lines[0] += UrlParameter.UserAgent + userAgent;
            this.hasUserAgent = true;
        }
        // --- Note ---
        // Improve after `ts-res` chaining update
        const result = this.checkSize(lines);
        if (result.ok) {
            this.resultBody.push(...lines);
        }
        return result;
    }
    cleanup() {
        this.currentSize = 0;
        this.resultBody = [];
        this.hasUserAgent = false;
        this.trackingVisitors = {};
    }
    checkSize(lines) {
        let size = 0;
        size += lines.reduce((acc, line) => acc + line.length * SYMBOL_SIZE, 0);
        if (size + this.currentSize > MAX_BODY_SIZE) {
            return buildExports.Err();
        }
        this.currentSize += size;
        return buildExports.Ok();
    }
    addVisitorTrackingLines({ visitorCode, lines, userAgent, isConsentProvided, isMappingIdentifier, }) {
        if (!this.trackingVisitors[visitorCode]) {
            this.trackingVisitors[visitorCode] = {
                isMappingIdentifier,
                isConsentProvided,
                userAgent,
                lines,
            };
        }
        else {
            if (userAgent) {
                this.trackingVisitors[visitorCode].userAgent = userAgent;
            }
            this.trackingVisitors[visitorCode].lines.push(...lines);
        }
        return this.prepareVisitorBody(visitorCode);
    }
    getActivityLine() {
        return (UrlEventType.Activity + UrlParameter.Nonce + Utilities.getNonce(this.prng));
    }
    getIdentifier(visitorCode, isMappingIdentifier) {
        const identifier = isMappingIdentifier
            ? UrlParameter.MappingValue
            : UrlParameter.VisitorCode;
        return identifier + encodeURIComponent(visitorCode);
    }
}

class Tracker {
    constructor({ dataManager, trackingStorage, variationConfiguration, trackingInterval, requester, prng, clientConfiguration, }) {
        this.intervalId = null;
        KameleoonLogger.debug `CALL: new Tracker(dataManager, trackingStorage, variationConfiguration, trackingInterval: ${trackingInterval}, requester, prng, clientConfiguration)`;
        this.dataManager = dataManager;
        this.trackingStorage = trackingStorage;
        this.variationConfiguration = variationConfiguration;
        this.requester = requester;
        this.bodyProvider = new BodyProvider(prng);
        this.clientConfiguration = clientConfiguration;
        try {
            this.intervalId = setInterval(() => {
                this.sendDataAll();
            }, trackingInterval);
        }
        catch (err) {
            this.intervalId && clearInterval(this.intervalId);
            throw err;
        }
        KameleoonLogger.debug `RETURN: new Tracker(dataManager, trackingStorage, variationConfiguration, trackingInterval: ${trackingInterval}, requester, prng, clientConfiguration)`;
    }
    scheduleVisitor(visitorCode, isConsentProvided) {
        KameleoonLogger.debug `CALL: Tracker.scheduleVisitor(visitorCode: ${visitorCode}, isConsentProvided: ${isConsentProvided})`;
        this.trackingStorage.read().and((trackingData) => {
            trackingData.scheduledVisitors[`_${visitorCode}`] = { isConsentProvided };
            this.trackingStorage.write(trackingData);
        });
        KameleoonLogger.debug `RETURN: Tracker.scheduleVisitor(visitorCode: ${visitorCode}, isConsentProvided: ${isConsentProvided})`;
    }
    checkIsIdentifier(visitorCode) {
        var _a, _b;
        const isUniqueIdentifier = this.dataManager.isUniqueIdentifier(visitorCode);
        const mappingIdentifier = (_b = (_a = this.dataManager.getMappingIdentifier(visitorCode)) === null || _a === void 0 ? void 0 : _a.mappingIdentifier) !== null && _b !== void 0 ? _b : visitorCode;
        let isMappingIdentifier = false;
        // --- Note ---
        // This part is a workaround for Data API
        // If there's is no unique identifier for the visitor
        // We do reconciliation for visitor with himself
        if (isUniqueIdentifier) {
            const linkedVisitor = this.dataManager.getLinkedVisitor(visitorCode);
            const index = this.dataManager.identifierCustomDataIndex;
            if (!linkedVisitor && typeof index === 'number') {
                this.dataManager.storeData({
                    visitorCode,
                    data: [new CustomData$1(index, visitorCode)],
                });
            }
            else {
                isMappingIdentifier = true;
            }
        }
        return isMappingIdentifier && visitorCode != mappingIdentifier;
    }
    getUserAgent(visitorCode) {
        const targetingData = this.dataManager.getVisitorData(visitorCode);
        if (targetingData) {
            const userAgentData = targetingData[KameleoonData.UserAgent];
            if (userAgentData) {
                return userAgentData.value;
            }
        }
        return undefined;
    }
    sendDataAll() {
        return __awaiter(this, void 0, void 0, function* () {
            const storageResult = this.trackingStorage.read();
            if (!storageResult.ok) {
                return;
            }
            const { scheduledVisitors } = storageResult.data;
            yield this.sendData(scheduledVisitors);
        });
    }
    sendDataForVisitor(visitorCode, isConsentProvided) {
        return __awaiter(this, void 0, void 0, function* () {
            const storageResult = this.trackingStorage.read();
            if (!storageResult.ok) {
                return;
            }
            yield this.sendData({ [`_${visitorCode}`]: { isConsentProvided } });
        });
    }
    sendData(scheduledVisitors) {
        return __awaiter(this, void 0, void 0, function* () {
            const pendingData = {};
            const trackingVisitorCodes = [];
            const trackedVisitors = [];
            for (const [visitorCode, { isConsentProvided }] of Object.entries(scheduledVisitors)) {
                let targetVisitorCode = visitorCode.startsWith('_')
                    ? visitorCode.substring(1)
                    : visitorCode;
                const isMappingIdentifier = this.checkIsIdentifier(targetVisitorCode);
                const userAgent = this.getUserAgent(targetVisitorCode);
                const visitorData = this.getUnsentVisitorData(targetVisitorCode, isConsentProvided);
                const variationData = this.getUnsentVariationData(targetVisitorCode, isConsentProvided);
                const result = this.bodyProvider.addData({
                    visitorCode: targetVisitorCode,
                    variationData,
                    visitorData,
                    userAgent,
                    isConsentProvided,
                    isMappingIdentifier,
                });
                if (result.ok) {
                    pendingData[targetVisitorCode] = {
                        visitorData,
                        variationData,
                    };
                    trackedVisitors.push({
                        visitorCode: targetVisitorCode,
                        isConsentProvided,
                    });
                    trackingVisitorCodes.push(visitorCode);
                }
                else {
                    KameleoonLogger.warning('Visitor data to be tracked exceeded the request size limit. Some visitor data is kept to be sent later.' +
                        ' If it is not caused by the peak load, decreasing the tracking interval is recommended.');
                    break;
                }
            }
            const { body, hasUserAgent } = this.bodyProvider.getTrackingBody();
            if (trackingVisitorCodes.length !== 0) {
                this.trackingStorage.read().and((trackingData) => {
                    trackingVisitorCodes.forEach((visitorCode) => {
                        delete trackingData.scheduledVisitors[visitorCode];
                    });
                    this.trackingStorage.write(trackingData);
                });
            }
            if (!body) {
                return;
            }
            const result = yield this.requester.track(body, hasUserAgent);
            if (result.ok) {
                KameleoonLogger.info `Successful request for tracking visitors: ${trackedVisitors}, data: ${pendingData}`;
                this.updateDataStatus(pendingData, TrackingStatus.Sent);
            }
            else {
                KameleoonLogger.error('Tracking request failed');
                KameleoonLogger.info `Failed request for tracking visitors: ${trackedVisitors}, data: ${pendingData}`;
                this.updateDataStatus(pendingData, TrackingStatus.Unsent);
                let notTrackedVisitors = {};
                for (let { visitorCode, isConsentProvided } of trackedVisitors) {
                    visitorCode = `_${visitorCode}`;
                    notTrackedVisitors[visitorCode] = {
                        isConsentProvided: isConsentProvided,
                    };
                }
                this.addNotTrackedVisitors(notTrackedVisitors);
            }
        });
    }
    addNotTrackedVisitors(notTrackedVisitors) {
        const storageResult = this.trackingStorage.read();
        if (!storageResult.ok) {
            return;
        }
        const { scheduledVisitors } = storageResult.data;
        Object.entries(notTrackedVisitors).forEach(([visitorCode, { isConsentProvided }]) => {
            if (!scheduledVisitors[visitorCode]) {
                scheduledVisitors[visitorCode] = { isConsentProvided };
            }
        });
        this.trackingStorage.write({
            scheduledVisitors: scheduledVisitors,
        });
    }
    updateDataStatus(data, status) {
        let updatedData = {};
        for (const [visitorCode, { visitorData, variationData }] of Object.entries(data)) {
            const visitorDataForUpdate = visitorData
                .filter((dataItem) => !(dataItem instanceof StaticData))
                .map((dataItem) => {
                const item = dataItem;
                item.status = status;
                return item;
            });
            if (visitorDataForUpdate.length) {
                updatedData[visitorCode] = visitorDataForUpdate;
            }
            const experimentIdList = variationData.map((dataItem) => String(dataItem.experimentId));
            this.variationConfiguration.updateDataStatus({
                visitorCode,
                experimentIdList,
                status,
            });
        }
        if (Object.keys(updatedData).length === 0) {
            return;
        }
        if (status === TrackingStatus.Sent) {
            this.dataManager.storeTrackedData(updatedData);
        }
        else {
            this.dataManager.storeDataForVisitors(updatedData, false);
        }
    }
    getUnsentVisitorData(visitorCode, isConsentProvided) {
        const unsentData = this.dataManager.getUnsentData(visitorCode);
        const resultData = [];
        if (!unsentData.length) {
            return [];
        }
        for (const data of unsentData) {
            if (!data.url) {
                continue;
            }
            if (!isConsentProvided &&
                (!this.clientConfiguration.hasAnyTargetedDeliveryRule ||
                    data instanceof StaticData ||
                    data.data.type !== KameleoonData.Conversion)) {
                continue;
            }
            resultData.push(data);
        }
        if (resultData.length) {
            const pendingData = resultData
                .filter((data) => !(data instanceof StaticData))
                .map((data) => {
                const item = data;
                item.status = TrackingStatus.Pending;
                return item;
            });
            this.dataManager.storeTrackedData({
                [visitorCode]: pendingData,
            });
        }
        return resultData;
    }
    getUnsentVariationData(visitorCode, isConsentProvided) {
        const unsentData = this.variationConfiguration.getUnsentData(visitorCode);
        const sentExperimentIds = new Set();
        if (!unsentData.length) {
            return [];
        }
        const resultData = unsentData.filter((item) => {
            const isIncluded = item.isTargetedRule || isConsentProvided;
            if (isIncluded) {
                sentExperimentIds.add(String(item.experimentId));
            }
            return isIncluded;
        });
        this.variationConfiguration.updateDataStatus({
            visitorCode,
            experimentIdList: Array.from(sentExperimentIds),
            status: TrackingStatus.Pending,
        });
        return resultData;
    }
}

const ASSIGN_VARIATION_COMMAND = 'Experiments.assignVariation';
const TRIGGER_COMMAND = 'Experiments.trigger';
class HybridManager {
    constructor(expirationPeriod, clientConfiguration) {
        KameleoonLogger.debug `CALL: new HybridManager(expirationPeriod: ${expirationPeriod})`;
        if (expirationPeriod <= 0) {
            throw new Error("'expirationPeriod' must be positive!");
        }
        this.expirationPeriod = expirationPeriod;
        this.clientConfiguration = clientConfiguration;
        KameleoonLogger.debug `RETURN: new HybridManager(expirationPeriod: ${expirationPeriod})`;
    }
    getEngineTrackingCode(assignedVariations) {
        var _a;
        KameleoonLogger.debug `CALL: HybridManager.getEngineTrackingCode(assignedVariations: ${assignedVariations})`;
        let trackingCode = HybridManager.TRACKING_CODE_INIT;
        const expiredTime = Date.now() - this.expirationPeriod;
        const experimentMap = this.clientConfiguration.experimentMap;
        for (const [experimentId, variation] of Object.entries(assignedVariations)) {
            if (variation.assignedTime === undefined ||
                variation.assignedTime < expiredTime) {
                continue;
            }
            const experimentIdNumber = Number(experimentId);
            const trackingOnly = !((_a = experimentMap.get(experimentIdNumber)) === null || _a === void 0 ? void 0 : _a.hasJsCssVariables);
            trackingCode += `window.kameleoonQueue.push(['${HybridManager.ASSIGN_VARIATION_COMMAND}',${experimentIdNumber},${variation.variationId},true]);`;
            trackingCode += `window.kameleoonQueue.push(['${HybridManager.TRIGGER_COMMAND}',${experimentIdNumber},${trackingOnly}]);`;
        }
        KameleoonLogger.debug `RETURN: HybridManager.getEngineTrackingCode(assignedVariations: ${assignedVariations}) -> (trackingCode: ${trackingCode})`;
        return trackingCode;
    }
    getAssignedVariationsFromKameleoonQueue(queue) {
        KameleoonLogger.debug `CALL: HybridManager.getAssignedVariationsEngineTrackingCode(queue: ${queue})`;
        if (!Array.isArray(queue)) {
            return {};
        }
        const assignedVariations = {};
        for (const command of queue) {
            if (!this.isAssignVariationCommand(command)) {
                continue;
            }
            const [, experimentId, variationId] = command;
            assignedVariations[experimentId] = {
                variationId,
                isTargetedRule: false,
                status: TrackingStatus.Unsent,
                assignedTime: Date.now(),
            };
        }
        KameleoonLogger.debug `RETURN: HybridManager.getAssignedVariationsEngineTrackingCode(queue: ${queue}) -> (assignedVariations: ${assignedVariations})`;
        return assignedVariations;
    }
    isAssignVariationCommand(command) {
        if (!Array.isArray(command)) {
            return false;
        }
        const [commandName, experimentId, variationId] = command;
        return (commandName === HybridManager.ASSIGN_VARIATION_COMMAND &&
            typeof experimentId === 'number' &&
            typeof variationId === 'number');
    }
}
HybridManager.TRACKING_CODE_INIT = 'window.kameleoonQueue=window.kameleoonQueue||[];';
HybridManager.ASSIGN_VARIATION_COMMAND = ASSIGN_VARIATION_COMMAND;
HybridManager.TRIGGER_COMMAND = TRIGGER_COMMAND;

/**
 * @class
 * KameleoonClient - a class for creating kameleoon client instance
 * for communicating with Kameleoon JavaScript SDK Core, when new instance is created
 */
class KameleoonClient {
    /**
     * @param {SDKCoreParameters} sdkCoreParameters - parameters for initializing sdk core
     */
    constructor({ siteCode, dependencies, configuration, internalConfiguration, stubMode, }) {
        var _a;
        this.initialized = false;
        this.stubMode = stubMode;
        if (stubMode) {
            this.variationConfiguration = {};
            this.clientConfiguration = {};
            this.dataManager = {};
            this.consentDataStorage = {};
            this.hybridManager = {};
            this.requester = {};
            this.externalPackageInfo = {};
            this.visitorCodeManager = {};
            this.eventManager = {};
            this.tracker = {};
            this.environment = '';
            return;
        }
        const logger = internalConfiguration === null || internalConfiguration === void 0 ? void 0 : internalConfiguration.externals.externalLogger;
        if (logger) {
            KameleoonLogger.setLogger(logger);
        }
        ConditionFactoryInstance.setConditionFactoryInstance(new ConditionFactory());
        KameleoonLogger.debug `CALL: new KameleoonClient(siteCode: ${siteCode}, dependencies: ${dependencies}, configuration: ${configuration})`;
        const { settings: clientSettings } = new ClientSettings(siteCode, configuration);
        this.environment = clientSettings.environment;
        const { externalStorage, externalEventSource, externalPackageInfo, externalVisitorCodeManager, externalRequester, externalPRNG, customDataManager, } = internalConfiguration.externals;
        const { useAbortController } = internalConfiguration.settings;
        const clientDataStorage = new DataStorage(externalStorage, KameleoonStorageKey.ClientData);
        const variationDataStorage = new DataStorage(externalStorage, KameleoonStorageKey.VariationData);
        const forcedVariationDataStorage = new DataStorage(externalStorage, KameleoonStorageKey.ForcedExperimentVariation);
        const simulatedVariationDataStorage = new DataStorage(externalStorage, KameleoonStorageKey.ForcedFeatureVariation);
        const consentDataStorage = new DataStorage(externalStorage, KameleoonStorageKey.ConsentData);
        const trackingStorage = new DataStorage(externalStorage, KameleoonStorageKey.TrackingData);
        let dataManager = customDataManager;
        if (!dataManager) {
            const targetingDataStorage = new DataStorage(externalStorage, KameleoonStorageKey.TargetingData);
            const dataInfoStorage = new DataStorage(externalStorage, KameleoonStorageKey.DataInfo);
            dataManager = new DataManager({
                dataStorage: targetingDataStorage,
                infoStorage: dataInfoStorage,
                cleanupInterval: clientSettings.cleanupInterval,
                packageInfo: externalPackageInfo,
            });
        }
        const urlProvider = (_a = dependencies === null || dependencies === void 0 ? void 0 : dependencies.urlProvider) !== null && _a !== void 0 ? _a : new UrlProvider();
        urlProvider.initialize({
            domain: clientSettings.networkDomain,
            siteCode: clientSettings.siteCode,
            packageInfo: externalPackageInfo,
            environment: clientSettings.environment,
        });
        const requester = new Requester({
            urlProvider,
            useAbortController,
            packageInfo: externalPackageInfo,
            externalRequester: externalRequester,
            requestTimeout: clientSettings.requestTimeout,
            trackRetryDelay: clientSettings.trackRetryDelay,
        });
        const eventSource = new KameleoonEventSource({
            siteCode: clientSettings.siteCode,
            externalEventSource,
            urlProvider,
        });
        const eventManager = new EventManager();
        const clientConfiguration = new ClientConfiguration({
            urlProvider,
            storage: clientDataStorage,
            updateInterval: clientSettings.updateInterval,
            dataManager,
            eventManager,
            requester,
            eventSource,
            externalVisitorCodeManager,
            externalPackageInfo,
            defaultDataFile: configuration === null || configuration === void 0 ? void 0 : configuration.defaultDataFile,
        });
        const hybridManager = new HybridManager(HYBRID_TRACKING_CODE_EXPIRATION_PERIOD, clientConfiguration);
        const variationConfiguration = new VariationConfiguration(variationDataStorage, forcedVariationDataStorage, simulatedVariationDataStorage, externalVisitorCodeManager, clientConfiguration);
        const tracker = new Tracker({
            dataManager,
            trackingStorage,
            variationConfiguration,
            requester,
            trackingInterval: clientSettings.trackingInterval,
            prng: externalPRNG,
            clientConfiguration,
        });
        this.tracker = tracker;
        this.variationConfiguration = variationConfiguration;
        this.requester = requester;
        this.hybridManager = hybridManager;
        this.dataManager = dataManager;
        this.clientConfiguration = clientConfiguration;
        this.externalPackageInfo = externalPackageInfo;
        this.consentDataStorage = consentDataStorage;
        this.visitorCodeManager = externalVisitorCodeManager;
        this.eventManager = eventManager;
        if (clientSettings.cleanupInterval !== null) {
            new StorageCleanupManager(externalStorage, clientSettings.cleanupInterval);
        }
        KameleoonLogger.debug `RETURN: new KameleoonClient(siteCode: ${siteCode}, dependencies: ${dependencies}, configuration: ${configuration})`;
    }
    initialize() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.stubMode) {
                return false;
            }
            KameleoonLogger.info('CALL: KameleoonClient.initialize()');
            const result = yield this.clientConfiguration.initialize();
            result.throw();
            this.initialized = true;
            KameleoonLogger.info `RETURN: KameleoonClient.initialize() -> (result: ${result.ok})`;
            return result.ok;
        });
    }
    addData(visitorCodeOrParams, ...dataRest) {
        if (this.stubMode) {
            throw new KameleoonError(KameleoonException.Initialization);
        }
        const params = typeof visitorCodeOrParams === 'string'
            ? { visitorCode: visitorCodeOrParams, data: dataRest }
            : visitorCodeOrParams;
        const { visitorCode, data, track = true } = params;
        KameleoonLogger.info `CALL: KameleoonClient.addData(visitorCode: ${visitorCode}, track: ${track}, data: ${data})`;
        this.visitorCodeManager.validateVisitorCode(visitorCode).throw();
        if (!this.initialized) {
            throw new KameleoonError(KameleoonException.Initialization);
        }
        // assuming DataManager.storeData supports `track` (boolean) as discussed
        this.dataManager.storeData({ visitorCode, track, data }).throw();
        KameleoonLogger.info `RETURN: KameleoonClient.addData(visitorCode: ${visitorCode}, track: ${track}, data: ${data})`;
    }
    getRemoteVisitorData({ visitorCode, shouldAddData = true, filters = DEFAULT_VISITOR_DATA_FILTERS, }) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.stubMode) {
                throw new KameleoonError(KameleoonException.Initialization);
            }
            KameleoonLogger.info `CALL: KameleoonClient.getRemoteVisitorData(visitorCode: ${visitorCode}, shouldAddData: ${shouldAddData}, filters: ${filters})`;
            if (!this.initialized) {
                throw new KameleoonError(KameleoonException.Initialization);
            }
            this.visitorCodeManager.validateVisitorCode(visitorCode).throw();
            const { previousVisitAmount } = filters;
            if (typeof previousVisitAmount === 'number' &&
                (previousVisitAmount < 1 || previousVisitAmount > 25)) {
                throw new KameleoonError(KameleoonException.VisitAmount);
            }
            const isUniqueIdentifier = this.dataManager.isUniqueIdentifier(visitorCode);
            const result = yield this.requester.getVisitorData({
                visitorCode,
                filters,
                isMappingIdentifier: isUniqueIdentifier,
            });
            const data = result.throw();
            const { visitorData, storageVisitorData, visitsData, mappingIdentifier } = Parser.parseVisitorData({
                data,
                filters,
                visitorCode,
                dataManager: this.dataManager,
                variationConfiguration: this.variationConfiguration,
            });
            for (const dataItem of storageVisitorData) {
                if (shouldAddData || this.dataManager.isPersistentCustomData(dataItem)) {
                    this.addData(visitorCode, dataItem);
                }
            }
            // --- Note ---
            // Data on visits amount and time stamps is not returned to a user
            if (visitsData && shouldAddData) {
                this.addData(visitorCode, visitsData);
            }
            if ((filters === null || filters === void 0 ? void 0 : filters.visitorCode) && mappingIdentifier) {
                this.dataManager.setMappingIdentifier(visitorCode, mappingIdentifier);
            }
            KameleoonLogger.info `RETURN: KameleoonClient.getRemoteVisitorData(visitorCode: ${visitorCode}, shouldAddData: ${shouldAddData}, filters: ${filters}) -> (visitorData: ${visitorData})`;
            return visitorData;
        });
    }
    trackConversion({ visitorCode, goalId, negative, revenue, metadata, }) {
        if (this.stubMode) {
            return;
        }
        KameleoonLogger.info `CALL: KameleoonClient.trackConversion(visitorCode: ${visitorCode}, goalId: ${goalId}, negative: ${negative}, revenue: ${revenue}, metadata: ${metadata})`;
        this.addData(visitorCode, new Conversion$1({ goalId, revenue, negative, metadata }));
        this.flush(visitorCode);
        KameleoonLogger.info `RETURN: KameleoonClient.trackConversion(visitorCode: ${visitorCode}, goalId: ${goalId}, negative: ${negative}, revenue: ${revenue}, metadata: ${metadata})`;
    }
    _flushInternal(visitorCode, isInstant = false) {
        return __awaiter(this, void 0, void 0, function* () {
            if (typeof visitorCode === 'string') {
                if (isInstant) {
                    yield this.tracker.sendDataForVisitor(visitorCode, this._isConsentProvided(visitorCode));
                }
                else {
                    this.tracker.scheduleVisitor(visitorCode, this._isConsentProvided(visitorCode));
                }
            }
            else {
                for (const visitorCodeKey of this.dataManager.unsentDataVisitors) {
                    this.tracker.scheduleVisitor(visitorCodeKey, this._isConsentProvided(visitorCodeKey));
                }
                for (const visitorCodeKey of this.variationConfiguration.getVisitorsWithUnsentData()) {
                    this.tracker.scheduleVisitor(visitorCodeKey, this._isConsentProvided(visitorCodeKey));
                }
                if (isInstant) {
                    yield this.tracker.sendDataAll();
                }
            }
        });
    }
    flushInstant(visitorCode) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.stubMode) {
                throw new KameleoonError(KameleoonException.Initialization);
            }
            const { visitorCode: validatedVisitorCode } = this._parseFlushParams(visitorCode);
            KameleoonLogger.info `CALL: KameleoonClient.flushInstant(visitorCode: ${visitorCode})`;
            if (!this.initialized) {
                throw new KameleoonError(KameleoonException.Initialization);
            }
            yield this._flushInternal(validatedVisitorCode, true);
            KameleoonLogger.info `RETURN: KameleoonClient.flushInstant(visitorCode: ${visitorCode})`;
        });
    }
    flush(params) {
        if (this.stubMode) {
            throw new KameleoonError(KameleoonException.Initialization);
        }
        const { visitorCode, isInstant } = this._parseFlushParams(params);
        KameleoonLogger.info `CALL: KameleoonClient.flush(visitorCode: ${visitorCode}, instant: ${isInstant})`;
        if (!this.initialized) {
            throw new KameleoonError(KameleoonException.Initialization);
        }
        this._flushInternal(visitorCode, isInstant);
        KameleoonLogger.info `RETURN: KameleoonClient.flush(visitorCode: ${visitorCode}, instant: ${isInstant})`;
    }
    _parseFlushParams(params) {
        var _a;
        let visitorCode;
        let isInstant = false;
        if (typeof params === 'string') {
            visitorCode = params;
        }
        else if (params) {
            visitorCode = params.visitorCode;
            isInstant = (_a = params.instant) !== null && _a !== void 0 ? _a : false;
        }
        if (visitorCode !== undefined) {
            this.visitorCodeManager.validateVisitorCode(visitorCode).throw();
        }
        return { visitorCode, isInstant };
    }
    getFeatureFlags() {
        if (this.stubMode) {
            throw new KameleoonError(KameleoonException.Initialization);
        }
        KameleoonLogger.info('CALL: KameleoonClient.getFeatureFlags()');
        if (!this.initialized) {
            throw new KameleoonError(KameleoonException.Initialization);
        }
        const featureFlags = this.clientConfiguration.featureFlags;
        const resultFeatureFlags = [];
        featureFlags.forEach(({ id, featureKey }) => {
            resultFeatureFlags.push({
                id,
                key: featureKey,
            });
        });
        KameleoonLogger.info `RETURN: KameleoonClient.getFeatureFlags() -> (FeatureFlags: ${resultFeatureFlags})`;
        return resultFeatureFlags;
    }
    getVisitorFeatureFlags(visitorCode) {
        if (this.stubMode) {
            throw new KameleoonError(KameleoonException.Initialization);
        }
        KameleoonLogger.info `CALL: KameleoonClient.getVisitorFeatureFlags(visitorCode: ${visitorCode})`;
        if (!this.initialized) {
            throw new KameleoonError(KameleoonException.Initialization);
        }
        this.visitorCodeManager.validateVisitorCode(visitorCode).throw();
        const activeVariations = this._getActiveFeatureVariations(visitorCode);
        const resultFeatureFlags = [];
        activeVariations.forEach(({ featureFlagId, featureKey }) => {
            resultFeatureFlags.push({
                id: featureFlagId,
                key: featureKey,
            });
        });
        KameleoonLogger.info `RETURN: KameleoonClient.getVisitorFeatureFlags(visitorCode: ${visitorCode}) -> (FeatureFlags: ${resultFeatureFlags})`;
        return resultFeatureFlags;
    }
    getVariation({ visitorCode, featureKey, track = true, }) {
        if (this.stubMode) {
            throw new KameleoonError(KameleoonException.Initialization);
        }
        KameleoonLogger.info `CALL: KameleoonClient.getVariation(visitorCode: ${visitorCode}, featureKey: ${featureKey}, track: ${track})`;
        this.visitorCodeManager.validateVisitorCode(visitorCode).throw();
        const variation = this._getFeatureVariation({
            visitorCode,
            featureKey,
            track,
        }).throw();
        KameleoonLogger.info `RETURN: KameleoonClient.getVariation(visitorCode: ${visitorCode}, featureKey: ${featureKey}, track: ${track}) -> (variation: ${variation})`;
        return variation;
    }
    getVariations({ visitorCode, onlyActive = false, track = true, }) {
        if (this.stubMode) {
            throw new KameleoonError(KameleoonException.Initialization);
        }
        KameleoonLogger.info `CALL: KameleoonClient.getVariations(visitorCode: ${visitorCode}, onlyActive: ${onlyActive}, track: ${track})`;
        this.visitorCodeManager.validateVisitorCode(visitorCode).throw();
        const variations = new Map();
        const featureFlags = this.clientConfiguration.featureFlags;
        for (const featureFlag of featureFlags.values()) {
            try {
                const variation = this._getFeatureVariation({
                    visitorCode,
                    featureKey: featureFlag.featureKey,
                    track,
                });
                if (variation.ok &&
                    (!onlyActive || variation.data.key !== OFF_VARIATION_KEY)) {
                    variations.set(featureFlag.featureKey, variation.data);
                }
            }
            catch (err) {
                if (err instanceof KameleoonError &&
                    err.type !== KameleoonException.FeatureFlagEnvironmentDisabled) {
                    throw err;
                }
            }
        }
        KameleoonLogger.info `RETURN: KameleoonClient.getVariations(visitorCode: ${visitorCode}, onlyActive: ${onlyActive}, track: ${track}) -> (variations: ${variations})`;
        return variations;
    }
    getActiveFeatureFlags(visitorCode) {
        if (this.stubMode) {
            throw new KameleoonError(KameleoonException.Initialization);
        }
        KameleoonLogger.info `CALL: KameleoonClient.getActiveFeatureFlags(visitorCode: ${visitorCode})`;
        if (!this.initialized) {
            throw new KameleoonError(KameleoonException.Initialization);
        }
        this.visitorCodeManager.validateVisitorCode(visitorCode).throw();
        const activeVariations = this._getActiveFeatureVariations(visitorCode);
        const resultFeatureList = new Map();
        activeVariations.forEach((variation) => {
            const { variationKey, featureKey, variationId, experimentId } = variation;
            let variables = [];
            if (variationId !== null && experimentId !== null) {
                variables = this._getFeatureVariables({
                    visitorCode,
                    featureKey,
                    variationKey,
                });
            }
            const resultVariables = variables.map((variable) => Parser.parseFeatureVariable(variable).throw());
            resultFeatureList.set(variation.featureKey, {
                name: '',
                key: variationKey,
                id: variationId,
                experimentId,
                variables: resultVariables,
            });
        });
        KameleoonLogger.info `RETURN: KameleoonClient.getActiveFeatureFlags(visitorCode: ${visitorCode}) -> (FeatureFlags: ${resultFeatureList})`;
        return resultFeatureList;
    }
    getFeatureFlagVariationKey(visitorCode, featureKey) {
        if (this.stubMode) {
            throw new KameleoonError(KameleoonException.Initialization);
        }
        KameleoonLogger.info `CALL: KameleoonClient.getFeatureFlagVariationKey(visitorCode: ${visitorCode}, featureKey: ${featureKey})`;
        this.visitorCodeManager.validateVisitorCode(visitorCode).throw();
        const { key } = this._getFeatureVariation({
            visitorCode,
            featureKey,
            track: true,
        }).throw();
        KameleoonLogger.info `RETURN: KameleoonClient.getFeatureFlagVariationKey(visitorCode: ${visitorCode}, featureKey: ${featureKey}) -> (variationKey: ${key})`;
        return key;
    }
    getFeatureFlagVariable({ visitorCode, featureKey, variableKey, }) {
        if (this.stubMode) {
            throw new KameleoonError(KameleoonException.Initialization);
        }
        KameleoonLogger.info `CALL: KameleoonClient.getFeatureFlagVariable(visitorCode: ${visitorCode}, featureKey: ${featureKey}, variableKey: ${variableKey})`;
        this.visitorCodeManager.validateVisitorCode(visitorCode).throw();
        const { key: variationKey } = this._getFeatureVariation({
            visitorCode,
            featureKey,
            track: true,
        }).throw();
        const variables = this._getFeatureVariables({
            visitorCode,
            featureKey,
            variationKey,
        });
        const variable = variables.find((item) => item.key === variableKey);
        if (!variable) {
            throw new KameleoonError(KameleoonException.FeatureFlagVariableNotFound, variableKey, visitorCode);
        }
        const { type, value } = Parser.parseFeatureVariable(variable).throw();
        const featureFlagVariable = { type, value };
        KameleoonLogger.info `RETURN: KameleoonClient.getFeatureFlagVariable(visitorCode: ${visitorCode}, featureKey: ${featureKey}, variableKey: ${variableKey}) -> (FeatureFlagVariable: ${featureFlagVariable})`;
        return featureFlagVariable;
    }
    getFeatureFlagVariables(visitorCode, featureKey) {
        if (this.stubMode) {
            throw new KameleoonError(KameleoonException.Initialization);
        }
        KameleoonLogger.info `CALL: KameleoonClient.getFeatureFlagVariables(visitorCode: ${visitorCode}, featureKey: ${featureKey})`;
        this.visitorCodeManager.validateVisitorCode(visitorCode).throw();
        const { key: variationKey } = this._getFeatureVariation({
            visitorCode,
            featureKey,
            track: true,
        }).throw();
        const variables = this._getFeatureVariables({
            visitorCode,
            featureKey,
            variationKey,
        });
        const resultVariables = [];
        for (const variable of variables) {
            const parsedVariable = Parser.parseFeatureVariable(variable).throw();
            resultVariables.push(parsedVariable);
        }
        KameleoonLogger.info `RETURN: KameleoonClient.getFeatureFlagVariables(visitorCode: ${visitorCode}, featureKey: ${featureKey}) -> (FeatureFlagVariables: ${resultVariables})`;
        return resultVariables;
    }
    isFeatureFlagActive(firstParam, secondParam) {
        if (this.stubMode) {
            throw new KameleoonError(KameleoonException.Initialization);
        }
        let [visitorCode, featureKey, track] = ['', '', true];
        if (typeof firstParam === 'string') {
            visitorCode = firstParam;
            featureKey = secondParam;
        }
        else {
            [visitorCode, featureKey] = [
                firstParam.visitorCode,
                firstParam.featureKey,
            ];
            if (firstParam.track !== undefined) {
                track = firstParam.track;
            }
        }
        KameleoonLogger.info `CALL: KameleoonClient.isFeatureFlagActive(visitorCode: ${visitorCode}, featureKey: ${featureKey}, track ${track})`;
        this.visitorCodeManager.validateVisitorCode(visitorCode).throw();
        try {
            const { key } = this._getFeatureVariation({
                visitorCode,
                featureKey,
                track,
            }).throw();
            const isActive = key !== OFF_VARIATION_KEY;
            KameleoonLogger.info `RETURN: KameleoonClient.isFeatureFlagActive(visitorCode: ${visitorCode}, featureKey: ${featureKey}, track: ${track}) -> (isActive: ${isActive})`;
            return isActive;
        }
        catch (err) {
            if (err instanceof KameleoonError &&
                err.type === KameleoonException.FeatureFlagEnvironmentDisabled) {
                KameleoonLogger.info `RETURN: KameleoonClient.isFeatureFlagActive(visitorCode: ${visitorCode}, featureKey: ${featureKey}, track: ${track}) -> (isActive: false)`;
                return false;
            }
            throw err;
        }
    }
    getRemoteData(key) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.stubMode) {
                return null;
            }
            KameleoonLogger.info `CALL: KameleoonClient.getRemoteData(key: ${key})`;
            const remoteData = yield this.requester.getRemoteData(key);
            KameleoonLogger.info `RETURN: KameleoonClient.getRemoteData(key: ${key}) -> (remoteData: ${remoteData})`;
            return remoteData.throw();
        });
    }
    getVisitorWarehouseAudience({ visitorCode, customDataIndex, warehouseKey, }) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.stubMode) {
                return null;
            }
            KameleoonLogger.info `CALL: KameleoonClient.getVisitorWarehouseAudience(visitorCode: ${visitorCode}, customDataIndex: ${customDataIndex}, warehouseKey: ${warehouseKey})`;
            this.visitorCodeManager.validateVisitorCode(visitorCode).throw();
            const data = yield this.getRemoteData(warehouseKey || visitorCode);
            if (!data) {
                throw new KameleoonError(KameleoonException.RemoteData, `No data found for ${warehouseKey || visitorCode} key`);
            }
            if (!data[WAREHOUSE_AUDIENCE_KEY] ||
                Object.keys(data[WAREHOUSE_AUDIENCE_KEY]).length === 0) {
                KameleoonLogger.info `RETURN: KameleoonClient.getVisitorWarehouseAudience(visitorCode: ${visitorCode}, customDataIndex: ${customDataIndex}, warehouseKey: ${warehouseKey}) -> (customData: null)`;
                return null;
            }
            const customData = new CustomData$1(customDataIndex, ...Object.keys(data[WAREHOUSE_AUDIENCE_KEY]));
            this.dataManager.storeData({
                visitorCode,
                track: true,
                data: [customData],
            });
            KameleoonLogger.info `RETURN: KameleoonClient.getVisitorWarehouseAudience(visitorCode: ${visitorCode}, customDataIndex: ${customDataIndex}, warehouseKey: ${warehouseKey}) -> (customData: ${customData})`;
            return customData;
        });
    }
    onEvent(event, callback) {
        if (this.stubMode) {
            throw new KameleoonError(KameleoonException.Initialization);
        }
        KameleoonLogger.info `CALL: KameleoonClient.onEvent(event: ${event}, callback)`;
        if (!this.initialized) {
            throw new KameleoonError(KameleoonException.Initialization);
        }
        this.eventManager.addEventHandler(event, callback);
        KameleoonLogger.info `RETURN: KameleoonClient.onEvent(event: ${event}, callback)`;
    }
    getEngineTrackingCode(visitorCode) {
        if (this.stubMode) {
            return '';
        }
        KameleoonLogger.info `CALL: KameleoonClient.getEngineTrackingCode(visitorCode: ${visitorCode})`;
        this.visitorCodeManager.validateVisitorCode(visitorCode).throw();
        const assignedVariationsResult = this.variationConfiguration.getStoredVariations(visitorCode);
        const trackingCode = this.hybridManager.getEngineTrackingCode(assignedVariationsResult.ok ? assignedVariationsResult.data : {});
        KameleoonLogger.info `RETURN: KameleoonClient.getEngineTrackingCode(visitorCode: ${visitorCode}) -> (trackingCode: ${trackingCode})`;
        return trackingCode;
    }
    _processKameleoonQueue(visitorCode, queue) {
        if (this.stubMode) {
            return;
        }
        KameleoonLogger.debug `CALL: KameleoonClient._processHybridQueue(visitorCode: ${visitorCode}, queue: ${queue})`;
        const assignedVariations = this.hybridManager.getAssignedVariationsFromKameleoonQueue(queue);
        const assignedVariationCount = Object.keys(assignedVariations).length;
        if (!assignedVariationCount) {
            return;
        }
        const updateResult = this.variationConfiguration.updateStoredVariations(visitorCode, assignedVariations);
        if (!updateResult.ok) {
            return;
        }
        this.flush(visitorCode);
        KameleoonLogger.debug `RETURN: KameleoonClient._processHybridQueue(visitorCode: ${visitorCode}, queue: ${queue})`;
    }
    isInitialized() {
        KameleoonLogger.debug `CALL/RETURN: KameleoonClient.isInitialized() -> (initialized: ${this.initialized})`;
        return this.initialized;
    }
    setLogLevel(level) {
        KameleoonLogger.setLogLevel(level);
    }
    setForcedVariation({ visitorCode, experimentId, variationKey, forceTargeting = true, }) {
        if (this.stubMode) {
            return;
        }
        KameleoonLogger.info `CALL: KameleoonClient.setForcedVariation(visitorCode: '${visitorCode}', experimentId: ${experimentId}, variationKey: '${variationKey}', forceTargeting: ${forceTargeting})`;
        this.visitorCodeManager.validateVisitorCode(visitorCode).throw();
        this._setForcedVariation({
            visitorCode,
            experimentId,
            variationKey,
            forceTargeting,
        }).throw();
        KameleoonLogger.info `RETURN: KameleoonClient.setForcedVariation(visitorCode: '${visitorCode}', experimentId: ${experimentId}, variationKey: '${variationKey}', forceTargeting: ${forceTargeting})`;
    }
    evaluateAudiences(visitorCode) {
        if (this.stubMode) {
            return;
        }
        KameleoonLogger.info `CALL: KameleoonClient.evaluateAudiences(visitorCode: ${visitorCode})`;
        this.visitorCodeManager.validateVisitorCode(visitorCode).throw();
        const targetedSegments = [];
        const targetingData = this.dataManager.getVisitorData(visitorCode);
        for (let segment of this.clientConfiguration.segments.values()) {
            if (!segment.audienceTracking) {
                continue;
            }
            const targetingResult = Utilities.checkTargeting({
                segment,
                visitorCode,
                targetingData,
                experimentId: null,
                clientConfiguration: this.clientConfiguration,
                packageInfo: this.externalPackageInfo,
                dataManager: this.dataManager,
                variationConfiguration: this.variationConfiguration,
            });
            const isTargeted = targetingResult.ok && targetingResult.data;
            if (isTargeted) {
                KameleoonLogger.info `Visitor ${visitorCode} has been targeted for ${segment}`;
                targetedSegments.push(new TargetedSegment(Number(segment.id)));
            }
        }
        if (targetedSegments.length !== 0) {
            this.dataManager.storeData({ visitorCode, data: targetedSegments });
        }
        this.flush(visitorCode);
        KameleoonLogger.info `RETURN: KameleoonClient.evaluateAudiences(visitorCode: ${visitorCode})`;
    }
    getDataFile() {
        const dataFile = {
            featureFlags: new Map(),
            dateModified: 0,
        };
        if (this.stubMode) {
            return dataFile;
        }
        KameleoonLogger.debug `CALL: KameleoonClient.getDataFile()`;
        const resultDataFile = this.clientConfiguration.dataFile;
        KameleoonLogger.debug `RETURN: KameleoonClient.getDataFile() -> (dataFile: ${resultDataFile})`;
        return resultDataFile;
    }
    setUserConsent({ visitorCode, consent, setData, }) {
        if (this.stubMode) {
            return;
        }
        KameleoonLogger.info `CALL: KameleoonClient.setUserConsent(visitorCode: ${visitorCode}, consent: ${consent}, setData: ${setData})`;
        this.visitorCodeManager.validateVisitorCode(visitorCode).throw();
        this.updateConsentData(visitorCode, consent);
        if (consent) {
            setData({
                visitorCode,
                key: KameleoonStorageKey.VisitorCode,
                maxAge: DEFAULT_MAX_AGE,
                path: PATH,
            });
        }
        KameleoonLogger.info `RETURN: KameleoonClient.setUserConsent(visitorCode: ${visitorCode}, consent: ${consent}, setData: ${setData})`;
    }
    updateConsentData(visitorCode, consent) {
        const readResult = this.consentDataStorage.read();
        const legalConsent = consent ? LegalConsent.Given : LegalConsent.NotGiven;
        if (!readResult.ok) {
            if (readResult.error.type === KameleoonException.StorageEmpty) {
                this.consentDataStorage.write({
                    [visitorCode]: {
                        consent: legalConsent,
                    },
                });
            }
            return;
        }
        const data = readResult.data;
        data[visitorCode] = {
            consent: legalConsent,
        };
        this.consentDataStorage.write(data);
    }
    getLegalConsent(visitorCode) {
        KameleoonLogger.debug `CALL: KameleoonClient.getLegalConsent(visitorCode: ${visitorCode})`;
        let legalConsent;
        const consentDataResult = this.consentDataStorage.read();
        legalConsent = consentDataResult.ok
            ? this.extractLegalConsent(consentDataResult.data[visitorCode])
            : LegalConsent.Unknown;
        KameleoonLogger.debug `RETURN: KameleoonClient.getLegalConsent(visitorCode: ${visitorCode}) -> (legalConsent: ${legalConsent})`;
        return legalConsent;
    }
    extractLegalConsent(consentData) {
        if (consentData === undefined)
            return LegalConsent.Unknown;
        if (typeof consentData === 'boolean') {
            return consentData ? LegalConsent.Given : LegalConsent.NotGiven;
        }
        const value = consentData.consent;
        if (typeof value === 'boolean')
            return value ? LegalConsent.Given : LegalConsent.NotGiven;
        return value;
    }
    _isConsentProvided(visitorCode) {
        KameleoonLogger.debug `CALL: KameleoonClient._isConsentProvided(visitorCode: ${visitorCode})`;
        const { isConsentRequired } = this.clientConfiguration;
        const isConsentProvided = !isConsentRequired ||
            this.getLegalConsent(visitorCode) == LegalConsent.Given;
        KameleoonLogger.debug `RETURN: KameleoonClient._isConsentProvided(visitorCode: ${visitorCode}) -> (isConsentProvided: ${isConsentProvided})`;
        return isConsentProvided;
    }
    _getFeatureVariables({ visitorCode, featureKey, variationKey, }) {
        KameleoonLogger.debug `CALL: KameleoonClient._getFeatureVariables(visitorCode: ${visitorCode}, featureKey: ${featureKey}, variationKey: ${variationKey})`;
        const featureFlags = this.clientConfiguration.featureFlags;
        const featureFlag = featureFlags.get(featureKey);
        if (!featureFlag) {
            throw new KameleoonError(KameleoonException.FeatureFlagConfigurationNotFound, featureKey);
        }
        const variation = featureFlag.variations.find((item) => item.key === variationKey);
        if (!variation) {
            throw new KameleoonError(KameleoonException.FeatureFlagVariationNotFound, variationKey, visitorCode);
        }
        KameleoonLogger.debug `RETURN: KameleoonClient._getFeatureVariables(visitorCode: ${visitorCode}, featureKey: ${featureKey}, variationKey: ${variationKey}) -> (variables: ${variation.variables})`;
        return variation.variables;
    }
    // @deprecated
    // To be removed with the deprecated methods
    _getActiveFeatureVariations(visitorCode) {
        KameleoonLogger.debug `CALL: KameleoonClient._getActiveFeatureVariations(visitorCode: ${visitorCode})`;
        const featureFlags = this.clientConfiguration.featureFlags;
        const activeVariations = [];
        for (const featureFlag of featureFlags.values()) {
            const forcedVariation = this._getForcedFeatureVariation(visitorCode, featureFlag.featureKey);
            if (!featureFlag.environmentEnabled && !(forcedVariation === null || forcedVariation === void 0 ? void 0 : forcedVariation.simulated)) {
                continue;
            }
            try {
                const evalExp = this._evaluate({
                    visitorCode,
                    featureFlag,
                    track: false,
                    save: false,
                    forcedVariation,
                });
                if (evalExp.variationKey !== OFF_VARIATION_KEY) {
                    activeVariations.push({
                        variationKey: evalExp.variationKey,
                        variationId: evalExp.variationId,
                        experimentId: evalExp.experimentId,
                        featureFlagId: featureFlag.id,
                        featureKey: featureFlag.featureKey,
                        rule: null,
                        isTargetedRule: evalExp.ruleType === "TARGETED_DELIVERY" /* RuleType.TARGETED_DELIVERY */,
                    });
                }
            }
            catch (err) {
                if (err instanceof KameleoonError) {
                    if (err.type != KameleoonException.FeatureFlagEnvironmentDisabled) {
                        KameleoonLogger.error `Unexpected error: ${err}`;
                    }
                    continue;
                }
            }
        }
        KameleoonLogger.debug `RETURN: KameleoonClient._getActiveFeatureVariations(visitorCode: ${visitorCode}) -> (activeVariations: ${activeVariations})`;
        return activeVariations;
    }
    _evaluate({ visitorCode, featureFlag, track, save, forcedVariation, }) {
        KameleoonLogger.debug `CALL: KameleoonClient._evaluate(visitorCode: ${visitorCode}, featureFlag: ${featureFlag}, track: ${track}, save: ${save})`;
        let evalExp;
        const visitorData = this.dataManager.getVisitorData(visitorCode);
        if (forcedVariation) {
            evalExp = KameleoonClient.EvaluatedExperiment.fromForcedFeatureVariation(featureFlag.defaultVariationKey, forcedVariation);
        }
        else if (this._isVisitorNotInHoldout(visitorCode, track, save, featureFlag, visitorData) &&
            this._isFFUnrestrictedByMEGroup(visitorCode, featureFlag, visitorData)) {
            const visitorIdentifier = this._getCodeForHash(visitorCode, featureFlag.bucketingCustomDataIndex, visitorData);
            const legalConsent = this.getLegalConsent(visitorCode);
            const variationData = this.variationConfiguration
                .getVariation({
                visitorCode,
                visitorIdentifier,
                featureFlag,
                track,
                withAssignment: save,
                targetingData: visitorData,
                clientConfiguration: this.clientConfiguration,
                dataManager: this.dataManager,
                packageInfo: this.externalPackageInfo,
                legalConsent,
            })
                .throw();
            evalExp =
                KameleoonClient.EvaluatedExperiment.fromVariationData(variationData);
        }
        else {
            evalExp = KameleoonClient.EvaluatedExperiment.fromDefaultVariationKey(featureFlag.defaultVariationKey);
        }
        if (save &&
            !evalExp.isSimulated &&
            evalExp.experimentId !== null &&
            evalExp.variationId !== null) {
            this.variationConfiguration.updateStoredVariations(visitorCode, {
                [evalExp.experimentId]: {
                    variationId: evalExp.variationId,
                    isTargetedRule: evalExp.ruleType === "TARGETED_DELIVERY" /* RuleType.TARGETED_DELIVERY */,
                    status: track ? TrackingStatus.Unsent : TrackingStatus.Sent,
                    assignedTime: Date.now(),
                },
            });
        }
        this.eventManager.fireEvent(EventType.Evaluation, {
            featureKey: featureFlag.featureKey,
            variation: {
                key: evalExp.variationKey,
                experimentId: evalExp.experimentId,
                id: evalExp.variationId,
            },
        });
        KameleoonLogger.debug `RETURN: KameleoonClient._evaluate(visitorCode: ${visitorCode}, featureFlag: ${featureFlag}, track: ${track}, save: ${save}) -> (evalExp: ${evalExp})`;
        return evalExp;
    }
    _isFFUnrestrictedByMEGroup(visitorCode, featureFlag, visitorData) {
        const meGroupName = featureFlag.mutuallyExclusiveGroup;
        if (!meGroupName) {
            return true;
        }
        KameleoonLogger.debug `CALL: KameleoonClient._isFFUnrestrictedByMEGroup(visitorCode: ${visitorCode}, featureFlag: ${featureFlag}, visitorData: ${visitorData})`;
        let selected = true;
        const meGroup = this.clientConfiguration.meGroups.get(meGroupName);
        if (meGroup) {
            const codeForHash = this._getCodeForHash(visitorCode, featureFlag.bucketingCustomDataIndex, visitorData);
            const hashMEGroup = Hasher.getHashDoubleForMEGroup(codeForHash, meGroupName);
            KameleoonLogger.debug `Calculated meGroup hash ${hashMEGroup} for code: ${codeForHash}, meGroup: ${meGroupName}`;
            selected = meGroup.getFeatureFlagByHash(hashMEGroup) === featureFlag;
        }
        KameleoonLogger.debug `RETURN: KameleoonClient._isFFUnrestrictedByMEGroup(visitorCode: ${visitorCode}, featureFlag: ${featureFlag}, visitorData: ${visitorData}) -> (selected: ${selected})`;
        return selected;
    }
    _getFeatureVariation({ visitorCode, featureKey, track, }) {
        var _a, _b;
        KameleoonLogger.debug `CALL: KameleoonClient._getFeatureVariation(visitorCode: ${visitorCode}, featureKey: ${featureKey}, track: ${track})`;
        if (!this.initialized) {
            return buildExports.Err(new KameleoonError(KameleoonException.Initialization));
        }
        const featureFlags = this.clientConfiguration.featureFlags;
        const featureFlag = featureFlags.get(featureKey);
        if (!featureFlag) {
            return buildExports.Err(new KameleoonError(KameleoonException.FeatureFlagConfigurationNotFound, featureKey));
        }
        const forcedVariation = this._getForcedFeatureVariation(visitorCode, featureKey);
        if (!featureFlag.environmentEnabled) {
            if (!(forcedVariation === null || forcedVariation === void 0 ? void 0 : forcedVariation.simulated)) {
                return buildExports.Err(new KameleoonError(KameleoonException.FeatureFlagEnvironmentDisabled, featureFlag.featureKey, this.environment));
            }
        }
        const evalExp = this._evaluate({
            visitorCode,
            featureFlag,
            track,
            save: true,
            forcedVariation,
        });
        const { experimentId, variationId, variationKey, isSimulated } = evalExp;
        let resultVariables = new Map();
        try {
            const variables = this._getFeatureVariables({
                visitorCode,
                featureKey,
                variationKey,
            });
            variables.forEach((variable) => {
                const parsedVariable = Parser.parseFeatureVariable(variable).throw();
                resultVariables.set(variable.key, parsedVariable);
            });
        }
        catch (_) { }
        if (track && !isSimulated) {
            this.flush(visitorCode);
        }
        const variationName = (_b = (_a = featureFlag.variations.find((item) => item.key === variationKey)) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : '';
        const resultData = {
            name: variationName,
            key: variationKey,
            id: variationId,
            experimentId,
            variables: resultVariables,
        };
        KameleoonLogger.debug `RETURN: KameleoonClient._getFeatureVariation(visitorCode: ${visitorCode}, featureKey: ${featureKey}, track: ${track}) -> (variation: ${resultData})`;
        return buildExports.Ok(resultData);
    }
    _isVisitorNotInHoldout(visitorCode, track, save, featureFlag, visitorData) {
        const holdout = this.clientConfiguration.holdout;
        if (!holdout) {
            return true;
        }
        KameleoonLogger.debug `CALL: KameleoonClient._isVisitorNotInHoldout(visitorCode: ${visitorCode}, track: ${track}, save: ${save}, featureFlag: ${featureFlag}, visitorData: ${visitorData})`;
        let isNotInHoldout = true;
        // Checking if the evaluation is blocked due to the consent policy
        const legalConsent = this.clientConfiguration.isConsentRequired
            ? this.getLegalConsent(visitorCode)
            : LegalConsent.Given;
        if (legalConsent == LegalConsent.NotGiven) {
            const behaviour = this.clientConfiguration.consentBlockingBehaviour;
            if (behaviour == "FULLY_BLOCK" /* ConsentBlockingBehaviour.CompletelyBlocked */) {
                throw new KameleoonError(KameleoonException.FeatureFlagEnvironmentDisabled, `Evaluation of holdout is blocked because consent is not provided for visitor '${visitorCode}'`);
            }
        }
        const codeForHash = this._getCodeForHash(visitorCode, featureFlag === null || featureFlag === void 0 ? void 0 : featureFlag.bucketingCustomDataIndex, visitorData);
        const holdoutHash = Hasher.getHashDouble({
            visitorIdentifier: codeForHash,
            respoolTime: null,
            id: String(holdout.experimentId),
        });
        KameleoonLogger.debug `Calculated holdoutHash: ${holdoutHash} for visitorCode: ${codeForHash}`;
        let varByExp = Utilities.getVariationByHash(holdout.variationByExposition, holdoutHash);
        if (varByExp !== null) {
            isNotInHoldout = varByExp.variationKey !== IN_HOLDOUT_VARIATION_KEY;
            if (save) {
                this.variationConfiguration.updateStoredVariations(visitorCode, {
                    [holdout.experimentId]: {
                        variationId: varByExp.variationId,
                        isTargetedRule: false,
                        status: track ? TrackingStatus.Unsent : TrackingStatus.Sent,
                        assignedTime: Date.now(),
                    },
                });
            }
        }
        KameleoonLogger.debug `RETURN: KameleoonClient._isVisitorNotInHoldout(visitorCode: ${visitorCode}, track: ${track}, save: ${save}, featureFlag: ${featureFlag}, visitorData: ${visitorData}) -> (isNotInHoldout: ${isNotInHoldout})`;
        return isNotInHoldout;
    }
    _setForcedVariation({ visitorCode, experimentId, variationKey, forceTargeting = true, }) {
        KameleoonLogger.debug `CALL: KameleoonClient._setForcedVariation(visitorCode: '${visitorCode}', experimentId: ${experimentId}, variationKey: '${variationKey}', forceTargeting: ${forceTargeting})`;
        if (variationKey === null) {
            const writeResult = this.variationConfiguration.updateForcedExperimentVariation(visitorCode, experimentId, null);
            KameleoonLogger.debug `RETURN: KameleoonClient._setForcedVariation(visitorCode: '${visitorCode}', experimentId: ${experimentId}, variationKey: '${variationKey}', forceTargeting: ${forceTargeting}) -> (writeResult: ${writeResult})`;
            return writeResult;
        }
        let rule = null;
        let varByExp = null;
        rule = this.clientConfiguration.experimentMap.get(experimentId);
        if (!rule) {
            KameleoonLogger.error `Experiment with id ${experimentId} not found for visitor ${visitorCode}`;
            return buildExports.Err(new KameleoonError(KameleoonException.FeatureFlagExperimentNotFound, experimentId, visitorCode));
        }
        varByExp = rule.variations.get(variationKey);
        if (varByExp === undefined) {
            KameleoonLogger.error `Variation with key ${variationKey} not found in experiment ${rule} for visitor ${visitorCode}`;
            return buildExports.Err(new KameleoonError(KameleoonException.FeatureFlagVariationNotFound, variationKey, visitorCode));
        }
        rule = {
            type: rule.type,
            experimentId: experimentId,
        };
        varByExp = {
            variationKey: variationKey,
            variationId: varByExp,
        };
        const writeResult = this.variationConfiguration.updateForcedExperimentVariation(visitorCode, experimentId, {
            rule: rule,
            varByExp: varByExp,
            forceTargeting,
        });
        KameleoonLogger.debug `RETURN: KameleoonClient._setForcedVariation(visitorCode: '${visitorCode}', experimentId: ${experimentId}, variationKey: '${variationKey}', forceTargeting: ${forceTargeting}) -> (writeResult: ${writeResult})`;
        return writeResult;
    }
    _getForcedFeatureVariation(visitorCode, featureKey) {
        const forcedVariationData = this.variationConfiguration.getForcedFeatureVariation(visitorCode, featureKey);
        if (!forcedVariationData.ok) {
            return null;
        }
        return forcedVariationData.data;
    }
    _getCodeForHash(visitorCode, bucketingCustomDataIndex, visitorData) {
        var _a;
        KameleoonLogger.debug `CALL: KameleoonClient._getCodeForHash(visitorCode: ${visitorCode}, bucketingCustomDataIndex: ${bucketingCustomDataIndex}, visitorData: ${visitorData})`;
        let codeForHash;
        if (bucketingCustomDataIndex != null) {
            const customData = visitorData === null || visitorData === void 0 ? void 0 : visitorData.customData;
            if (customData) {
                const customDataValue = (_a = customData[bucketingCustomDataIndex]) === null || _a === void 0 ? void 0 : _a.value[0];
                if (customDataValue) {
                    codeForHash = customDataValue;
                }
            }
        }
        if (!codeForHash) {
            codeForHash = this.dataManager.getVisitorIdentifier(visitorCode);
        }
        KameleoonLogger.debug `RETURN: KameleoonClient._getCodeForHash(visitorCode: ${visitorCode}, bucketingCustomDataIndex: ${bucketingCustomDataIndex}, visitorData: ${visitorData}) -> (codeForHash: ${codeForHash})`;
        return codeForHash;
    }
    _refreshDataFileIfStale() {
        return __awaiter(this, void 0, void 0, function* () {
            KameleoonLogger.info('CALL: KameleoonClient.refreshDataFileIfStale()');
            const result = yield this.clientConfiguration.refreshDataFileIfStale();
            KameleoonLogger.info `RETURN: KameleoonClient.refreshDataFileIfStale() -> (result: ${result})`;
            return result.ok && result.data;
        });
    }
}
KameleoonClient.EvaluatedExperiment = class {
    static fromForcedFeatureVariation(defaultVariationKey, forcedFeatureVariation) {
        var _a, _b, _c, _d;
        let varKey = defaultVariationKey;
        if (forcedFeatureVariation.varByExp) {
            varKey = forcedFeatureVariation.varByExp.variationKey;
        }
        else if (((_a = forcedFeatureVariation.rule) === null || _a === void 0 ? void 0 : _a.type) === "EXPERIMENTATION" /* RuleType.EXPERIMENTATION */) {
            varKey = OFF_VARIATION_KEY;
        }
        return {
            variationKey: varKey,
            variationId: ((_b = forcedFeatureVariation.varByExp) === null || _b === void 0 ? void 0 : _b.variationId) || null,
            experimentId: ((_c = forcedFeatureVariation.rule) === null || _c === void 0 ? void 0 : _c.experimentId) || null,
            ruleType: ((_d = forcedFeatureVariation.rule) === null || _d === void 0 ? void 0 : _d.type) || null,
            isSimulated: forcedFeatureVariation.simulated,
        };
    }
    static fromVariationData(variationData) {
        var _a, _b;
        return {
            variationKey: variationData.variationKey,
            variationId: variationData.variationId,
            experimentId: variationData.experimentId,
            ruleType: (_b = (_a = variationData.rule) === null || _a === void 0 ? void 0 : _a.type) !== null && _b !== void 0 ? _b : null,
            isSimulated: false,
        };
    }
    static fromDefaultVariationKey(defaultVariationKey) {
        return {
            variationKey: defaultVariationKey,
            variationId: null,
            experimentId: null,
            ruleType: null,
            isSimulated: false,
        };
    }
};

/**
 * KameleoonUtils - a class containing static Kameleoon helper methods
 * */
class KameleoonUtils {
    /**
     * @method simulateSuccessRequest - a method to simulate a successful request based on request type, primarily used for `IExternalRequester` implementations
     *
     * @param {RequestType} requestType - request type
     * @param {SimulateRequestDataType[RequestType]} data - simulate data type for request
     * */
    static simulateSuccessRequest(requestType, data) {
        switch (requestType) {
            case RequestType.Tracking:
                return new Promise((resolve) => {
                    const response = {
                        status: 204,
                        json: () => new Promise((r) => r(null)),
                        text: () => new Promise((r) => r('')),
                        ok: true,
                    };
                    resolve(response);
                });
            case RequestType.Configuration:
            case RequestType.RemoteData:
                return new Promise((resolve) => {
                    const response = {
                        status: 200,
                        json: () => new Promise((r) => r(data)),
                        text: () => new Promise((r) => r('')),
                        ok: true,
                    };
                    resolve(response);
                });
            default:
                exhaustCheck(requestType);
        }
    }
    /**
     * @method getCookieValue - a method to get a cookie value by key from a cookie string, primarily used for `IExternalVisitorCodeManager` implementations
     *
     * @param {string} cookie - cookie string
     * @param {string} key - cookie key
     * @returns {string | null} cookie value or null if not found
     * */
    static getCookieValue(cookie, key) {
        const pairs = cookie.split('; ');
        const pair = pairs.find((pair) => {
            const [pairKey, pairValue] = pair.split('=');
            return pairKey === key && pairValue !== '';
        });
        if (pair) {
            return pair.split('=')[1];
        }
        return null;
    }
}

var Err = buildExports.Err;
var Ok = buildExports.Ok;
export { ApplicationVersion$1 as ApplicationVersion, Browser$1 as Browser, BrowserType, Conversion$1 as Conversion, Cookie$1 as Cookie, CustomData$1 as CustomData, DataManager, DataStorage, Device$1 as Device, DeviceType, Environment, Err, EventType, GeolocationData, KameleoonClient as KameleoonCore, KameleoonData, KameleoonError, KameleoonException, KameleoonLogger, KameleoonStorageKey, KameleoonUtils, LegalConsent, ListUtilities, LogLevel, Ok, OperatingSystem$1 as OperatingSystem, OperatingSystemType, PageView, Parser, RequestType, SdkLanguageType, StaticData, TrackingStatus, UniqueIdentifier, UrlProvider, UserAgent, Validator, VariableType, VisitorCodeManager };
//# sourceMappingURL=javascript-sdk-core.browser.es.js.map
